(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("aXzbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7faab5f53a414e08$export$2e2bcd8739ae039);

var $iUSsr = parcelRequire("iUSsr");

var $liSU2 = parcelRequire("liSU2");
var $7faab5f53a414e08$var$d = {
    __tags__: {}
};
/**
 * @short Do the js-* fixes
 *
 * It scans for elements into $root that have js-* attributes and link events as required. Known jsfixes:
 *
 * Modules are set just by name, functions with name of module, dot, name of returned object function: mymodule.myfunc.
 *
 * * js-load -- Loads the given module and runs the load method with the current element
 * * js-click -- When click on event loads the modul and runs the function on the form "module.function"
 * * js-popup -- At click, shows a popup with the given data.
 *
 * Examples:
 *
 *   <a href="#_" js-click="register.openDialog">Register</a>
 */ $7faab5f53a414e08$var$d.fix = function($root) {
    if (!$root) $root = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body");
    for(var k in $7faab5f53a414e08$var$d.__tags__){
        var attrsel = "[" + k + "]";
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).merge($root.filter(attrsel), $root.find(attrsel)).not(".template, .template " + attrsel).each(function() {
            var t = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
            $7faab5f53a414e08$var$d.do(k, t, t.attr(k));
        });
    }
};
/**
 * @short Do a jsfix on a given element.
 *
 * Used internallym, but can be used by other jsfixes to force some behaviours.
 */ $7faab5f53a414e08$var$d.do = function(key, $el, data) {
    if ($el.closest(".template,[js-ignore]").length > 0) return;
    if (!data) data = $el.attr(key);
    try {
        $7faab5f53a414e08$var$d.__tags__[key]($el, data);
    } catch (e) {
        console.error(e);
    }
    $el.removeAttr(key);
};
/**
 * @short Register custom made js-tags.
 *
 * Internally it uses this very same register to registry builtin js-tags, but new ones can be registered.
 *
 * @param id Tag id, for example js-click
 * @param feach Funtion to execute on each element that matches, with element as first argument (function($el){ ... })
 *
 * Example of use:
 *
 * 	jsfix.register('js-popup', function($el){
 * 		$el.click(function(){
 * 			require(['dialog'],function(dialog){
 * 				dialog.createOverWindow().load($el.attr('js-popup'))
 * 			})
 * 		})
 * 	})
 *
 * This register a js-popup hook that opens overwindows (lightboxes, dialogs) with the given url.
 *
 * The jsfix is applied inmediatly to the full page, so new entries work inmediatly.
 *
 * @warning The js-* attribute is removed after the first call to the changing function, so if value must be used, it must be stored in a closure properly.
 */ $7faab5f53a414e08$var$d.register = function(id, feach) {
    $7faab5f53a414e08$var$d.__tags__[id] = feach;
    // Apply now.
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[" + id + "]").not(".template [" + id + "]").each(function() {
        $7faab5f53a414e08$var$d.do(id, (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this));
    });
};
/**
 * @name js-load
 * @short Loads a javascript requirejs module.
 */ $7faab5f53a414e08$var$d.register("js-load", function($el) {
    (0, $liSU2.import_by_name)($el.attr("js-load")).then(function(a) {
        a && a.load && a.load($el);
    });
});
/**
 * @name js-load
 * @short On click loads a requirejs module and applies a function (module.function).
 */ $7faab5f53a414e08$var$d.register("js-click", function($el) {
    var jsclick = $el.attr("js-click");
    $el.click(function() {
        var mod = jsclick.split(".")[0];
        var func = jsclick.split(".")[1];
        require([
            mod
        ], function(a) {
            a[func]($el);
        });
    });
});
/**
 * @short Parse the options of a jsfix.
 *
 * @param options The options of the jsfix.
 * @returns The options parsed.
 */ $7faab5f53a414e08$var$d.parse_options = function(options) {
    return Object.fromEntries(options.split(",").map((option)=>{
        return option.split("=");
    }));
};
var $7faab5f53a414e08$export$2e2bcd8739ae039 = $7faab5f53a414e08$var$d;

});
parcelRegister("liSU2", function(module, exports) {

$parcel$export(module.exports, "import_by_name", () => $f825ddf4dc41bb14$export$aaa60f6fe79292ba);
$parcel$export(module.exports, "get_function_by_name", () => $f825ddf4dc41bb14$export$3e1e0705bf3b2d92);
/**
 * @short Import a module by name
 *
 * We need this function to tell parcel to compile and hash and everything
 * these modules. Later are loaded by name, normally in the html, not by path.
 *
 * @param name - The name of the module to import
 * @returns The imported module
 */ 







































const $f825ddf4dc41bb14$export$aaa60f6fe79292ba = async (name)=>{
    switch(name){
        case "ajax_tables":
            return (parcelRequire("6fxwt"));
        case "editable_tables":
            return (parcelRequire("etSgY"));
        case "utils":
            return Promise.resolve((parcelRequire("jSeXR")));
        case "forms":
            return Promise.resolve((parcelRequire("gkdRb")));
        case "form":
            return (parcelRequire("44K3k"));
        case "formsjson":
            return (parcelRequire("8wRys"));
        case "tabs":
            return (parcelRequire("bJzoA"));
        case "index":
            return Promise.resolve((parcelRequire("aZgYx")));
        case "3panels":
            return (parcelRequire("b8FLW"));
        // case "messages":
        //   return import("healthmotiv/tasks/js/messages");
        case "cms":
            return (parcelRequire("bFKtv"));
        case "cmsp":
            return (parcelRequire("8FTRs"));
        case "upload":
            return (parcelRequire("g6BFq"));
        case "users":
            return (parcelRequire("31VAC"));
        case "filtered_file_list":
            return (parcelRequire("31xAa"));
        case "gui":
            return (parcelRequire("irKeD"));
        case "add_message":
            return (parcelRequire("2BpmZ"));
        case "collaborator_filter_list":
            return (parcelRequire("bjjWr"));
        case "jquery.tablesorter":
            return (parcelRequire("i8QZx"));
        case "file_messages":
            return (parcelRequire("cvFmR"));
        case "metrics":
            return (parcelRequire("8Mgw5"));
        case "pain":
            return (parcelRequire("eGPLs"));
        case "cinput":
            return (parcelRequire("7S7xn"));
        case "userform_edit":
            return (parcelRequire("auIWN"));
        case "userforms_reports":
            return (parcelRequire("arqRO"));
        case "userforms":
            return (parcelRequire("bVENP"));
        case "group_permissions":
            return (parcelRequire("fsMsp"));
        case "enduser_register":
            return (parcelRequire("kq28k"));
        case "fastuser":
            return (parcelRequire("5jzUE"));
        case "jquery-ui":
            return Promise.resolve((parcelRequire("aPbgY")));
        case "slider":
            return Promise.resolve((parcelRequire("fTbrq")));
        case "jquery-validation":
            return (parcelRequire("j8WGH"));
        case "messages":
            return (parcelRequire("8g9Fd"));
        case "contracts":
            return (parcelRequire("fMymV"));
        case "graphs":
            return (parcelRequire("1AcZv"));
        case "log_report":
            return (parcelRequire("2UmYW"));
        case "cmd":
            return (parcelRequire("ckrmH"));
        case "pathology":
            return (parcelRequire("8lzGS"));
        case "coronis":
            return Promise.resolve((parcelRequire("etgDw")));
        case "colabjoin":
            return (parcelRequire("gHB2G"));
        case "useraddress":
            return (parcelRequire("gGcX4"));
        default:
            throw new Error(`Unknown module: ${name}`);
    }
};
const $f825ddf4dc41bb14$export$3e1e0705bf3b2d92 = async (mod_name)=>{
    if (!mod_name) // console.error("No module name provided");
    return null;
    if (!mod_name.includes(".")) // console.error("No function name provided");
    return null;
    const [module_name, name] = mod_name.split(".");
    const module = await $f825ddf4dc41bb14$export$aaa60f6fe79292ba(module_name);
    return module[name];
};
window.import_by_name = $f825ddf4dc41bb14$export$aaa60f6fe79292ba;

});
parcelRegister("6fxwt", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("jOKmh")),
    (parcelRequire("lErZQ"))($parcel$resolve("iS3ev"))
]).then(()=>parcelRequire('7xsUb'));

});
parcelRegister("lErZQ", function(module, exports) {
"use strict";

var $2f5wq = parcelRequire("2f5wq");
module.exports = $2f5wq(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2f5wq", function(module, exports) {
"use strict";
var $1a21440d91860188$var$cachedBundles = {};
var $1a21440d91860188$var$cachedPreloads = {};
var $1a21440d91860188$var$cachedPrefetches = {};
function $1a21440d91860188$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1a21440d91860188$var$cachedPreloads;
        case 'prefetch':
            return $1a21440d91860188$var$cachedPrefetches;
        default:
            return $1a21440d91860188$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1a21440d91860188$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("etSgY", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("jOKmh")),
    (parcelRequire("lErZQ"))($parcel$resolve("iS3ev")),
    (parcelRequire("lErZQ"))($parcel$resolve("dFBut"))
]).then(()=>parcelRequire('8xA4Q'));

});

parcelRegister("jSeXR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "requireCSS", () => $e77eab1bdbecfba4$export$b31e6df4c5a8996c);
$parcel$export(module.exports, "array_equals", () => $e77eab1bdbecfba4$export$e3b4f361ea9eee78);
$parcel$export(module.exports, "date_to_string", () => $e77eab1bdbecfba4$export$870b3f94155fff8a);
$parcel$export(module.exports, "fullscreen", () => $e77eab1bdbecfba4$export$af93ab412ae68734);
$parcel$export(module.exports, "html_escape", () => $e77eab1bdbecfba4$export$1fe65ff7dbc29dfb);
$parcel$export(module.exports, "default", () => $e77eab1bdbecfba4$export$2e2bcd8739ae039);

var $iUSsr = parcelRequire("iUSsr");

var $1pryj = parcelRequire("1pryj");
var $e77eab1bdbecfba4$var$loaded = {};
var $e77eab1bdbecfba4$export$b31e6df4c5a8996c = function(css) {
    // From requirejs documentation.
    if ($e77eab1bdbecfba4$var$loaded[css]) return;
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = (0, $1pryj.default).STATIC_URL + "css/" + css + ".css";
    document.getElementsByTagName("body")[0].appendChild(link);
    $e77eab1bdbecfba4$var$loaded[css] = true;
};
var $e77eab1bdbecfba4$export$e3b4f361ea9eee78 = function(a, b) {
    if (a.length != b.length) return false;
    for(var i in a){
        if (a[i] != b[i]) return false;
    }
    return true;
};
var $e77eab1bdbecfba4$export$870b3f94155fff8a = function(date) {
    function pad(number) {
        if (number < 10) return "0" + number;
        return number;
    }
    if (date.getUTCHours() == 0 && date.getUTCMinutes() == 0) return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate());
    else return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + " " + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes());
};
var $e77eab1bdbecfba4$export$af93ab412ae68734 = function(_on, $el) {
    console.log("fullscreen", _on, $el);
    if (_on) {
        var element = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($el)[0];
        if (element.requestFullscreen) element.requestFullscreen();
        else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
        else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
        else if (element.msRequestFullscreen) element.msRequestFullscreen();
    } else {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.msExitFullscreen) document.msExitFullscreen();
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    }
};
var $e77eab1bdbecfba4$export$1fe65ff7dbc29dfb = function(txt) {
    return txt.replace("&", "&amp;").replace("<", "&lt;").replace(">", "&gt;");
};
var $e77eab1bdbecfba4$export$2e2bcd8739ae039 = {
    requireCSS: $e77eab1bdbecfba4$export$b31e6df4c5a8996c,
    array_equals: $e77eab1bdbecfba4$export$e3b4f361ea9eee78,
    date_to_string: $e77eab1bdbecfba4$export$870b3f94155fff8a,
    fullscreen: $e77eab1bdbecfba4$export$af93ab412ae68734,
    html_escape: $e77eab1bdbecfba4$export$1fe65ff7dbc29dfb
};

});
parcelRegister("1pryj", function(module, exports) {

$parcel$export(module.exports, "default", () => $106d7f9aa8b5e489$export$2e2bcd8739ae039);

var $iUSsr = parcelRequire("iUSsr");
const $106d7f9aa8b5e489$export$128fa18b7194ef = document.getElementById("require-main").src;
const $106d7f9aa8b5e489$export$84d6a7807ce2b018 = $106d7f9aa8b5e489$export$128fa18b7194ef.slice(0, $106d7f9aa8b5e489$export$128fa18b7194ef.lastIndexOf("/") - 2);
const $106d7f9aa8b5e489$export$9a771d6906431624 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("meta[http-equiv=content-language]").attr("content");
var $106d7f9aa8b5e489$export$2e2bcd8739ae039 = {
    URL: $106d7f9aa8b5e489$export$128fa18b7194ef,
    STATIC_URL: $106d7f9aa8b5e489$export$84d6a7807ce2b018,
    LANG: $106d7f9aa8b5e489$export$9a771d6906431624
};

});


parcelRegister("gkdRb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fix", () => $be2943487fb11d1e$export$d838837eb5b184e3);
$parcel$export(module.exports, "default", () => $be2943487fb11d1e$export$2e2bcd8739ae039);

var $6gih2 = parcelRequire("6gih2");

var $etgDw = parcelRequire("etgDw");

var $aXzbO = parcelRequire("aXzbO");

var $evyJi = parcelRequire("evyJi");

var $jSeXR = parcelRequire("jSeXR");
parcelRequire("aPbgY");

var $liSU2 = parcelRequire("liSU2");

var $dV0v3 = parcelRequire("dV0v3");
var $be2943487fb11d1e$var$d = {};
$be2943487fb11d1e$var$d.fixDateInputs = function(root) {
    if (root.find("[datepicker],.date").length > 0) {
        (0, $jSeXR.default).requireCSS("../js/main");
        // console.log("fixDateInputs", root);
        try {
            (0, $dV0v3.default)({
                lang: (0, $evyJi.default).languageCode
            });
        } catch (e) {
            console.error("could not set datepicker defaults", e);
        }
        (0, $6gih2.default)(root.find("[datepicker],.date").not(".hasDatepicker,.template")).each(function() {
            var dp = (0, $6gih2.default)(this);
            var opts = {};
            if (dp.attr("method") == "future") opts.minDate = 0;
            dp.datepicker(opts);
        });
    }
};
// d.fixAutocomplete = function (root) {
//   if (root.find("[autocomplete]").not("[autocomplete=off]").length > 0) {
//     $(root.find("[autocomplete]").not("[autocomplete=off]")).each(function () {
//       const $el = $(this);
//       var source = window[$el.attr("autocomplete")];
//       // 					console.log(this)
//       if (!source) {
//         var url = $(this).attr("autocomplete");
//         var depends = $(this).attr("depends");
//         if (depends) {
//           source = function (request, response) {
//             var data = { term: request.term };
//             data[depends] = $("#" + depends).val();
//             $.get(
//               url,
//               data,
//               function (res) {
//                 response(res);
//               },
//               "json"
//             );
//           };
//         } else source = url;
//       }
//       // 					console.log(source)
//       $el
//         .autocomplete({
//           source: source,
//           minLength: 0,
//           close: window[$el.attr("onchange")],
//         })
//         .attr("autocomplete", "off");
//       if ($el.hasClass("autopop")) {
//         $el.bind("focus", function () {
//           $el.autocomplete("search");
//         });
//       }
//     });
//   }
// };
$be2943487fb11d1e$var$d.fixTimeInputs = function(root) {
    (0, $6gih2.default)(root.find("input.time")).each(function() {
        const $el = (0, $6gih2.default)(this);
        var sel = (0, $6gih2.default)("<select>");
        var attrs = [
            "id",
            "name",
            "class"
        ];
        for(var i in attrs){
            var a = attrs[i];
            sel.attr(a, $el.attr(a));
        }
        var zero_pad_2 = function(n) {
            var nn = "0" + n;
            nn = nn.substr(nn.length - 2);
            return nn;
        };
        var time_to_min = function(hhmm) {
            var HM = v.split(":");
            var HH, MM;
            if (HM[0][0] == "0") HH = Number(HM[0][1]);
            else HH = Number(HM[0]);
            if (HM[1][0] == "0") MM = Number(HM[1][1]);
            else MM = Number(HM[1]);
            return HH * 60 + MM;
        };
        var min_to_time = function(vmin) {
            return zero_pad_2(Math.floor(vmin / 60)) + ":" + zero_pad_2(vmin % 60);
        };
        for(var h = 0; h < 24; h++){
            var hh = zero_pad_2(h);
            for(var m = 0; m < 60; m += 15){
                var mm = zero_pad_2(m);
                var hhmm = hh + ":" + mm;
                sel.append((0, $6gih2.default)("<option>").val(hhmm).text(hhmm));
            }
        }
        var v = $el.val() || "09:00";
        var vmin = time_to_min(v);
        vmin = Math.round(vmin / 15) * 15;
        v = min_to_time(vmin);
        $el.replaceWith(sel);
        sel.val(v);
    });
};
$be2943487fb11d1e$var$d.fixRequired = function(root) {
    if (root.find(".required").length) {
        // dynamic load validate only when needed.
        (0, $liSU2.import_by_name)("jquery-validation").then(function() {
            root.find("form").has(".required").each(function() {
                const $el = (0, $6gih2.default)(this);
                console.log("validate", $el);
                const rules = $el.find(".required").map(function() {
                    return {
                        [(0, $6gih2.default)(this).attr("name")]: {
                            required: true
                        }
                    };
                });
                $el.validate({
                    rules: rules
                });
            });
            // validator translations from http://ajax.aspnetcdn.com/ajax/jquery.validate/1.9/localization/messages_fr.js
            if ((0, $evyJi.default).languageCode == "es") /*
         * Translated default messages for the jQuery validation plugin.
         * Locale: ES
         */ jQuery.extend(jQuery.validator.messages, {
                required: "Este campo es obligatorio.",
                remote: "Por favor, rellena este campo.",
                email: "Por favor, escribe una direcci\xf3n de correo v\xe1lida",
                url: "Por favor, escribe una URL v\xe1lida.",
                date: "Por favor, escribe una fecha v\xe1lida.",
                dateISO: "Por favor, escribe una fecha (ISO) v\xe1lida.",
                number: "Por favor, escribe un n\xfamero entero v\xe1lido.",
                digits: "Por favor, escribe s\xf3lo d\xedgitos.",
                creditcard: "Por favor, escribe un n\xfamero de tarjeta v\xe1lido.",
                equalTo: "Por favor, escribe el mismo valor de nuevo.",
                accept: "Por favor, escribe un valor con una extensi\xf3n aceptada.",
                maxlength: jQuery.validator.format("Por favor, no escribas m\xe1s de {0} caracteres."),
                minlength: jQuery.validator.format("Por favor, no escribas menos de {0} caracteres."),
                rangelength: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
                range: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1}."),
                max: jQuery.validator.format("Por favor, escribe un valor menor o igual a {0}."),
                min: jQuery.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
            });
            if ((0, $evyJi.default).languageCode == "fr") /*
         * Translated default messages for the jQuery validation plugin.
         * Locale: FR
         */ jQuery.extend(jQuery.validator.messages, {
                required: "Ce champ est requis.",
                remote: "Veuillez remplir ce champ pour continuer.",
                email: "Veuillez entrer une adresse email valide.",
                url: "Veuillez entrer une URL valide.",
                date: "Veuillez entrer une date valide.",
                dateISO: "Veuillez entrer une date valide (ISO).",
                number: "Veuillez entrer un nombre valide.",
                digits: "Veuillez entrer (seulement) une valeur num\xe9rique.",
                creditcard: "Veuillez entrer un num\xe9ro de carte de cr\xe9dit valide.",
                equalTo: "Veuillez entrer une nouvelle fois la m\xeame valeur.",
                accept: "Veuillez entrer une valeur avec une extension valide.",
                maxlength: jQuery.validator.format("Veuillez ne pas entrer plus de {0} caract\xe8res."),
                minlength: jQuery.validator.format("Veuillez entrer au moins {0} caract\xe8res."),
                rangelength: jQuery.validator.format("Veuillez entrer entre {0} et {1} caract\xe8res."),
                range: jQuery.validator.format("Veuillez entrer une valeur entre {0} et {1}."),
                max: jQuery.validator.format("Veuillez entrer une valeur inf\xe9rieure ou \xe9gale \xe0 {0}."),
                min: jQuery.validator.format("Veuillez entrer une valeur sup\xe9rieure ou \xe9gale \xe0 {0}.")
            });
        });
        root.find(".required").each(function() {
            const $el = (0, $6gih2.default)(this);
            var prev;
            var label = $el.attr("label");
            if (label) prev = (0, $etgDw.default).find($el, label);
            else prev = $el.prev();
            if (prev.find("i.required").length == 0) prev.append('&nbsp;<i class="required nonimportant">(' + (0, $evyJi.default)("Required") + ")</i>");
        });
    }
};
$be2943487fb11d1e$var$d.fix = function(root) {
    if (!root) root = (0, $6gih2.default)("body");
    $be2943487fb11d1e$var$d.fixDateInputs(root);
    // d.fixAutocomplete(root);
    $be2943487fb11d1e$var$d.fixRequired(root);
    $be2943487fb11d1e$var$d.fixTimeInputs(root);
};
(0, $etgDw.fix_register)($be2943487fb11d1e$var$d.fix);
function $be2943487fb11d1e$export$d838837eb5b184e3(root) {
    $be2943487fb11d1e$var$d.fix(root);
}
(0, $aXzbO.default).register("js-checked-show", function($el, sel) {
    var check_if_show = function() {
        if ($el.prop("checked")) (0, $etgDw.default).find($el, sel).show();
        else (0, $etgDw.default).find($el, sel).hide();
    };
    // Not on $el, as this notifies only when it gets active, must check all other mates
    if ($el.attr("type") == "radio") // Tell others in group they are no longer.
    (0, $6gih2.default)("[name=" + $el.attr("name") + "]").change(check_if_show);
    else $el.change(check_if_show);
    check_if_show();
});
(0, $aXzbO.default).register("js-select-val", function($el, val) {
    if (!$el.val()) $el.val(val);
});
(0, $aXzbO.default).register("js-select", function($el, val) {
    $el.val(val);
});
(0, $aXzbO.default).register("js-load-on-select", function($el, sel) {
    $el.change(function() {
        var url = $el.find(":selected").attr("url");
        if (url) var area = (0, $etgDw.default).find($el, sel);
        area.load(url, function() {
            (0, $etgDw.default).fix(area);
        });
    });
});
(0, $aXzbO.default).register("js-show-when-selected", function($el, val) {
    var options = (0, $6gih2.default)(val);
    var show_options = (0, $6gih2.default).makeArray(options.map(function() {
        return (0, $6gih2.default)(this).val();
    }));
    var parent = options.parent();
    var check_if_show = function() {
        console.log("test");
        if (show_options.indexOf(parent.val()) >= 0) $el.show();
        else $el.hide();
    };
    check_if_show();
    parent.change(check_if_show);
});
/**
 * @name js-submit-reload
 * @short When this form (or form child) is posted, the $el itself is replaced with the response to this post.
 *
 * It is usefull to for exmaple use non-ajax forms that automatically become ajax forms.
 *
 * @param toreplace If any, the element to replace on submit. If not, the same el.
 */ (0, $aXzbO.default).register("js-submit-reload", function($el) {
    var $toreplace = $el;
    if ($el.attr("js-submit-reload")) $toreplace = (0, $6gih2.default)($el.attr("js-submit-reload"));
    (0, $6gih2.default).merge($el.filter("form"), $el.find("form")).submit(function(ev) {
        ev.preventDefault();
        var $form = (0, $6gih2.default)(this);
        var submit;
        if ($form.attr("method") == "POST") submit = (0, $6gih2.default).post;
        else submit = (0, $6gih2.default).get;
        submit($form.attr("action"), $form.serialize() + "&format=ajax", function(data) {
            var $nel = (0, $6gih2.default)(data);
            $toreplace.replaceWith($nel);
            $be2943487fb11d1e$var$d.fix($nel);
            (0, $liSU2.import_by_name)("coronis").then(function(coronis) {
                coronis.fix($nel);
            });
        }, "html");
    });
});
/**
 * @short Submits the form, and uses the json response to fill another form
 *
 * For example to use a select to allow autocomplete of another form.
 *
 * @param js-submit-json-fill A selector to the form to fill.
 *
 * Each key for the returned dict is the name of the input to fill.
 *
 * Can also fill arrays for select options, with each element a dict of {val:..., text:...}
 */ (0, $aXzbO.default).register("js-submit-json-fill", function($el, sel) {
    var $form = (0, $6gih2.default)(sel);
    $el.submit(function(ev) {
        ev.preventDefault();
        var submit;
        if ($el.attr("method") == "POST") submit = (0, $6gih2.default).post;
        else submit = (0, $6gih2.default).get;
        var fill = function($form, data) {
            if (data instanceof Array) {
                // This is for selects
                $form.html("");
                data.forEach(function() {
                    const v = this;
                    $form.append((0, $6gih2.default)("<option>").val(v.val).text(v.text));
                });
            } else {
                // Other objects.
                var k;
                for(k in data)$form.find("[name=" + k + "]").val(data[k]);
            }
        };
        submit($el.attr("action"), $el.serialize() + "&format=json", function(data) {
            fill($form, data);
        }, "json");
    });
});
/**
 * @name js-toggle-show
 * @short Toggles the selected element, on click of this element
 */ (0, $aXzbO.default).register("js-toggle-show", function($el, totoggle) {
    var update = function() {
        var $toto = (0, $etgDw.default).find($el, totoggle);
        if ($el.filter("input:checked").length || $el.find("input:checked").length) //console.log("show %o %o", $el[0].id, $toto[0])
        $toto.show();
        else //console.log("hide %o %o", $el[0].id, $toto[0])
        $toto.hide();
    };
    $el.change(update);
    update();
});
/**
 * @name js-copy-on-change
 */ (0, $aXzbO.default).register("js-copy-on-change", function($el, data) {
    $el.change(function() {
        (0, $6gih2.default)(data).val($el.val()).change();
    });
});
/**
 * @name js-submit-async
 * @short Submits a form asynchronously, and writes a success or failure tag above the submit button.
 *
 * On both cases the content of the result is shown, but class changes from success to failure.
 */ (0, $aXzbO.default).register("js-submit-async", function($el, data) {
    $el.submit(function(ev) {
        ev.preventDefault();
        if ($el.find(".required.error").not("[js-required-if-visible]:hidden .required.error").length > 0) {
            var msg = (0, $6gih2.default)('<div class="failure">').text((0, $evyJi.default)("There are errors on the form. Check and try again."));
            msg.delay(3000).fadeOut().queue(function() {
                msg.remove();
            });
            $el.find("[type=submit]").before(msg);
            return;
        }
        var submit = function(url, form, cb) {
            var formData = new FormData(form[0]);
            console.log(formData);
            var aj = (0, $6gih2.default).ajax({
                url: url,
                type: "POST",
                data: formData,
                success: cb,
                contentType: false,
                processData: false
            });
            return aj;
        };
        var sending = (0, $6gih2.default)('<div class="success">').text((0, $evyJi.default)("Sending"));
        $el.find("[type=submit]").before(sending);
        submit($el.attr("action"), $el, function(data) {
            if (data.slice(0, 9) == "redirect:") {
                window.location = data.slice(9);
                return;
            }
            sending.remove();
            var msg = (0, $6gih2.default)('<div class="success">').html(data);
            msg.delay(3000).fadeOut().queue(function() {
                msg.remove();
            });
            $el.find("[type=submit]").before(msg);
        }).error(function(ev) {
            sending.remove();
            var data = ev.responseText;
            var msg = (0, $6gih2.default)('<div class="failure">').text(data);
            msg.delay(3000).fadeOut().queue(function() {
                msg.remove();
            });
            $el.find("[type=submit]").before(msg);
        });
    });
});
/**
 * @short Loads the image from the form, and set it into a img
 */ (0, $aXzbO.default).register("js-file-to-img", function($el, sel) {
    $el.on("change", function(ev) {
        var fr = new FileReader();
        fr.onload = function() {
            (0, $6gih2.default)(sel).attr("src", fr.result);
        };
        fr.readAsDataURL($el[0].files[0]);
    });
});
(0, $aXzbO.default).register("js-dup-and-clear-on-click", function($el, sel) {
    $el.click(function() {
        var $cl = (0, $etgDw.default).find($el, sel);
        var nel = $cl.clone();
        nel.removeClass("template");
        $cl.parent().append(nel);
        nel.find("input").val("");
        nel.find(".hasDatepicker").removeClass("hasDatepicker").removeAttr("id");
        (0, $etgDw.default).fix(nel);
    });
});
/**
 * @short Show an element only when this element is selected. When unselected, hide.
 */ (0, $aXzbO.default).register("js-selected-show", function($el, sel) {
    var toshow = (0, $etgDw.default).find($el, sel);
    var select = (0, $6gih2.default)($el.parent());
    var option = $el.val();
    var update = function() {
        if (select.val() == option) toshow.show();
        else toshow.hide();
    };
    select.change(update);
    update();
});
/**
 * @short For checkboxes that share a checkbox group, only one can be selected.
 *
 * The group mark is an element, normally a common parent, but not necesarily.
 */ (0, $aXzbO.default).register("js-checkbox-group", function($el, sel) {
    // Add the element to the group.
    var $p = (0, $etgDw.default).find($el, sel);
    var gr = $p.data("js-checkbox-group") || [];
    gr.push($el);
    $p.data("js-checkbox-group", gr);
    // When clicked, turn them all off, me on.
    $el.click(function() {
        (0, $6gih2.default)($p.data("js-checkbox-group")).each(function() {
            const $el = (0, $6gih2.default)(this);
            $el.prop("checked", false).change();
        });
        $el.prop("checked", true).change();
    });
});
/**
 * @short Shows a message before leaving the page if any input has changed on the $el.
 *
 * If reset_sel selected element is clicked, the change flag is reset, so it can exit page normally.
 */ (0, $aXzbO.default).register("js-confirm-exit-after-edit", function($el, reset_sel) {
    var changed = false;
    var modified = function() {
        changed = true;
    };
    var reset = function() {
        changed = false;
    };
    $el.find("input, select, textarea").on("keyup", modified);
    (0, $6gih2.default)(reset_sel).click(reset);
    (0, $6gih2.default)(window).on("beforeunload", (ev)=>{
        if (changed) return (0, $evyJi.default)("There are unsaved changes. Are you sure you want to leve this page?");
    });
});
/**
 * @short Hide the children of sel that do not comply with filter=$el.val()
 *
 */ (0, $aXzbO.default).register("js-select-filter", function($el, sel) {
    var $tohide;
    var $sel;
    if (sel.indexOf("|") >= 0) {
        var tohide = sel.split("|")[0];
        $sel = (0, $etgDw.default).find($el, tohide);
        sel = sel.split("|")[1];
        $tohide = (0, $etgDw.default).find($el, sel);
    } else {
        $sel = (0, $etgDw.default).find($el, sel);
        $tohide = $sel;
    }
    var $maybehide = $sel.find("[filter]");
    var update = function() {
        $tohide.show();
        var val = $el.val();
        var oval = $maybehide.parent().val() || $maybehide.parent().attr("jvalue"); // Other value, for optional selector.
        // Hide everything, then show whats visible.
        $maybehide.hide();
        var $shown = $maybehide.filter('[filter="' + val + '"]').show();
        if ($shown.length == 0) $tohide.hide();
        // If previous selected, or default is visible, select it, else select none
        if ($shown.filter("[value=" + oval + "]").length != 0) $maybehide.parent().val(oval);
        else $maybehide.parent().val("");
        $maybehide.parent().change();
    };
    update();
    $el.change(update);
});
/**
 * @short When slected whis radio, set the value into the givel selector
 */ (0, $aXzbO.default).register("js-radio-for", function($el, sel) {
    var $for = (0, $etgDw.default).find($el, sel);
    $el.click(function() {
        $for.val($el.val());
    });
    $for.change(function() {
        if ($for.val() == $el.val()) $el.prop("checked", true).change();
    });
});
(0, $aXzbO.default).register("js-search", function($el, lis) {
    var contains = function(li, txt) {
        var tt = txt.split(" ");
        var i;
        for(i = 0; i < tt.length; i++){
            if (!tt[i]) continue;
            if (li.text().toLowerCase().indexOf(tt[i]) <= 0) return false;
        }
        return true;
    };
    var search = function() {
        var txt = $el.val().toLowerCase();
        var $lis = (0, $6gih2.default)(lis);
        $lis.each(function() {
            const $el = (0, $6gih2.default)(this);
            if (contains($el, txt)) $el.show();
            else $el.hide();
        });
        if ($lis.find(".selected:visible").length == 0) (0, $6gih2.default)($lis.find("a:visible:first")[0]).click();
    };
    $el.change(search);
    $el.parent().find(".js-search").click(search);
});
(0, $aXzbO.default).register("js-checkbox-selects", function($el, sel) {
    var $sel = (0, $etgDw.default).find($el, sel);
    var update = function() {
        console.log($el.prop("checked"));
        if ($el.prop("checked")) $sel.addClass("selected");
        else $sel.removeClass("selected");
    };
    $el.change(update);
    update();
});
(0, $aXzbO.default).register("js-confirm-before-submit", function($form, text) {
    $form.submit(function(ev) {
        if (!confirm(text)) ev.preventDefault();
    });
});
var $be2943487fb11d1e$export$2e2bcd8739ae039 = $be2943487fb11d1e$var$d;

});
parcelRegister("6gih2", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f2697b020b8350$export$2e2bcd8739ae039);

var $iUSsr = parcelRequire("iUSsr");
window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
var $48f2697b020b8350$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));

});

parcelRegister("etgDw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fix_register", () => fix_register);
$parcel$export(module.exports, "default", () => $a890adcb19f151d5$export$2e2bcd8739ae039);

var $iUSsr = parcelRequire("iUSsr");
parcelRequire("ixUnv");
var $1njYz = parcelRequire("1njYz");

var $aXzbO = parcelRequire("aXzbO");

var $liSU2 = parcelRequire("liSU2");


var __fix_f__ = [
    function($root) {
        // Make it idempotent
        if ($root.data("has-base-fixes")) return;
        $root.data("has-base-fixes", true);
        // Ajax tables
        var fixAjaxTables = function() {
            if ($root.find(".listing").length) (parcelRequire("i8QZx")).then(function() {
                $root.find(".listing").tablesorter({
                    sortlist: [
                        0
                    ],
                    widgets: [
                        "zebra"
                    ]
                });
            });
            if ($root.find(".ajax_list").length) (parcelRequire("6fxwt")).then(function() {
                $root.find("div.ajax_list").asAjaxTable();
            });
        };
        var fixCurrentLink = function() {
            var currentUrl = window.location.pathname;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("a").each(function() {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("href") == currentUrl) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass("active");
            });
        };
        fixCurrentLink();
        if ($root.find(".listing,.ajax_list").length) fixAjaxTables();
        if ($root.find("form").length) (0, $liSU2.import_by_name)("forms").then(function(forms) {
            forms.fix($root);
        });
        $root.find("[onenter]").each(function() {
            var t = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
            f = t.attr("onenter");
            t.attr("onenter", "");
            t.keypress(function(ev) {
                if (ev.which == 10 || ev.which == 13) eval(f);
            });
        });
    },
    function($root) {
        /// Load all required at require tags.
        $root.find("require").each(function() {
            var required = (0, $1njYz.default)((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).text().split(",")).map(function(x) {
                return x.replace(/^\s+|\s+$/g, ""); // trim
            }).map(function(x) {
                (0, $liSU2.import_by_name)(x).then(function() {});
            });
        });
        $root.find("css").each(function() {
            var required = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).text().split(",");
            (0, $liSU2.import_by_name)("utils").then(function(utils) {
                utils.requireCSS(required);
            });
        });
    }
];
/**
 * @short Do fixes on loaded snippets. Use as require('coronis').fix($myjqueryelarray)
 *
 * @param $root is a jquery element array of new elements.
 */ var fix = function($root) {
    if (!$root) $root = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(__fix_f__).each(function() {
        this($root);
    });
};
var fix_register = function(f1) {
    __fix_f__.push(f1);
    f1((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body"));
};
/**
 * @short jQuery find based on an element, but allow to search on parents too.
 *
 * To search on parent, start it with ::parent.
 */ var find = function($el, sel) {
    if (!sel) return (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))([]);
    var sfind_rel = function($el, sel) {
        if (!sel) return $el;
        if (sel.slice(0, 8) == "::parent") return sfind_rel($el.parent(), (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).trim(sel.slice(8)));
        return $el.find(sel);
    };
    var sfind = function($el, sel) {
        if (sel.slice(0, 8) == "::parent") return sfind_rel($el, sel);
        if (sel.slice(0, 2) == "..") {
            var end = sel.indexOf("..", 1);
            var csel = sel.slice(2, end);
            sel = sel.slice(end + 2);
            return sfind_rel($el.closest(csel), sel);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(sel);
    };
    if (sel.indexOf(",") >= 0) {
        var ret = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(sel.split(",")).map(function(i, ssel) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).merge(ret, sfind($el, (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).trim(ssel)));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(ret);
    }
    return sfind($el, sel);
};
var nid_seq = 1;
var ensureId = function($el) {
    if ($el.attr("id")) return;
    var nid = "crns-" + nid_seq;
    nid_seq += 1;
    $el.attr("id", nid);
};
/**
 * @name js-submit-on-change
 * @short do an automatic post of this form when this element changes
 */ (0, $aXzbO.default).register("js-submit-on-change", function($el, data) {
    var post; // Depends on data
    if (data) post = function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(data).submit();
    };
    else post = function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($el[0].form).submit();
    };
    $el.change(post);
});
fix_register((0, $aXzbO.default).fix);
/**
 * @short For the given node and childs, replace id substrings.
 */ var replaceIds = function(node, oldid, newid) {
    for(var n in node.childNodes){
        var nd = node.childNodes[n];
        var id = typeof nd.id;
        var name = typeof nd.name;
        if (id != "undefined" || name != "undefined") replaceIds(nd, oldid, newid);
    }
    if (node.id) node.id = node.id.replace(oldid, newid);
    if (node.name) node.name = node.name.replace(oldid, newid);
};
fix();
var coronis = {
    fix: fix,
    fix_register: fix_register,
    find: find,
    ensureId: ensureId,
    replaceIds: replaceIds
};
var $a890adcb19f151d5$export$2e2bcd8739ae039 = coronis;

});
parcelRegister("ixUnv", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("1njYz")).default);
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $1njYz = parcelRequire("1njYz");

var $gdauW = parcelRequire("gdauW");
$parcel$exportWildcard(module.exports, $gdauW);

});
parcelRegister("1njYz", function(module, exports) {

$parcel$export(module.exports, "default", () => $10076f3d454fd4ad$export$2e2bcd8739ae039);
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("gdauW");
var $63AJi = parcelRequire("63AJi");
var $gdauW = parcelRequire("gdauW");
// Add all of the Underscore functions to the wrapper object.
var $10076f3d454fd4ad$var$_ = (0, $63AJi.default)($gdauW);
// Legacy Node.js API.
$10076f3d454fd4ad$var$_._ = $10076f3d454fd4ad$var$_;
var // Export the Underscore API.
$10076f3d454fd4ad$export$2e2bcd8739ae039 = $10076f3d454fd4ad$var$_;

});
parcelRegister("gdauW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", () => (parcelRequire("0fogG")).VERSION);
$parcel$export(module.exports, "restArguments", () => (parcelRequire("9b4UF")).default);
$parcel$export(module.exports, "isObject", () => (parcelRequire("ip1qP")).default);
$parcel$export(module.exports, "isNull", () => (parcelRequire("9NTkq")).default);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("1ryv3")).default);
$parcel$export(module.exports, "isBoolean", () => (parcelRequire("7Rbr4")).default);
$parcel$export(module.exports, "isElement", () => (parcelRequire("c47lv")).default);
$parcel$export(module.exports, "isString", () => (parcelRequire("eeGBh")).default);
$parcel$export(module.exports, "isNumber", () => (parcelRequire("cu3St")).default);
$parcel$export(module.exports, "isDate", () => (parcelRequire("8n4Bn")).default);
$parcel$export(module.exports, "isRegExp", () => (parcelRequire("fnXE0")).default);
$parcel$export(module.exports, "isError", () => (parcelRequire("7MFTz")).default);
$parcel$export(module.exports, "isSymbol", () => (parcelRequire("ao4q3")).default);
$parcel$export(module.exports, "isArrayBuffer", () => (parcelRequire("4he2i")).default);
$parcel$export(module.exports, "isDataView", () => (parcelRequire("hGEiU")).default);
$parcel$export(module.exports, "isArray", () => (parcelRequire("hux9f")).default);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("atLoF")).default);
$parcel$export(module.exports, "isArguments", () => (parcelRequire("kO3hQ")).default);
$parcel$export(module.exports, "isFinite", () => (parcelRequire("jwwdD")).default);
$parcel$export(module.exports, "isNaN", () => (parcelRequire("5b3jG")).default);
$parcel$export(module.exports, "isTypedArray", () => (parcelRequire("30QxN")).default);
$parcel$export(module.exports, "isEmpty", () => (parcelRequire("f7bBZ")).default);
$parcel$export(module.exports, "isMatch", () => (parcelRequire("IgwY6")).default);
$parcel$export(module.exports, "isEqual", () => (parcelRequire("4vRze")).default);
$parcel$export(module.exports, "isMap", () => (parcelRequire("cPfVH")).default);
$parcel$export(module.exports, "isWeakMap", () => (parcelRequire("eyJSb")).default);
$parcel$export(module.exports, "isSet", () => (parcelRequire("9xU3y")).default);
$parcel$export(module.exports, "isWeakSet", () => (parcelRequire("krkyR")).default);
$parcel$export(module.exports, "keys", () => (parcelRequire("1rFsw")).default);
$parcel$export(module.exports, "allKeys", () => (parcelRequire("aJjO9")).default);
$parcel$export(module.exports, "values", () => (parcelRequire("a1tWb")).default);
$parcel$export(module.exports, "pairs", () => (parcelRequire("jtpc7")).default);
$parcel$export(module.exports, "invert", () => (parcelRequire("hGaFi")).default);
$parcel$export(module.exports, "functions", () => (parcelRequire("gmuuZ")).default);
$parcel$export(module.exports, "methods", () => (parcelRequire("gmuuZ")).default);
$parcel$export(module.exports, "extend", () => (parcelRequire("fFuwj")).default);
$parcel$export(module.exports, "extendOwn", () => (parcelRequire("x06cO")).default);
$parcel$export(module.exports, "assign", () => (parcelRequire("x06cO")).default);
$parcel$export(module.exports, "defaults", () => (parcelRequire("17Hnr")).default);
$parcel$export(module.exports, "create", () => (parcelRequire("gNib3")).default);
$parcel$export(module.exports, "clone", () => (parcelRequire("eENfB")).default);
$parcel$export(module.exports, "tap", () => (parcelRequire("6L4iO")).default);
$parcel$export(module.exports, "get", () => (parcelRequire("jkJ9i")).default);
$parcel$export(module.exports, "has", () => (parcelRequire("83NPx")).default);
$parcel$export(module.exports, "mapObject", () => (parcelRequire("gejmE")).default);
$parcel$export(module.exports, "identity", () => (parcelRequire("b3btC")).default);
$parcel$export(module.exports, "constant", () => (parcelRequire("6MFBG")).default);
$parcel$export(module.exports, "noop", () => (parcelRequire("jssPN")).default);
$parcel$export(module.exports, "toPath", () => (parcelRequire("aCdeG")).default);
$parcel$export(module.exports, "property", () => (parcelRequire("7gghp")).default);
$parcel$export(module.exports, "propertyOf", () => (parcelRequire("8HP4K")).default);
$parcel$export(module.exports, "matcher", () => (parcelRequire("gyNYk")).default);
$parcel$export(module.exports, "matches", () => (parcelRequire("gyNYk")).default);
$parcel$export(module.exports, "times", () => (parcelRequire("7UdJN")).default);
$parcel$export(module.exports, "random", () => (parcelRequire("97fU6")).default);
$parcel$export(module.exports, "now", () => (parcelRequire("1Yy3o")).default);
$parcel$export(module.exports, "escape", () => (parcelRequire("kH9tx")).default);
$parcel$export(module.exports, "unescape", () => (parcelRequire("jEiAQ")).default);
$parcel$export(module.exports, "templateSettings", () => (parcelRequire("eAyrH")).default);
$parcel$export(module.exports, "template", () => (parcelRequire("7m1QE")).default);
$parcel$export(module.exports, "result", () => (parcelRequire("dVtip")).default);
$parcel$export(module.exports, "uniqueId", () => (parcelRequire("brpOv")).default);
$parcel$export(module.exports, "chain", () => (parcelRequire("jc1kq")).default);
$parcel$export(module.exports, "iteratee", () => (parcelRequire("6jb4b")).default);
$parcel$export(module.exports, "partial", () => (parcelRequire("lSJhi")).default);
$parcel$export(module.exports, "bind", () => (parcelRequire("iELwm")).default);
$parcel$export(module.exports, "bindAll", () => (parcelRequire("8OoKw")).default);
$parcel$export(module.exports, "memoize", () => (parcelRequire("7ncWx")).default);
$parcel$export(module.exports, "delay", () => (parcelRequire("3RwiW")).default);
$parcel$export(module.exports, "defer", () => (parcelRequire("jA0Ja")).default);
$parcel$export(module.exports, "throttle", () => (parcelRequire("l5420")).default);
$parcel$export(module.exports, "debounce", () => (parcelRequire("5cfcY")).default);
$parcel$export(module.exports, "wrap", () => (parcelRequire("2rRDv")).default);
$parcel$export(module.exports, "negate", () => (parcelRequire("9yzrH")).default);
$parcel$export(module.exports, "compose", () => (parcelRequire("h0nlN")).default);
$parcel$export(module.exports, "after", () => (parcelRequire("hAYIU")).default);
$parcel$export(module.exports, "before", () => (parcelRequire("7G3Xv")).default);
$parcel$export(module.exports, "once", () => (parcelRequire("6D6Wy")).default);
$parcel$export(module.exports, "findKey", () => (parcelRequire("4sQsY")).default);
$parcel$export(module.exports, "findIndex", () => (parcelRequire("7H7To")).default);
$parcel$export(module.exports, "findLastIndex", () => (parcelRequire("3RRBL")).default);
$parcel$export(module.exports, "sortedIndex", () => (parcelRequire("7imeo")).default);
$parcel$export(module.exports, "indexOf", () => (parcelRequire("aMe0b")).default);
$parcel$export(module.exports, "lastIndexOf", () => (parcelRequire("9CMoH")).default);
$parcel$export(module.exports, "find", () => (parcelRequire("l0a5h")).default);
$parcel$export(module.exports, "detect", () => (parcelRequire("l0a5h")).default);
$parcel$export(module.exports, "findWhere", () => (parcelRequire("6oaDx")).default);
$parcel$export(module.exports, "each", () => (parcelRequire("k08ZD")).default);
$parcel$export(module.exports, "forEach", () => (parcelRequire("k08ZD")).default);
$parcel$export(module.exports, "map", () => (parcelRequire("e1hz7")).default);
$parcel$export(module.exports, "collect", () => (parcelRequire("e1hz7")).default);
$parcel$export(module.exports, "reduce", () => (parcelRequire("5ztlX")).default);
$parcel$export(module.exports, "foldl", () => (parcelRequire("5ztlX")).default);
$parcel$export(module.exports, "inject", () => (parcelRequire("5ztlX")).default);
$parcel$export(module.exports, "reduceRight", () => (parcelRequire("3h2GT")).default);
$parcel$export(module.exports, "foldr", () => (parcelRequire("3h2GT")).default);
$parcel$export(module.exports, "filter", () => (parcelRequire("2mDFn")).default);
$parcel$export(module.exports, "select", () => (parcelRequire("2mDFn")).default);
$parcel$export(module.exports, "reject", () => (parcelRequire("dNa3T")).default);
$parcel$export(module.exports, "every", () => (parcelRequire("jgJEX")).default);
$parcel$export(module.exports, "all", () => (parcelRequire("jgJEX")).default);
$parcel$export(module.exports, "some", () => (parcelRequire("9A89L")).default);
$parcel$export(module.exports, "any", () => (parcelRequire("9A89L")).default);
$parcel$export(module.exports, "contains", () => (parcelRequire("gKeEm")).default);
$parcel$export(module.exports, "includes", () => (parcelRequire("gKeEm")).default);
$parcel$export(module.exports, "include", () => (parcelRequire("gKeEm")).default);
$parcel$export(module.exports, "invoke", () => (parcelRequire("dCJW1")).default);
$parcel$export(module.exports, "pluck", () => (parcelRequire("5KyAs")).default);
$parcel$export(module.exports, "where", () => (parcelRequire("2X6oB")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("gVpd2")).default);
$parcel$export(module.exports, "min", () => (parcelRequire("VITl0")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("dkK7j")).default);
$parcel$export(module.exports, "sample", () => (parcelRequire("a2b2M")).default);
$parcel$export(module.exports, "sortBy", () => (parcelRequire("gAiTl")).default);
$parcel$export(module.exports, "groupBy", () => (parcelRequire("bdh5G")).default);
$parcel$export(module.exports, "indexBy", () => (parcelRequire("bSlRz")).default);
$parcel$export(module.exports, "countBy", () => (parcelRequire("5N48u")).default);
$parcel$export(module.exports, "partition", () => (parcelRequire("4TODu")).default);
$parcel$export(module.exports, "toArray", () => (parcelRequire("cAT6M")).default);
$parcel$export(module.exports, "size", () => (parcelRequire("7B8AD")).default);
$parcel$export(module.exports, "pick", () => (parcelRequire("9I9nf")).default);
$parcel$export(module.exports, "omit", () => (parcelRequire("4QNAj")).default);
$parcel$export(module.exports, "first", () => (parcelRequire("5wOr9")).default);
$parcel$export(module.exports, "head", () => (parcelRequire("5wOr9")).default);
$parcel$export(module.exports, "take", () => (parcelRequire("5wOr9")).default);
$parcel$export(module.exports, "initial", () => (parcelRequire("5g2xy")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("1VINE")).default);
$parcel$export(module.exports, "rest", () => (parcelRequire("gai4j")).default);
$parcel$export(module.exports, "tail", () => (parcelRequire("gai4j")).default);
$parcel$export(module.exports, "drop", () => (parcelRequire("gai4j")).default);
$parcel$export(module.exports, "compact", () => (parcelRequire("xDQNi")).default);
$parcel$export(module.exports, "flatten", () => (parcelRequire("aBPI4")).default);
$parcel$export(module.exports, "without", () => (parcelRequire("4iX6H")).default);
$parcel$export(module.exports, "uniq", () => (parcelRequire("25WHZ")).default);
$parcel$export(module.exports, "unique", () => (parcelRequire("25WHZ")).default);
$parcel$export(module.exports, "union", () => (parcelRequire("8vDfc")).default);
$parcel$export(module.exports, "intersection", () => (parcelRequire("cjA2Z")).default);
$parcel$export(module.exports, "difference", () => (parcelRequire("3UQ7O")).default);
$parcel$export(module.exports, "unzip", () => (parcelRequire("dLtZM")).default);
$parcel$export(module.exports, "transpose", () => (parcelRequire("dLtZM")).default);
$parcel$export(module.exports, "zip", () => (parcelRequire("cI1un")).default);
$parcel$export(module.exports, "object", () => (parcelRequire("kVaiK")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("koB8T")).default);
$parcel$export(module.exports, "chunk", () => (parcelRequire("2bQfI")).default);
$parcel$export(module.exports, "mixin", () => (parcelRequire("63AJi")).default);
$parcel$export(module.exports, "default", () => (parcelRequire("eQt0N")).default);
// Named Exports
// =============
//     Underscore.js 1.13.7
//     https://underscorejs.org
//     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $0fogG = parcelRequire("0fogG");

var $9b4UF = parcelRequire("9b4UF");

var $ip1qP = parcelRequire("ip1qP");

var $9NTkq = parcelRequire("9NTkq");

var $1ryv3 = parcelRequire("1ryv3");

var $7Rbr4 = parcelRequire("7Rbr4");

var $c47lv = parcelRequire("c47lv");

var $eeGBh = parcelRequire("eeGBh");

var $cu3St = parcelRequire("cu3St");

var $8n4Bn = parcelRequire("8n4Bn");

var $fnXE0 = parcelRequire("fnXE0");

var $7MFTz = parcelRequire("7MFTz");

var $ao4q3 = parcelRequire("ao4q3");

var $4he2i = parcelRequire("4he2i");

var $hGEiU = parcelRequire("hGEiU");

var $hux9f = parcelRequire("hux9f");

var $atLoF = parcelRequire("atLoF");

var $kO3hQ = parcelRequire("kO3hQ");

var $jwwdD = parcelRequire("jwwdD");

var $5b3jG = parcelRequire("5b3jG");

var $30QxN = parcelRequire("30QxN");

var $f7bBZ = parcelRequire("f7bBZ");

var $IgwY6 = parcelRequire("IgwY6");

var $4vRze = parcelRequire("4vRze");

var $cPfVH = parcelRequire("cPfVH");

var $eyJSb = parcelRequire("eyJSb");

var $9xU3y = parcelRequire("9xU3y");

var $krkyR = parcelRequire("krkyR");

var $1rFsw = parcelRequire("1rFsw");

var $aJjO9 = parcelRequire("aJjO9");

var $a1tWb = parcelRequire("a1tWb");

var $jtpc7 = parcelRequire("jtpc7");

var $hGaFi = parcelRequire("hGaFi");

var $gmuuZ = parcelRequire("gmuuZ");

var $fFuwj = parcelRequire("fFuwj");

var $x06cO = parcelRequire("x06cO");

var $17Hnr = parcelRequire("17Hnr");

var $gNib3 = parcelRequire("gNib3");

var $eENfB = parcelRequire("eENfB");

var $6L4iO = parcelRequire("6L4iO");

var $jkJ9i = parcelRequire("jkJ9i");

var $83NPx = parcelRequire("83NPx");

var $gejmE = parcelRequire("gejmE");

var $b3btC = parcelRequire("b3btC");

var $6MFBG = parcelRequire("6MFBG");

var $jssPN = parcelRequire("jssPN");

var $aCdeG = parcelRequire("aCdeG");

var $7gghp = parcelRequire("7gghp");

var $8HP4K = parcelRequire("8HP4K");

var $gyNYk = parcelRequire("gyNYk");

var $7UdJN = parcelRequire("7UdJN");

var $97fU6 = parcelRequire("97fU6");

var $1Yy3o = parcelRequire("1Yy3o");

var $kH9tx = parcelRequire("kH9tx");

var $jEiAQ = parcelRequire("jEiAQ");

var $eAyrH = parcelRequire("eAyrH");

var $7m1QE = parcelRequire("7m1QE");

var $dVtip = parcelRequire("dVtip");

var $brpOv = parcelRequire("brpOv");

var $jc1kq = parcelRequire("jc1kq");

var $6jb4b = parcelRequire("6jb4b");

var $lSJhi = parcelRequire("lSJhi");

var $iELwm = parcelRequire("iELwm");

var $8OoKw = parcelRequire("8OoKw");

var $7ncWx = parcelRequire("7ncWx");

var $3RwiW = parcelRequire("3RwiW");

var $jA0Ja = parcelRequire("jA0Ja");

var $l5420 = parcelRequire("l5420");

var $5cfcY = parcelRequire("5cfcY");

var $2rRDv = parcelRequire("2rRDv");

var $9yzrH = parcelRequire("9yzrH");

var $h0nlN = parcelRequire("h0nlN");

var $hAYIU = parcelRequire("hAYIU");

var $7G3Xv = parcelRequire("7G3Xv");

var $6D6Wy = parcelRequire("6D6Wy");

var $4sQsY = parcelRequire("4sQsY");

var $7H7To = parcelRequire("7H7To");

var $3RRBL = parcelRequire("3RRBL");

var $7imeo = parcelRequire("7imeo");

var $aMe0b = parcelRequire("aMe0b");

var $9CMoH = parcelRequire("9CMoH");

var $l0a5h = parcelRequire("l0a5h");

var $6oaDx = parcelRequire("6oaDx");

var $k08ZD = parcelRequire("k08ZD");

var $e1hz7 = parcelRequire("e1hz7");

var $5ztlX = parcelRequire("5ztlX");

var $3h2GT = parcelRequire("3h2GT");

var $2mDFn = parcelRequire("2mDFn");

var $dNa3T = parcelRequire("dNa3T");

var $jgJEX = parcelRequire("jgJEX");

var $9A89L = parcelRequire("9A89L");

var $gKeEm = parcelRequire("gKeEm");

var $dCJW1 = parcelRequire("dCJW1");

var $5KyAs = parcelRequire("5KyAs");

var $2X6oB = parcelRequire("2X6oB");

var $gVpd2 = parcelRequire("gVpd2");

var $VITl0 = parcelRequire("VITl0");

var $dkK7j = parcelRequire("dkK7j");

var $a2b2M = parcelRequire("a2b2M");

var $gAiTl = parcelRequire("gAiTl");

var $bdh5G = parcelRequire("bdh5G");

var $bSlRz = parcelRequire("bSlRz");

var $5N48u = parcelRequire("5N48u");

var $4TODu = parcelRequire("4TODu");

var $cAT6M = parcelRequire("cAT6M");

var $7B8AD = parcelRequire("7B8AD");

var $9I9nf = parcelRequire("9I9nf");

var $4QNAj = parcelRequire("4QNAj");

var $5wOr9 = parcelRequire("5wOr9");

var $5g2xy = parcelRequire("5g2xy");

var $1VINE = parcelRequire("1VINE");

var $gai4j = parcelRequire("gai4j");

var $xDQNi = parcelRequire("xDQNi");

var $aBPI4 = parcelRequire("aBPI4");

var $4iX6H = parcelRequire("4iX6H");

var $25WHZ = parcelRequire("25WHZ");

var $8vDfc = parcelRequire("8vDfc");

var $cjA2Z = parcelRequire("cjA2Z");

var $3UQ7O = parcelRequire("3UQ7O");

var $dLtZM = parcelRequire("dLtZM");

var $cI1un = parcelRequire("cI1un");

var $kVaiK = parcelRequire("kVaiK");

var $koB8T = parcelRequire("koB8T");

var $2bQfI = parcelRequire("2bQfI");

var $63AJi = parcelRequire("63AJi");

var $eQt0N = parcelRequire("eQt0N");

});
parcelRegister("0fogG", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $000bf06b37c76f83$export$a4ad2735b021c132);
$parcel$export(module.exports, "root", () => $000bf06b37c76f83$export$e8e78c978b129247);
$parcel$export(module.exports, "ArrayProto", () => $000bf06b37c76f83$export$aabeece9448a227a);
$parcel$export(module.exports, "ObjProto", () => $000bf06b37c76f83$export$e77bb59b5e655b3d);
$parcel$export(module.exports, "SymbolProto", () => $000bf06b37c76f83$export$e229dcb397ceea81);
$parcel$export(module.exports, "push", () => $000bf06b37c76f83$export$4cbf152802aa238);
$parcel$export(module.exports, "slice", () => $000bf06b37c76f83$export$58adb3bec8346d0f);
$parcel$export(module.exports, "toString", () => $000bf06b37c76f83$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "hasOwnProperty", () => $000bf06b37c76f83$export$5a15a386532a5ea4);
$parcel$export(module.exports, "supportsArrayBuffer", () => $000bf06b37c76f83$export$20eaf89d899ede58);
$parcel$export(module.exports, "supportsDataView", () => $000bf06b37c76f83$export$a2e478ad34dac33e);
$parcel$export(module.exports, "nativeIsArray", () => $000bf06b37c76f83$export$552cf9b635cef256);
$parcel$export(module.exports, "nativeKeys", () => $000bf06b37c76f83$export$e676cf06d7fd2114);
$parcel$export(module.exports, "nativeCreate", () => $000bf06b37c76f83$export$5b53dc95b548c58c);
$parcel$export(module.exports, "nativeIsView", () => $000bf06b37c76f83$export$35fc70fc5e80d5a7);
$parcel$export(module.exports, "_isNaN", () => $000bf06b37c76f83$export$a739ba33a90be0a1);
$parcel$export(module.exports, "_isFinite", () => $000bf06b37c76f83$export$8b48b92f6c9d5ad);
$parcel$export(module.exports, "hasEnumBug", () => $000bf06b37c76f83$export$7dcea4d27900b116);
$parcel$export(module.exports, "nonEnumerableProps", () => $000bf06b37c76f83$export$f8fa596d5e31cb19);
$parcel$export(module.exports, "MAX_ARRAY_INDEX", () => $000bf06b37c76f83$export$63b3abc5cd28bc48);
// Current version.
var $000bf06b37c76f83$export$a4ad2735b021c132 = '1.13.7';
var $000bf06b37c76f83$export$e8e78c978b129247 = typeof self == 'object' && self.self === self && self || typeof $parcel$global == 'object' && $parcel$global.global === $parcel$global && $parcel$global || Function('return this')() || {};
var $000bf06b37c76f83$export$aabeece9448a227a = Array.prototype, $000bf06b37c76f83$export$e77bb59b5e655b3d = Object.prototype;
var $000bf06b37c76f83$export$e229dcb397ceea81 = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
var $000bf06b37c76f83$export$4cbf152802aa238 = $000bf06b37c76f83$export$aabeece9448a227a.push, $000bf06b37c76f83$export$58adb3bec8346d0f = $000bf06b37c76f83$export$aabeece9448a227a.slice, $000bf06b37c76f83$export$f84e8e69fd4488a5 = $000bf06b37c76f83$export$e77bb59b5e655b3d.toString, $000bf06b37c76f83$export$5a15a386532a5ea4 = $000bf06b37c76f83$export$e77bb59b5e655b3d.hasOwnProperty;
var $000bf06b37c76f83$export$20eaf89d899ede58 = typeof ArrayBuffer !== 'undefined', $000bf06b37c76f83$export$a2e478ad34dac33e = typeof DataView !== 'undefined';
var $000bf06b37c76f83$export$552cf9b635cef256 = Array.isArray, $000bf06b37c76f83$export$e676cf06d7fd2114 = Object.keys, $000bf06b37c76f83$export$5b53dc95b548c58c = Object.create, $000bf06b37c76f83$export$35fc70fc5e80d5a7 = $000bf06b37c76f83$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $000bf06b37c76f83$export$a739ba33a90be0a1 = isNaN, $000bf06b37c76f83$export$8b48b92f6c9d5ad = isFinite;
var $000bf06b37c76f83$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable('toString');
var $000bf06b37c76f83$export$f8fa596d5e31cb19 = [
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
var $000bf06b37c76f83$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("9b4UF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ae8f3bb26145910$export$2e2bcd8739ae039);
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $6ae8f3bb26145910$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("ip1qP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d65bac1468aa9328$export$2e2bcd8739ae039);
// Is a given variable an object?
function $d65bac1468aa9328$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
}

});

parcelRegister("9NTkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $72339bbc06f7efa6$export$2e2bcd8739ae039);
// Is a given value equal to null?
function $72339bbc06f7efa6$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("1ryv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $10d31309ad0f145a$export$2e2bcd8739ae039);
// Is a given variable undefined?
function $10d31309ad0f145a$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("7Rbr4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b865a84a6b97411$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");
function $5b865a84a6b97411$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $0fogG.toString).call(obj) === '[object Boolean]';
}

});

parcelRegister("c47lv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c8b8e79eb697cdd$export$2e2bcd8739ae039);
// Is a given value a DOM element?
function $8c8b8e79eb697cdd$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("eeGBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5d36b01f6e8d706$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $a5d36b01f6e8d706$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('String');

});
parcelRegister("b5ZjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $813fb9f4e121dd4d$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");
function $813fb9f4e121dd4d$export$2e2bcd8739ae039(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
        return (0, $0fogG.toString).call(obj) === tag;
    };
}

});


parcelRegister("cu3St", function(module, exports) {

$parcel$export(module.exports, "default", () => $916b4b6065a38125$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $916b4b6065a38125$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('Number');

});

parcelRegister("8n4Bn", function(module, exports) {

$parcel$export(module.exports, "default", () => $61840a8822840127$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $61840a8822840127$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('Date');

});

parcelRegister("fnXE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b337451cfbe7578e$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $b337451cfbe7578e$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('RegExp');

});

parcelRegister("7MFTz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aad83a32e48d8e6$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $5aad83a32e48d8e6$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('Error');

});

parcelRegister("ao4q3", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ff92d8eecdcbfb$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $78ff92d8eecdcbfb$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('Symbol');

});

parcelRegister("4he2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $31d3a3378f39bb73$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $31d3a3378f39bb73$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('ArrayBuffer');

});

parcelRegister("hGEiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce059f6f84c810bf$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");

var $atLoF = parcelRequire("atLoF");

var $4he2i = parcelRequire("4he2i");

var $ccxH1 = parcelRequire("ccxH1");
var $ce059f6f84c810bf$var$isDataView = (0, $b5ZjP.default)('DataView');
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $ce059f6f84c810bf$var$alternateIsDataView(obj) {
    return obj != null && (0, $atLoF.default)(obj.getInt8) && (0, $4he2i.default)(obj.buffer);
}
var $ce059f6f84c810bf$export$2e2bcd8739ae039 = (0, $ccxH1.hasDataViewBug) ? $ce059f6f84c810bf$var$alternateIsDataView : $ce059f6f84c810bf$var$isDataView;

});
parcelRegister("atLoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a1160d330c1ead7$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");

var $0fogG = parcelRequire("0fogG");
var $7a1160d330c1ead7$var$isFunction = (0, $b5ZjP.default)('Function');
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $7a1160d330c1ead7$var$nodelist = (0, $0fogG.root).document && (0, $0fogG.root).document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof $7a1160d330c1ead7$var$nodelist != 'function') $7a1160d330c1ead7$var$isFunction = function(obj) {
    return typeof obj == 'function' || false;
};
var $7a1160d330c1ead7$export$2e2bcd8739ae039 = $7a1160d330c1ead7$var$isFunction;

});

parcelRegister("ccxH1", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", () => $8e20bdb7b03abac7$export$29b9ed4126fa90ab);
$parcel$export(module.exports, "isIE11", () => $8e20bdb7b03abac7$export$f7bad96d83325a34);

var $0fogG = parcelRequire("0fogG");

var $6lIjG = parcelRequire("6lIjG");
var $8e20bdb7b03abac7$export$29b9ed4126fa90ab = (0, $0fogG.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $6lIjG.default)(new DataView(new ArrayBuffer(8)))), $8e20bdb7b03abac7$export$f7bad96d83325a34 = typeof Map !== 'undefined' && (0, $6lIjG.default)(new Map);

});
parcelRegister("6lIjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $49f7148ef223a767$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $49f7148ef223a767$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('Object');

});



parcelRegister("hux9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbbef3895bf17d6c$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");

var $b5ZjP = parcelRequire("b5ZjP");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$cbbef3895bf17d6c$export$2e2bcd8739ae039 = (0, $0fogG.nativeIsArray) || (0, $b5ZjP.default)('Array');

});

parcelRegister("kO3hQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f25b06de0e39401b$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");

var $lHkXO = parcelRequire("lHkXO");
var $f25b06de0e39401b$var$isArguments = (0, $b5ZjP.default)('Arguments');
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$f25b06de0e39401b$var$isArguments(arguments)) $f25b06de0e39401b$var$isArguments = function(obj) {
        return (0, $lHkXO.default)(obj, 'callee');
    };
})();
var $f25b06de0e39401b$export$2e2bcd8739ae039 = $f25b06de0e39401b$var$isArguments;

});
parcelRegister("lHkXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcbde018fd436a38$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");
function $fcbde018fd436a38$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $0fogG.hasOwnProperty).call(obj, key);
}

});


parcelRegister("jwwdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e369ff7b104f0391$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");

var $ao4q3 = parcelRequire("ao4q3");
function $e369ff7b104f0391$export$2e2bcd8739ae039(obj) {
    return !(0, $ao4q3.default)(obj) && (0, $0fogG._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("5b3jG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c508d6a45be1c8e$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");

var $cu3St = parcelRequire("cu3St");
function $3c508d6a45be1c8e$export$2e2bcd8739ae039(obj) {
    return (0, $cu3St.default)(obj) && (0, $0fogG._isNaN)(obj);
}

});

parcelRegister("30QxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $231a215d76c221be$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");

var $hGEiU = parcelRequire("hGEiU");

var $6MFBG = parcelRequire("6MFBG");

var $3LAAj = parcelRequire("3LAAj");
// Is a given value a typed array?
var $231a215d76c221be$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $231a215d76c221be$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $0fogG.nativeIsView) ? (0, $0fogG.nativeIsView)(obj) && !(0, $hGEiU.default)(obj) : (0, $3LAAj.default)(obj) && $231a215d76c221be$var$typedArrayPattern.test((0, $0fogG.toString).call(obj));
}
var $231a215d76c221be$export$2e2bcd8739ae039 = (0, $0fogG.supportsArrayBuffer) ? $231a215d76c221be$var$isTypedArray : (0, $6MFBG.default)(false);

});
parcelRegister("6MFBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f0780033f8f3cc7$export$2e2bcd8739ae039);
// Predicate-generating function. Often useful outside of Underscore.
function $4f0780033f8f3cc7$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("3LAAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2be223d4255b810a$export$2e2bcd8739ae039);

var $iypm0 = parcelRequire("iypm0");

var $jabMU = parcelRequire("jabMU");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$2be223d4255b810a$export$2e2bcd8739ae039 = (0, $iypm0.default)((0, $jabMU.default));

});
parcelRegister("iypm0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f11c1a9d870d7$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");
function $d81f11c1a9d870d7$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= (0, $0fogG.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("jabMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $df38184ffcf99ee6$export$2e2bcd8739ae039);

var $5eLoL = parcelRequire("5eLoL");
var // Internal helper to obtain the `byteLength` property of an object.
$df38184ffcf99ee6$export$2e2bcd8739ae039 = (0, $5eLoL.default)('byteLength');

});
parcelRegister("5eLoL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d0306eb1f173609$export$2e2bcd8739ae039);
// Internal helper to generate a function to obtain property `key` from `obj`.
function $3d0306eb1f173609$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("f7bBZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0108450fb92934d$export$2e2bcd8739ae039);

var $giMod = parcelRequire("giMod");

var $hux9f = parcelRequire("hux9f");

var $eeGBh = parcelRequire("eeGBh");

var $kO3hQ = parcelRequire("kO3hQ");

var $1rFsw = parcelRequire("1rFsw");
function $b0108450fb92934d$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $giMod.default)(obj);
    if (typeof length == 'number' && ((0, $hux9f.default)(obj) || (0, $eeGBh.default)(obj) || (0, $kO3hQ.default)(obj))) return length === 0;
    return (0, $giMod.default)((0, $1rFsw.default)(obj)) === 0;
}

});
parcelRegister("giMod", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde3dcec59a84efa$export$2e2bcd8739ae039);

var $5eLoL = parcelRequire("5eLoL");
var // Internal helper to obtain the `length` property of an object.
$bde3dcec59a84efa$export$2e2bcd8739ae039 = (0, $5eLoL.default)('length');

});

parcelRegister("1rFsw", function(module, exports) {

$parcel$export(module.exports, "default", () => $10d878f831902995$export$2e2bcd8739ae039);

var $ip1qP = parcelRequire("ip1qP");

var $0fogG = parcelRequire("0fogG");

var $lHkXO = parcelRequire("lHkXO");

var $2YQyY = parcelRequire("2YQyY");
function $10d878f831902995$export$2e2bcd8739ae039(obj) {
    if (!(0, $ip1qP.default)(obj)) return [];
    if (0, $0fogG.nativeKeys) return (0, $0fogG.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $lHkXO.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $0fogG.hasEnumBug) (0, $2YQyY.default)(obj, keys);
    return keys;
}

});
parcelRegister("2YQyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b9f54944e13173$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");

var $atLoF = parcelRequire("atLoF");

var $lHkXO = parcelRequire("lHkXO");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $22b9f54944e13173$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $22b9f54944e13173$export$2e2bcd8739ae039(obj, keys) {
    keys = $22b9f54944e13173$var$emulatedSet(keys);
    var nonEnumIdx = (0, $0fogG.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $atLoF.default)(constructor) && constructor.prototype || (0, $0fogG.ObjProto);
    // Constructor is a special case.
    var prop = 'constructor';
    if ((0, $lHkXO.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $0fogG.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("IgwY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0850eed6854c7f5a$export$2e2bcd8739ae039);

var $1rFsw = parcelRequire("1rFsw");
function $0850eed6854c7f5a$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $1rFsw.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("4vRze", function(module, exports) {

$parcel$export(module.exports, "default", () => $34939bff65b1f7a5$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");

var $0fogG = parcelRequire("0fogG");

var $jabMU = parcelRequire("jabMU");

var $30QxN = parcelRequire("30QxN");

var $atLoF = parcelRequire("atLoF");

var $ccxH1 = parcelRequire("ccxH1");

var $hGEiU = parcelRequire("hGEiU");

var $1rFsw = parcelRequire("1rFsw");

var $lHkXO = parcelRequire("lHkXO");

var $7w2B8 = parcelRequire("7w2B8");
// We use this string twice, so give it a name for minification.
var $34939bff65b1f7a5$var$tagDataView = '[object DataView]';
// Internal recursive comparison function for `_.isEqual`.
function $34939bff65b1f7a5$var$eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return $34939bff65b1f7a5$var$deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `_.isEqual`.
function $34939bff65b1f7a5$var$deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof (0, $9FCoE.default)) a = a._wrapped;
    if (b instanceof (0, $9FCoE.default)) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = (0, $0fogG.toString).call(a);
    if (className !== (0, $0fogG.toString).call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if ((0, $ccxH1.hasDataViewBug) && className == '[object Object]' && (0, $hGEiU.default)(a)) {
        if (!(0, $hGEiU.default)(b)) return false;
        className = $34939bff65b1f7a5$var$tagDataView;
    }
    switch(className){
        // These types are compared by value.
        case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case '[object String]':
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return '' + a === '' + b;
        case '[object Number]':
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case '[object Date]':
        case '[object Boolean]':
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case '[object Symbol]':
            return (0, $0fogG.SymbolProto).valueOf.call(a) === (0, $0fogG.SymbolProto).valueOf.call(b);
        case '[object ArrayBuffer]':
        case $34939bff65b1f7a5$var$tagDataView:
            // Coerce to typed array so we can fall through.
            return $34939bff65b1f7a5$var$deepEq((0, $7w2B8.default)(a), (0, $7w2B8.default)(b), aStack, bStack);
    }
    var areArrays = className === '[object Array]';
    if (!areArrays && (0, $30QxN.default)(a)) {
        var byteLength = (0, $jabMU.default)(a);
        if (byteLength !== (0, $jabMU.default)(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
        if (typeof a != 'object' || typeof b != 'object') return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !((0, $atLoF.default)(aCtor) && aCtor instanceof aCtor && (0, $atLoF.default)(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) return false;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$34939bff65b1f7a5$var$eq(a[length], b[length], aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var _keys = (0, $1rFsw.default)(a), key;
        length = _keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if ((0, $1rFsw.default)(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = _keys[length];
            if (!((0, $lHkXO.default)(b, key) && $34939bff65b1f7a5$var$eq(a[key], b[key], aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $34939bff65b1f7a5$export$2e2bcd8739ae039(a, b) {
    return $34939bff65b1f7a5$var$eq(a, b);
}

});
parcelRegister("9FCoE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a5ba2bf2c48a3b$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");
function $70a5ba2bf2c48a3b$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $70a5ba2bf2c48a3b$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $70a5ba2bf2c48a3b$export$2e2bcd8739ae039)) return new $70a5ba2bf2c48a3b$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$70a5ba2bf2c48a3b$export$2e2bcd8739ae039.VERSION = (0, $0fogG.VERSION);
// Extracts the result from a wrapped and chained object.
$70a5ba2bf2c48a3b$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$70a5ba2bf2c48a3b$export$2e2bcd8739ae039.prototype.valueOf = $70a5ba2bf2c48a3b$export$2e2bcd8739ae039.prototype.toJSON = $70a5ba2bf2c48a3b$export$2e2bcd8739ae039.prototype.value;
$70a5ba2bf2c48a3b$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("7w2B8", function(module, exports) {

$parcel$export(module.exports, "default", () => $578d897ad8af3fc1$export$2e2bcd8739ae039);

var $jabMU = parcelRequire("jabMU");
function $578d897ad8af3fc1$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $jabMU.default)(bufferSource));
}

});


parcelRegister("cPfVH", function(module, exports) {

$parcel$export(module.exports, "default", () => $95669ac32a242dc9$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");

var $ccxH1 = parcelRequire("ccxH1");

var $2DDyJ = parcelRequire("2DDyJ");
var $95669ac32a242dc9$export$2e2bcd8739ae039 = (0, $ccxH1.isIE11) ? (0, $2DDyJ.ie11fingerprint)((0, $2DDyJ.mapMethods)) : (0, $b5ZjP.default)('Map');

});
parcelRegister("2DDyJ", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", () => $1ebde8e8bb54f853$export$15230eca1f400e40);
$parcel$export(module.exports, "weakMapMethods", () => $1ebde8e8bb54f853$export$2f74b890a72cf48);
$parcel$export(module.exports, "mapMethods", () => $1ebde8e8bb54f853$export$de9acb94190bb764);
$parcel$export(module.exports, "setMethods", () => $1ebde8e8bb54f853$export$60e14a5e2a057f78);

var $giMod = parcelRequire("giMod");

var $atLoF = parcelRequire("atLoF");

var $aJjO9 = parcelRequire("aJjO9");
function $1ebde8e8bb54f853$export$15230eca1f400e40(methods) {
    var length = (0, $giMod.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $aJjO9.default)(obj);
        if ((0, $giMod.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $atLoF.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $1ebde8e8bb54f853$export$2f74b890a72cf48 || !(0, $atLoF.default)(obj[$1ebde8e8bb54f853$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $1ebde8e8bb54f853$var$forEachName = 'forEach', $1ebde8e8bb54f853$var$hasName = 'has', $1ebde8e8bb54f853$var$commonInit = [
    'clear',
    'delete'
], $1ebde8e8bb54f853$var$mapTail = [
    'get',
    $1ebde8e8bb54f853$var$hasName,
    'set'
];
var $1ebde8e8bb54f853$export$de9acb94190bb764 = $1ebde8e8bb54f853$var$commonInit.concat($1ebde8e8bb54f853$var$forEachName, $1ebde8e8bb54f853$var$mapTail), $1ebde8e8bb54f853$export$2f74b890a72cf48 = $1ebde8e8bb54f853$var$commonInit.concat($1ebde8e8bb54f853$var$mapTail), $1ebde8e8bb54f853$export$60e14a5e2a057f78 = [
    'add'
].concat($1ebde8e8bb54f853$var$commonInit, $1ebde8e8bb54f853$var$forEachName, $1ebde8e8bb54f853$var$hasName);

});
parcelRegister("aJjO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cfd78c47e40001d$export$2e2bcd8739ae039);

var $ip1qP = parcelRequire("ip1qP");

var $0fogG = parcelRequire("0fogG");

var $2YQyY = parcelRequire("2YQyY");
function $7cfd78c47e40001d$export$2e2bcd8739ae039(obj) {
    if (!(0, $ip1qP.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $0fogG.hasEnumBug) (0, $2YQyY.default)(obj, keys);
    return keys;
}

});



parcelRegister("eyJSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a997d30bf5f02d92$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");

var $ccxH1 = parcelRequire("ccxH1");

var $2DDyJ = parcelRequire("2DDyJ");
var $a997d30bf5f02d92$export$2e2bcd8739ae039 = (0, $ccxH1.isIE11) ? (0, $2DDyJ.ie11fingerprint)((0, $2DDyJ.weakMapMethods)) : (0, $b5ZjP.default)('WeakMap');

});

parcelRegister("9xU3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f32adb8335c21b9$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");

var $ccxH1 = parcelRequire("ccxH1");

var $2DDyJ = parcelRequire("2DDyJ");
var $6f32adb8335c21b9$export$2e2bcd8739ae039 = (0, $ccxH1.isIE11) ? (0, $2DDyJ.ie11fingerprint)((0, $2DDyJ.setMethods)) : (0, $b5ZjP.default)('Set');

});

parcelRegister("krkyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee16474d61ba27d8$export$2e2bcd8739ae039);

var $b5ZjP = parcelRequire("b5ZjP");
var $ee16474d61ba27d8$export$2e2bcd8739ae039 = (0, $b5ZjP.default)('WeakSet');

});

parcelRegister("a1tWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $74c1385509a211c9$export$2e2bcd8739ae039);

var $1rFsw = parcelRequire("1rFsw");
function $74c1385509a211c9$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $1rFsw.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("jtpc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2d444dfe470c8e0$export$2e2bcd8739ae039);

var $1rFsw = parcelRequire("1rFsw");
function $e2d444dfe470c8e0$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $1rFsw.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("hGaFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdeea1c50d07975c$export$2e2bcd8739ae039);

var $1rFsw = parcelRequire("1rFsw");
function $cdeea1c50d07975c$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $1rFsw.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("gmuuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0312f0f727f9296b$export$2e2bcd8739ae039);

var $atLoF = parcelRequire("atLoF");
function $0312f0f727f9296b$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $atLoF.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("fFuwj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6825bfedafe2c53$export$2e2bcd8739ae039);

var $hlhdj = parcelRequire("hlhdj");

var $aJjO9 = parcelRequire("aJjO9");
var // Extend a given object with all the properties in passed-in object(s).
$b6825bfedafe2c53$export$2e2bcd8739ae039 = (0, $hlhdj.default)((0, $aJjO9.default));

});
parcelRegister("hlhdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca01c0232ad395ba$export$2e2bcd8739ae039);
// An internal function for creating assigner functions.
function $ca01c0232ad395ba$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("x06cO", function(module, exports) {

$parcel$export(module.exports, "default", () => $063328dc1099c027$export$2e2bcd8739ae039);

var $hlhdj = parcelRequire("hlhdj");

var $1rFsw = parcelRequire("1rFsw");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$063328dc1099c027$export$2e2bcd8739ae039 = (0, $hlhdj.default)((0, $1rFsw.default));

});

parcelRegister("17Hnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1817ad2e2b4d97$export$2e2bcd8739ae039);

var $hlhdj = parcelRequire("hlhdj");

var $aJjO9 = parcelRequire("aJjO9");
var // Fill in a given object with default properties.
$0d1817ad2e2b4d97$export$2e2bcd8739ae039 = (0, $hlhdj.default)((0, $aJjO9.default), true);

});

parcelRegister("gNib3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c39f5290221c75c4$export$2e2bcd8739ae039);

var $3rGS7 = parcelRequire("3rGS7");

var $x06cO = parcelRequire("x06cO");
function $c39f5290221c75c4$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $3rGS7.default)(prototype);
    if (props) (0, $x06cO.default)(result, props);
    return result;
}

});
parcelRegister("3rGS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2825262fd6be2153$export$2e2bcd8739ae039);

var $ip1qP = parcelRequire("ip1qP");

var $0fogG = parcelRequire("0fogG");
// Create a naked function reference for surrogate-prototype-swapping.
function $2825262fd6be2153$var$ctor() {
    return function() {};
}
function $2825262fd6be2153$export$2e2bcd8739ae039(prototype) {
    if (!(0, $ip1qP.default)(prototype)) return {};
    if (0, $0fogG.nativeCreate) return (0, $0fogG.nativeCreate)(prototype);
    var Ctor = $2825262fd6be2153$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("eENfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $aabb014bb33743ea$export$2e2bcd8739ae039);

var $ip1qP = parcelRequire("ip1qP");

var $hux9f = parcelRequire("hux9f");

var $fFuwj = parcelRequire("fFuwj");
function $aabb014bb33743ea$export$2e2bcd8739ae039(obj) {
    if (!(0, $ip1qP.default)(obj)) return obj;
    return (0, $hux9f.default)(obj) ? obj.slice() : (0, $fFuwj.default)({}, obj);
}

});

parcelRegister("6L4iO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eba783b5226dfe4$export$2e2bcd8739ae039);
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $4eba783b5226dfe4$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("jkJ9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e132e83cba12b620$export$2e2bcd8739ae039);

var $izdkQ = parcelRequire("izdkQ");

var $2pDg4 = parcelRequire("2pDg4");

var $1ryv3 = parcelRequire("1ryv3");
function $e132e83cba12b620$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $2pDg4.default)(object, (0, $izdkQ.default)(path));
    return (0, $1ryv3.default)(value) ? defaultValue : value;
}

});
parcelRegister("izdkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d845d6f3ea037e5a$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");
parcelRequire("aCdeG");
function $d845d6f3ea037e5a$export$2e2bcd8739ae039(path) {
    return (0, $9FCoE.default).toPath(path);
}

});
parcelRegister("aCdeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba7b85b4cb72d46$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");

var $hux9f = parcelRequire("hux9f");
function $7ba7b85b4cb72d46$export$2e2bcd8739ae039(path) {
    return (0, $hux9f.default)(path) ? path : [
        path
    ];
}
(0, $9FCoE.default).toPath = $7ba7b85b4cb72d46$export$2e2bcd8739ae039;

});


parcelRegister("2pDg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c1c5e6fc7adcd90$export$2e2bcd8739ae039);
// Internal function to obtain a nested property in `obj` along `path`.
function $1c1c5e6fc7adcd90$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("83NPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de541c8c6755cda$export$2e2bcd8739ae039);

var $lHkXO = parcelRequire("lHkXO");

var $izdkQ = parcelRequire("izdkQ");
function $5de541c8c6755cda$export$2e2bcd8739ae039(obj, path) {
    path = (0, $izdkQ.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $lHkXO.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("gejmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd0cf97de98c15c5$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $1rFsw = parcelRequire("1rFsw");
function $bd0cf97de98c15c5$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $cmfAU.default)(iteratee, context);
    var _keys = (0, $1rFsw.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("cmfAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ff3a2ca0f32c0ce$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");

var $4W9NQ = parcelRequire("4W9NQ");

var $6jb4b = parcelRequire("6jb4b");
function $8ff3a2ca0f32c0ce$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $9FCoE.default).iteratee !== (0, $6jb4b.default)) return (0, $9FCoE.default).iteratee(value, context);
    return (0, $4W9NQ.default)(value, context, argCount);
}

});
parcelRegister("4W9NQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $39842ed76aeafb7f$export$2e2bcd8739ae039);

var $b3btC = parcelRequire("b3btC");

var $atLoF = parcelRequire("atLoF");

var $ip1qP = parcelRequire("ip1qP");

var $hux9f = parcelRequire("hux9f");

var $gyNYk = parcelRequire("gyNYk");

var $7gghp = parcelRequire("7gghp");

var $a4GZa = parcelRequire("a4GZa");
function $39842ed76aeafb7f$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $b3btC.default;
    if ((0, $atLoF.default)(value)) return (0, $a4GZa.default)(value, context, argCount);
    if ((0, $ip1qP.default)(value) && !(0, $hux9f.default)(value)) return (0, $gyNYk.default)(value);
    return (0, $7gghp.default)(value);
}

});
parcelRegister("b3btC", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b8e08ce82c9994$export$2e2bcd8739ae039);
// Keep the identity function around for default iteratees.
function $80b8e08ce82c9994$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("gyNYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e695b90ab77523$export$2e2bcd8739ae039);

var $x06cO = parcelRequire("x06cO");

var $IgwY6 = parcelRequire("IgwY6");
function $c0e695b90ab77523$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $x06cO.default)({}, attrs);
    return function(obj) {
        return (0, $IgwY6.default)(obj, attrs);
    };
}

});

parcelRegister("7gghp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5496a7d4e82b030b$export$2e2bcd8739ae039);

var $2pDg4 = parcelRequire("2pDg4");

var $izdkQ = parcelRequire("izdkQ");
function $5496a7d4e82b030b$export$2e2bcd8739ae039(path) {
    path = (0, $izdkQ.default)(path);
    return function(obj) {
        return (0, $2pDg4.default)(obj, path);
    };
}

});

parcelRegister("a4GZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $755b9f22064c833d$export$2e2bcd8739ae039);
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $755b9f22064c833d$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("6jb4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $497d19f913a2281d$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");

var $4W9NQ = parcelRequire("4W9NQ");
function $497d19f913a2281d$export$2e2bcd8739ae039(value, context) {
    return (0, $4W9NQ.default)(value, context, Infinity);
}
(0, $9FCoE.default).iteratee = $497d19f913a2281d$export$2e2bcd8739ae039;

});



parcelRegister("jssPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a6ffc261e64b05$export$2e2bcd8739ae039);
// Predicate-generating function. Often useful outside of Underscore.
function $e2a6ffc261e64b05$export$2e2bcd8739ae039() {}

});

parcelRegister("8HP4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $6569f56a1f6fa1b6$export$2e2bcd8739ae039);

var $jssPN = parcelRequire("jssPN");

var $jkJ9i = parcelRequire("jkJ9i");
function $6569f56a1f6fa1b6$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $jssPN.default;
    return function(path) {
        return (0, $jkJ9i.default)(obj, path);
    };
}

});

parcelRegister("7UdJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c186b5cf69fe337$export$2e2bcd8739ae039);

var $a4GZa = parcelRequire("a4GZa");
function $5c186b5cf69fe337$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $a4GZa.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("97fU6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a311ab3d3f6b8ad$export$2e2bcd8739ae039);
// Return a random integer between `min` and `max` (inclusive).
function $6a311ab3d3f6b8ad$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("1Yy3o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1705cf64fc5fa86e$export$2e2bcd8739ae039);
// A (possibly faster) way to get the current timestamp as an integer.
var $1705cf64fc5fa86e$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("kH9tx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f10f2c69a55144c5$export$2e2bcd8739ae039);

var $be6sr = parcelRequire("be6sr");

var $bhFrh = parcelRequire("bhFrh");
var // Function for escaping strings to HTML interpolation.
$f10f2c69a55144c5$export$2e2bcd8739ae039 = (0, $be6sr.default)((0, $bhFrh.default));

});
parcelRegister("be6sr", function(module, exports) {

$parcel$export(module.exports, "default", () => $82c602de23a9bb13$export$2e2bcd8739ae039);

var $1rFsw = parcelRequire("1rFsw");
function $82c602de23a9bb13$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + (0, $1rFsw.default)(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("bhFrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $83716d2f8944d79a$export$2e2bcd8739ae039);
// Internal list of HTML entities for escaping.
var $83716d2f8944d79a$export$2e2bcd8739ae039 = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};

});


parcelRegister("jEiAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4e02cfd266dca1a$export$2e2bcd8739ae039);

var $be6sr = parcelRequire("be6sr");

var $ck1Wr = parcelRequire("ck1Wr");
var // Function for unescaping strings from HTML interpolation.
$e4e02cfd266dca1a$export$2e2bcd8739ae039 = (0, $be6sr.default)((0, $ck1Wr.default));

});
parcelRegister("ck1Wr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f88dbdeb1550c56$export$2e2bcd8739ae039);

var $hGaFi = parcelRequire("hGaFi");

var $bhFrh = parcelRequire("bhFrh");
var // Internal list of HTML entities for unescaping.
$8f88dbdeb1550c56$export$2e2bcd8739ae039 = (0, $hGaFi.default)((0, $bhFrh.default));

});


parcelRegister("eAyrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ef25b17449df53$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$a9ef25b17449df53$export$2e2bcd8739ae039 = (0, $9FCoE.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("7m1QE", function(module, exports) {

$parcel$export(module.exports, "default", () => $55ac057e5527d1ce$export$2e2bcd8739ae039);

var $17Hnr = parcelRequire("17Hnr");

var $9FCoE = parcelRequire("9FCoE");
parcelRequire("eAyrH");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $55ac057e5527d1ce$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $55ac057e5527d1ce$var$escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var $55ac057e5527d1ce$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $55ac057e5527d1ce$var$escapeChar(match) {
    return '\\' + $55ac057e5527d1ce$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $55ac057e5527d1ce$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $55ac057e5527d1ce$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $17Hnr.default)({}, settings, (0, $9FCoE.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $55ac057e5527d1ce$var$noMatch).source,
        (settings.interpolate || $55ac057e5527d1ce$var$noMatch).source,
        (settings.evaluate || $55ac057e5527d1ce$var$noMatch).source
    ].join('|') + '|$', 'g');
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($55ac057e5527d1ce$var$escapeRegExp, $55ac057e5527d1ce$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$55ac057e5527d1ce$var$bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
    var render;
    try {
        render = new Function(argument, '_', source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $9FCoE.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}

});

parcelRegister("dVtip", function(module, exports) {

$parcel$export(module.exports, "default", () => $a23752ca0e41cf59$export$2e2bcd8739ae039);

var $atLoF = parcelRequire("atLoF");

var $izdkQ = parcelRequire("izdkQ");
function $a23752ca0e41cf59$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $izdkQ.default)(path);
    var length = path.length;
    if (!length) return (0, $atLoF.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $atLoF.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("brpOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $02264b5005aaa00f$export$2e2bcd8739ae039);
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $02264b5005aaa00f$var$idCounter = 0;
function $02264b5005aaa00f$export$2e2bcd8739ae039(prefix) {
    var id = ++$02264b5005aaa00f$var$idCounter + '';
    return prefix ? prefix + id : id;
}

});

parcelRegister("jc1kq", function(module, exports) {

$parcel$export(module.exports, "default", () => $df902b1b6bb814d7$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");
function $df902b1b6bb814d7$export$2e2bcd8739ae039(obj) {
    var instance = (0, $9FCoE.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("lSJhi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee1c36648b3821f$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $gsuJy = parcelRequire("gsuJy");

var $9FCoE = parcelRequire("9FCoE");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $fee1c36648b3821f$var$partial = (0, $9b4UF.default)(function(func, boundArgs) {
    var placeholder = $fee1c36648b3821f$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $gsuJy.default)(func, bound, this, this, args);
    };
    return bound;
});
$fee1c36648b3821f$var$partial.placeholder = (0, $9FCoE.default);
var $fee1c36648b3821f$export$2e2bcd8739ae039 = $fee1c36648b3821f$var$partial;

});
parcelRegister("gsuJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb719f048ad30de$export$2e2bcd8739ae039);

var $3rGS7 = parcelRequire("3rGS7");

var $ip1qP = parcelRequire("ip1qP");
function $bfb719f048ad30de$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $3rGS7.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $ip1qP.default)(result)) return result;
    return self;
}

});


parcelRegister("iELwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d950d31447ffb212$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $atLoF = parcelRequire("atLoF");

var $gsuJy = parcelRequire("gsuJy");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$d950d31447ffb212$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(func, context, args) {
    if (!(0, $atLoF.default)(func)) throw new TypeError('Bind must be called on a function');
    var bound = (0, $9b4UF.default)(function(callArgs) {
        return (0, $gsuJy.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("8OoKw", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a630f2e3eb3dab$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $6vOl1 = parcelRequire("6vOl1");

var $iELwm = parcelRequire("iELwm");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$66a630f2e3eb3dab$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(obj, keys) {
    keys = (0, $6vOl1.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while(index--){
        var key = keys[index];
        obj[key] = (0, $iELwm.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("6vOl1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bdcaf6a3a7ad9d8$export$2e2bcd8739ae039);

var $giMod = parcelRequire("giMod");

var $kESAN = parcelRequire("kESAN");

var $hux9f = parcelRequire("hux9f");

var $kO3hQ = parcelRequire("kO3hQ");
function $4bdcaf6a3a7ad9d8$export$2e2bcd8739ae039(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) depth = Infinity;
    else if (depth <= 0) return output.concat(input);
    var idx = output.length;
    for(var i = 0, length = (0, $giMod.default)(input); i < length; i++){
        var value = input[i];
        if ((0, $kESAN.default)(value) && ((0, $hux9f.default)(value) || (0, $kO3hQ.default)(value))) {
            // Flatten current level of array or arguments object.
            if (depth > 1) {
                $4bdcaf6a3a7ad9d8$export$2e2bcd8739ae039(value, depth - 1, strict, output);
                idx = output.length;
            } else {
                var j = 0, len = value.length;
                while(j < len)output[idx++] = value[j++];
            }
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("kESAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0a1e3fd1981da54$export$2e2bcd8739ae039);

var $iypm0 = parcelRequire("iypm0");

var $giMod = parcelRequire("giMod");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$f0a1e3fd1981da54$export$2e2bcd8739ae039 = (0, $iypm0.default)((0, $giMod.default));

});



parcelRegister("7ncWx", function(module, exports) {

$parcel$export(module.exports, "default", () => $55e4b8a7101815a5$export$2e2bcd8739ae039);

var $lHkXO = parcelRequire("lHkXO");
function $55e4b8a7101815a5$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $lHkXO.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("3RwiW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cff615b0b5d26ce$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$2cff615b0b5d26ce$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("jA0Ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $e411f194cb862e02$export$2e2bcd8739ae039);

var $lSJhi = parcelRequire("lSJhi");

var $3RwiW = parcelRequire("3RwiW");

var $9FCoE = parcelRequire("9FCoE");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$e411f194cb862e02$export$2e2bcd8739ae039 = (0, $lSJhi.default)((0, $3RwiW.default), (0, $9FCoE.default), 1);

});

parcelRegister("l5420", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58d311f2ba66c06$export$2e2bcd8739ae039);

var $1Yy3o = parcelRequire("1Yy3o");
function $f58d311f2ba66c06$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $1Yy3o.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $1Yy3o.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("5cfcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c89dece771eb4ab$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $1Yy3o = parcelRequire("1Yy3o");
function $3c89dece771eb4ab$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $1Yy3o.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $9b4UF.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $1Yy3o.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("2rRDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c87b56e09cab4b4$export$2e2bcd8739ae039);

var $lSJhi = parcelRequire("lSJhi");
function $1c87b56e09cab4b4$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $lSJhi.default)(wrapper, func);
}

});

parcelRegister("9yzrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f52c8cf12aa79d8$export$2e2bcd8739ae039);
// Returns a negated version of the passed-in predicate.
function $6f52c8cf12aa79d8$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("h0nlN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6148cae5304d807$export$2e2bcd8739ae039);
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $c6148cae5304d807$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("hAYIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf4e6e043468e73$export$2e2bcd8739ae039);
// Returns a function that will only be executed on and after the Nth call.
function $ccf4e6e043468e73$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("7G3Xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $596f86c76604b564$export$2e2bcd8739ae039);
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $596f86c76604b564$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("6D6Wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3bc56ddcc142d2$export$2e2bcd8739ae039);

var $lSJhi = parcelRequire("lSJhi");

var $7G3Xv = parcelRequire("7G3Xv");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$4d3bc56ddcc142d2$export$2e2bcd8739ae039 = (0, $lSJhi.default)((0, $7G3Xv.default), 2);

});

parcelRegister("4sQsY", function(module, exports) {

$parcel$export(module.exports, "default", () => $340279ab3dfea7e7$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $1rFsw = parcelRequire("1rFsw");
function $340279ab3dfea7e7$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $cmfAU.default)(predicate, context);
    var _keys = (0, $1rFsw.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("7H7To", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a2abd564729ad7$export$2e2bcd8739ae039);

var $3zhoV = parcelRequire("3zhoV");
var // Returns the first index on an array-like that passes a truth test.
$59a2abd564729ad7$export$2e2bcd8739ae039 = (0, $3zhoV.default)(1);

});
parcelRegister("3zhoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992237c00c6ebcc$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $giMod = parcelRequire("giMod");
function $2992237c00c6ebcc$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $cmfAU.default)(predicate, context);
        var length = (0, $giMod.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("3RRBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d0fe7cfcdff1bab$export$2e2bcd8739ae039);

var $3zhoV = parcelRequire("3zhoV");
var // Returns the last index on an array-like that passes a truth test.
$2d0fe7cfcdff1bab$export$2e2bcd8739ae039 = (0, $3zhoV.default)(-1);

});

parcelRegister("7imeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $54fb7576cfe202a7$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $giMod = parcelRequire("giMod");
function $54fb7576cfe202a7$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $cmfAU.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $giMod.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("aMe0b", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d893f904b17345b$export$2e2bcd8739ae039);

var $7imeo = parcelRequire("7imeo");

var $7H7To = parcelRequire("7H7To");

var $hOxsU = parcelRequire("hOxsU");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$7d893f904b17345b$export$2e2bcd8739ae039 = (0, $hOxsU.default)(1, (0, $7H7To.default), (0, $7imeo.default));

});
parcelRegister("hOxsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8110b0a44c2681$export$2e2bcd8739ae039);

var $giMod = parcelRequire("giMod");

var $0fogG = parcelRequire("0fogG");

var $5b3jG = parcelRequire("5b3jG");
function $cf8110b0a44c2681$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $giMod.default)(array);
        if (typeof idx == 'number') {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $0fogG.slice).call(array, i, length), (0, $5b3jG.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("9CMoH", function(module, exports) {

$parcel$export(module.exports, "default", () => $701d345d07d6e05f$export$2e2bcd8739ae039);

var $3RRBL = parcelRequire("3RRBL");

var $hOxsU = parcelRequire("hOxsU");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$701d345d07d6e05f$export$2e2bcd8739ae039 = (0, $hOxsU.default)(-1, (0, $3RRBL.default));

});

parcelRegister("l0a5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4a16b94b6647455$export$2e2bcd8739ae039);

var $kESAN = parcelRequire("kESAN");

var $7H7To = parcelRequire("7H7To");

var $4sQsY = parcelRequire("4sQsY");
function $f4a16b94b6647455$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $kESAN.default)(obj) ? (0, $7H7To.default) : (0, $4sQsY.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("6oaDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a6d3c2c77ce47ef$export$2e2bcd8739ae039);

var $l0a5h = parcelRequire("l0a5h");

var $gyNYk = parcelRequire("gyNYk");
function $4a6d3c2c77ce47ef$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $l0a5h.default)(obj, (0, $gyNYk.default)(attrs));
}

});

parcelRegister("k08ZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8fac895305272f7$export$2e2bcd8739ae039);

var $a4GZa = parcelRequire("a4GZa");

var $kESAN = parcelRequire("kESAN");

var $1rFsw = parcelRequire("1rFsw");
function $e8fac895305272f7$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $a4GZa.default)(iteratee, context);
    var i, length;
    if ((0, $kESAN.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $1rFsw.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("e1hz7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a34ec8cb8af215f1$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $kESAN = parcelRequire("kESAN");

var $1rFsw = parcelRequire("1rFsw");
function $a34ec8cb8af215f1$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $cmfAU.default)(iteratee, context);
    var _keys = !(0, $kESAN.default)(obj) && (0, $1rFsw.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("5ztlX", function(module, exports) {

$parcel$export(module.exports, "default", () => $40e6fd88c6329e43$export$2e2bcd8739ae039);

var $IGyd7 = parcelRequire("IGyd7");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$40e6fd88c6329e43$export$2e2bcd8739ae039 = (0, $IGyd7.default)(1);

});
parcelRegister("IGyd7", function(module, exports) {

$parcel$export(module.exports, "default", () => $08651ddfe2dcd2d1$export$2e2bcd8739ae039);

var $kESAN = parcelRequire("kESAN");

var $1rFsw = parcelRequire("1rFsw");

var $a4GZa = parcelRequire("a4GZa");
function $08651ddfe2dcd2d1$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $kESAN.default)(obj) && (0, $1rFsw.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $a4GZa.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("3h2GT", function(module, exports) {

$parcel$export(module.exports, "default", () => $26250bf4a2293ce3$export$2e2bcd8739ae039);

var $IGyd7 = parcelRequire("IGyd7");
var // The right-associative version of reduce, also known as `foldr`.
$26250bf4a2293ce3$export$2e2bcd8739ae039 = (0, $IGyd7.default)(-1);

});

parcelRegister("2mDFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b8c67be4cd38f71$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $k08ZD = parcelRequire("k08ZD");
function $1b8c67be4cd38f71$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $cmfAU.default)(predicate, context);
    (0, $k08ZD.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("dNa3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a7a80073e081b8$export$2e2bcd8739ae039);

var $2mDFn = parcelRequire("2mDFn");

var $9yzrH = parcelRequire("9yzrH");

var $cmfAU = parcelRequire("cmfAU");
function $a0a7a80073e081b8$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $2mDFn.default)(obj, (0, $9yzrH.default)((0, $cmfAU.default)(predicate)), context);
}

});

parcelRegister("jgJEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e072ee02180f8563$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $kESAN = parcelRequire("kESAN");

var $1rFsw = parcelRequire("1rFsw");
function $e072ee02180f8563$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $cmfAU.default)(predicate, context);
    var _keys = !(0, $kESAN.default)(obj) && (0, $1rFsw.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("9A89L", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f9dcd93990ed99a$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $kESAN = parcelRequire("kESAN");

var $1rFsw = parcelRequire("1rFsw");
function $6f9dcd93990ed99a$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $cmfAU.default)(predicate, context);
    var _keys = !(0, $kESAN.default)(obj) && (0, $1rFsw.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("gKeEm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c30c4e60aa157e87$export$2e2bcd8739ae039);

var $kESAN = parcelRequire("kESAN");

var $a1tWb = parcelRequire("a1tWb");

var $aMe0b = parcelRequire("aMe0b");
function $c30c4e60aa157e87$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $kESAN.default)(obj)) obj = (0, $a1tWb.default)(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return (0, $aMe0b.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("dCJW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb274ac3972dd88$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $atLoF = parcelRequire("atLoF");

var $e1hz7 = parcelRequire("e1hz7");

var $2pDg4 = parcelRequire("2pDg4");

var $izdkQ = parcelRequire("izdkQ");
var // Invoke a method (with arguments) on every item in a collection.
$9eb274ac3972dd88$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $atLoF.default)(path)) func = path;
    else {
        path = (0, $izdkQ.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $e1hz7.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $2pDg4.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("5KyAs", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc13dff0c56846$export$2e2bcd8739ae039);

var $e1hz7 = parcelRequire("e1hz7");

var $7gghp = parcelRequire("7gghp");
function $42fc13dff0c56846$export$2e2bcd8739ae039(obj, key) {
    return (0, $e1hz7.default)(obj, (0, $7gghp.default)(key));
}

});

parcelRegister("2X6oB", function(module, exports) {

$parcel$export(module.exports, "default", () => $22660d86d2c151bd$export$2e2bcd8739ae039);

var $2mDFn = parcelRequire("2mDFn");

var $gyNYk = parcelRequire("gyNYk");
function $22660d86d2c151bd$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $2mDFn.default)(obj, (0, $gyNYk.default)(attrs));
}

});

parcelRegister("gVpd2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5258640f2aa0f3b$export$2e2bcd8739ae039);

var $kESAN = parcelRequire("kESAN");

var $a1tWb = parcelRequire("a1tWb");

var $cmfAU = parcelRequire("cmfAU");

var $k08ZD = parcelRequire("k08ZD");
function $c5258640f2aa0f3b$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $kESAN.default)(obj) ? obj : (0, $a1tWb.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $cmfAU.default)(iteratee, context);
        (0, $k08ZD.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("VITl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad82582e4d2e4fc$export$2e2bcd8739ae039);

var $kESAN = parcelRequire("kESAN");

var $a1tWb = parcelRequire("a1tWb");

var $cmfAU = parcelRequire("cmfAU");

var $k08ZD = parcelRequire("k08ZD");
function $0ad82582e4d2e4fc$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $kESAN.default)(obj) ? obj : (0, $a1tWb.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $cmfAU.default)(iteratee, context);
        (0, $k08ZD.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("dkK7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b50ea7eeb7eb73b$export$2e2bcd8739ae039);

var $a2b2M = parcelRequire("a2b2M");
function $9b50ea7eeb7eb73b$export$2e2bcd8739ae039(obj) {
    return (0, $a2b2M.default)(obj, Infinity);
}

});
parcelRegister("a2b2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e2a8611eb858d2$export$2e2bcd8739ae039);

var $kESAN = parcelRequire("kESAN");

var $a1tWb = parcelRequire("a1tWb");

var $giMod = parcelRequire("giMod");

var $97fU6 = parcelRequire("97fU6");

var $cAT6M = parcelRequire("cAT6M");
function $74e2a8611eb858d2$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $kESAN.default)(obj)) obj = (0, $a1tWb.default)(obj);
        return obj[(0, $97fU6.default)(obj.length - 1)];
    }
    var sample = (0, $cAT6M.default)(obj);
    var length = (0, $giMod.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $97fU6.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("cAT6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b398330f3fb78f$export$2e2bcd8739ae039);

var $hux9f = parcelRequire("hux9f");

var $0fogG = parcelRequire("0fogG");

var $eeGBh = parcelRequire("eeGBh");

var $kESAN = parcelRequire("kESAN");

var $e1hz7 = parcelRequire("e1hz7");

var $b3btC = parcelRequire("b3btC");

var $a1tWb = parcelRequire("a1tWb");
// Safely create a real, live array from anything iterable.
var $92b398330f3fb78f$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $92b398330f3fb78f$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $hux9f.default)(obj)) return (0, $0fogG.slice).call(obj);
    if ((0, $eeGBh.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($92b398330f3fb78f$var$reStrSymbol);
    if ((0, $kESAN.default)(obj)) return (0, $e1hz7.default)(obj, (0, $b3btC.default));
    return (0, $a1tWb.default)(obj);
}

});



parcelRegister("gAiTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c12ea9a5a95da39d$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $5KyAs = parcelRequire("5KyAs");

var $e1hz7 = parcelRequire("e1hz7");
function $c12ea9a5a95da39d$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $cmfAU.default)(iteratee, context);
    return (0, $5KyAs.default)((0, $e1hz7.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), 'value');
}

});

parcelRegister("bdh5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $829e2a70a6e38459$export$2e2bcd8739ae039);

var $791vf = parcelRequire("791vf");

var $lHkXO = parcelRequire("lHkXO");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$829e2a70a6e38459$export$2e2bcd8739ae039 = (0, $791vf.default)(function(result, value, key) {
    if ((0, $lHkXO.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("791vf", function(module, exports) {

$parcel$export(module.exports, "default", () => $533a8a2149808307$export$2e2bcd8739ae039);

var $cmfAU = parcelRequire("cmfAU");

var $k08ZD = parcelRequire("k08ZD");
function $533a8a2149808307$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $cmfAU.default)(iteratee, context);
        (0, $k08ZD.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("bSlRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a55b262de88236a$export$2e2bcd8739ae039);

var $791vf = parcelRequire("791vf");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$8a55b262de88236a$export$2e2bcd8739ae039 = (0, $791vf.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("5N48u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0116872bfec243f4$export$2e2bcd8739ae039);

var $791vf = parcelRequire("791vf");

var $lHkXO = parcelRequire("lHkXO");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$0116872bfec243f4$export$2e2bcd8739ae039 = (0, $791vf.default)(function(result, value, key) {
    if ((0, $lHkXO.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("4TODu", function(module, exports) {

$parcel$export(module.exports, "default", () => $391393b5443a762e$export$2e2bcd8739ae039);

var $791vf = parcelRequire("791vf");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$391393b5443a762e$export$2e2bcd8739ae039 = (0, $791vf.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("7B8AD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5882a6db3a781b53$export$2e2bcd8739ae039);

var $kESAN = parcelRequire("kESAN");

var $1rFsw = parcelRequire("1rFsw");
function $5882a6db3a781b53$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $kESAN.default)(obj) ? obj.length : (0, $1rFsw.default)(obj).length;
}

});

parcelRegister("9I9nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $711f7e919eb9f47f$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $atLoF = parcelRequire("atLoF");

var $a4GZa = parcelRequire("a4GZa");

var $aJjO9 = parcelRequire("aJjO9");

var $eaYQM = parcelRequire("eaYQM");

var $6vOl1 = parcelRequire("6vOl1");
var // Return a copy of the object only containing the allowed properties.
$711f7e919eb9f47f$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $atLoF.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $a4GZa.default)(iteratee, keys[1]);
        keys = (0, $aJjO9.default)(obj);
    } else {
        iteratee = (0, $eaYQM.default);
        keys = (0, $6vOl1.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("eaYQM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a52133745a3a12b4$export$2e2bcd8739ae039);
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $a52133745a3a12b4$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("4QNAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $38827b3f9f92bc8a$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $atLoF = parcelRequire("atLoF");

var $9yzrH = parcelRequire("9yzrH");

var $e1hz7 = parcelRequire("e1hz7");

var $6vOl1 = parcelRequire("6vOl1");

var $gKeEm = parcelRequire("gKeEm");

var $9I9nf = parcelRequire("9I9nf");
var // Return a copy of the object without the disallowed properties.
$38827b3f9f92bc8a$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $atLoF.default)(iteratee)) {
        iteratee = (0, $9yzrH.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $e1hz7.default)((0, $6vOl1.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $gKeEm.default)(keys, key);
        };
    }
    return (0, $9I9nf.default)(obj, iteratee, context);
});

});

parcelRegister("5wOr9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4067109f1d844384$export$2e2bcd8739ae039);

var $5g2xy = parcelRequire("5g2xy");
function $4067109f1d844384$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $5g2xy.default)(array, array.length - n);
}

});
parcelRegister("5g2xy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d406ac98849653c$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");
function $3d406ac98849653c$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $0fogG.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("1VINE", function(module, exports) {

$parcel$export(module.exports, "default", () => $167ddda286f603b5$export$2e2bcd8739ae039);

var $gai4j = parcelRequire("gai4j");
function $167ddda286f603b5$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $gai4j.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("gai4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc4b989026d3e002$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");
function $bc4b989026d3e002$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $0fogG.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("xDQNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0651feaa475db999$export$2e2bcd8739ae039);

var $2mDFn = parcelRequire("2mDFn");
function $0651feaa475db999$export$2e2bcd8739ae039(array) {
    return (0, $2mDFn.default)(array, Boolean);
}

});

parcelRegister("aBPI4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b95788ce13a9288$export$2e2bcd8739ae039);

var $6vOl1 = parcelRequire("6vOl1");
function $7b95788ce13a9288$export$2e2bcd8739ae039(array, depth) {
    return (0, $6vOl1.default)(array, depth, false);
}

});

parcelRegister("4iX6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3226b1491313edb0$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $3UQ7O = parcelRequire("3UQ7O");
var // Return a version of the array that does not contain the specified value(s).
$3226b1491313edb0$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(array, otherArrays) {
    return (0, $3UQ7O.default)(array, otherArrays);
});

});
parcelRegister("3UQ7O", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d9f08fa0449b94a$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $6vOl1 = parcelRequire("6vOl1");

var $2mDFn = parcelRequire("2mDFn");

var $gKeEm = parcelRequire("gKeEm");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$2d9f08fa0449b94a$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(array, rest) {
    rest = (0, $6vOl1.default)(rest, true, true);
    return (0, $2mDFn.default)(array, function(value) {
        return !(0, $gKeEm.default)(rest, value);
    });
});

});


parcelRegister("25WHZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $186996aa0da61cbf$export$2e2bcd8739ae039);

var $7Rbr4 = parcelRequire("7Rbr4");

var $cmfAU = parcelRequire("cmfAU");

var $giMod = parcelRequire("giMod");

var $gKeEm = parcelRequire("gKeEm");
function $186996aa0da61cbf$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $7Rbr4.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $cmfAU.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $giMod.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $gKeEm.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $gKeEm.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("8vDfc", function(module, exports) {

$parcel$export(module.exports, "default", () => $631fa912944bbfbb$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $25WHZ = parcelRequire("25WHZ");

var $6vOl1 = parcelRequire("6vOl1");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$631fa912944bbfbb$export$2e2bcd8739ae039 = (0, $9b4UF.default)(function(arrays) {
    return (0, $25WHZ.default)((0, $6vOl1.default)(arrays, true, true));
});

});

parcelRegister("cjA2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f73389c8d8152c8$export$2e2bcd8739ae039);

var $giMod = parcelRequire("giMod");

var $gKeEm = parcelRequire("gKeEm");
function $8f73389c8d8152c8$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $giMod.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $gKeEm.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $gKeEm.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("dLtZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a056ee9d102c8a30$export$2e2bcd8739ae039);

var $gVpd2 = parcelRequire("gVpd2");

var $giMod = parcelRequire("giMod");

var $5KyAs = parcelRequire("5KyAs");
function $a056ee9d102c8a30$export$2e2bcd8739ae039(array) {
    var length = array && (0, $gVpd2.default)(array, (0, $giMod.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $5KyAs.default)(array, index);
    return result;
}

});

parcelRegister("cI1un", function(module, exports) {

$parcel$export(module.exports, "default", () => $940abfc319184bc3$export$2e2bcd8739ae039);

var $9b4UF = parcelRequire("9b4UF");

var $dLtZM = parcelRequire("dLtZM");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$940abfc319184bc3$export$2e2bcd8739ae039 = (0, $9b4UF.default)((0, $dLtZM.default));

});

parcelRegister("kVaiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b11f2b686ad024$export$2e2bcd8739ae039);

var $giMod = parcelRequire("giMod");
function $f3b11f2b686ad024$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $giMod.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("koB8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed92dc433cfbc55f$export$2e2bcd8739ae039);
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $ed92dc433cfbc55f$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("2bQfI", function(module, exports) {

$parcel$export(module.exports, "default", () => $19852420dc100e65$export$2e2bcd8739ae039);

var $0fogG = parcelRequire("0fogG");
function $19852420dc100e65$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $0fogG.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("63AJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $468f839bc7d46a7c$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");

var $k08ZD = parcelRequire("k08ZD");

var $gmuuZ = parcelRequire("gmuuZ");

var $0fogG = parcelRequire("0fogG");

var $bKoev = parcelRequire("bKoev");
function $468f839bc7d46a7c$export$2e2bcd8739ae039(obj) {
    (0, $k08ZD.default)((0, $gmuuZ.default)(obj), function(name) {
        var func = (0, $9FCoE.default)[name] = obj[name];
        (0, $9FCoE.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $0fogG.push).apply(args, arguments);
            return (0, $bKoev.default)(this, func.apply((0, $9FCoE.default), args));
        };
    });
    return 0, $9FCoE.default;
}

});
parcelRegister("bKoev", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d6c9c3b9071b02$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");
function $88d6c9c3b9071b02$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $9FCoE.default)(obj).chain() : obj;
}

});


parcelRegister("eQt0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $acec6d2fb8e7735d$export$2e2bcd8739ae039);

var $9FCoE = parcelRequire("9FCoE");

var $k08ZD = parcelRequire("k08ZD");

var $0fogG = parcelRequire("0fogG");

var $bKoev = parcelRequire("bKoev");
// Add all mutator `Array` functions to the wrapper.
(0, $k08ZD.default)([
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
], function(name) {
    var method = (0, $0fogG.ArrayProto)[name];
    (0, $9FCoE.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        }
        return (0, $bKoev.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $k08ZD.default)([
    'concat',
    'join',
    'slice'
], function(name) {
    var method = (0, $0fogG.ArrayProto)[name];
    (0, $9FCoE.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $bKoev.default)(this, obj);
    };
});
var $acec6d2fb8e7735d$export$2e2bcd8739ae039 = (0, $9FCoE.default);

});




parcelRegister("i8QZx", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("jOKmh")).then(()=>parcelRequire('47dOU'));

});


parcelRegister("evyJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8fee68076382bf3$export$2e2bcd8739ae039);

var $iUSsr = parcelRequire("iUSsr");
var $a8fee68076382bf3$var$languageCode = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html").attr("lang");
var $a8fee68076382bf3$var$translations = {
    es: {
        "Please wait...": "Por favor espere...",
        "Uploading data ": "Subiendo datos ",
        Required: "Obligatorio",
        "File upload in progress. Are you sure you want to stop the file upload?": "Se esta subiendo un archivo. \xbfEsta seguro de querer detener esta operaci\xf3n?"
    },
    fr: {
        Required: "Obligatoire"
    }
};
/**
 * @short Translation function.
 *
 * It needs two preious init calls:
 *
 *  addTranslations(trans) - A dict like this {'es':{'hello':hola},'fr':{'hello':'alo'}},
 *                           may be called several times
 *
 *  setLanguageCode(code) - the language code, like 'es'
 *
 * Allows an arbitrary number of arguments that will replace (as Strings) the {{1}}, {{2}}, {{3}}...
 */ var $a8fee68076382bf3$var$_ = function() {
    //alert(languageCode)
    var s = arguments[0];
    ns = s;
    try {
        ns = $a8fee68076382bf3$var$translations[$a8fee68076382bf3$var$languageCode][s];
        if (!ns) ns = s;
    } catch (e) {
        ns = s;
    }
    // Now substitutions
    for(i = 1; i < arguments.length; i++)ns = ns.replace("{{" + i + "}}", String(arguments[i]));
    return ns;
};
$a8fee68076382bf3$var$_.setLanguageCode = function(code) {
    $a8fee68076382bf3$var$languageCode = code;
    $a8fee68076382bf3$var$_.languageCode = code;
};
$a8fee68076382bf3$var$_.addTranslations = function(trans) {
    for(var lang in trans){
        if (!$a8fee68076382bf3$var$translations[lang]) $a8fee68076382bf3$var$translations[lang] = {};
        for(var orig in trans[lang])$a8fee68076382bf3$var$translations[lang][orig] = trans[lang][orig];
    }
};
$a8fee68076382bf3$var$_.translations = $a8fee68076382bf3$var$translations;
var // 	_.changeLanguage = function(lang){
// 		$('#lang [name=language]').val(lang)
// 		$('#lang').submit()
// 	}
$a8fee68076382bf3$export$2e2bcd8739ae039 = $a8fee68076382bf3$var$_;

});

parcelRegister("aPbgY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7e1769576319b2e0$export$2e2bcd8739ae039);

var $6gih2 = parcelRequire("6gih2");
parcelRequire("khcvv");
parcelRequire("eZi9U");
parcelRequire("l6jOP");
parcelRequire("fiGBW");
parcelRequire("gxm1M");
parcelRequire("8DRDR");
parcelRequire("51KzB");
parcelRequire("43ggz");
parcelRequire("jSeXR");



window.$ = window.jQuery = (0, $6gih2.default);
var // utils.requireCSS("jquery-ui");
// utils.requireCSS("jquery-ui/themes/base/jquery-ui");
$7e1769576319b2e0$export$2e2bcd8739ae039 = (0, $6gih2.default);

});
parcelRegister("khcvv", function(module, exports) {
/*!
 * jQuery UI Widget 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: https://api.jqueryui.com/jQuery.widget/
//>>demos: https://jqueryui.com/widget/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    var widgetUuid = 0;
    var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
    var widgetSlice = Array.prototype.slice;
    $.cleanData = function(orig) {
        return function(elems) {
            var events, elem, i;
            for(i = 0; (elem = elems[i]) != null; i++){
                // Only trigger remove when necessary to save time
                events = $._data(elem, "events");
                if (events && events.remove) $(elem).triggerHandler("remove");
            }
            orig(elems);
        };
    }($.cleanData);
    $.widget = function(name, base, prototype) {
        var existingConstructor, constructor, basePrototype;
        // ProxiedPrototype allows the provided prototype to remain unmodified
        // so that it can be used as a mixin for multiple widgets (#8876)
        var proxiedPrototype = {};
        var namespace = name.split(".")[0];
        name = name.split(".")[1];
        if (name === "__proto__" || name === "constructor") return $.error("Invalid widget name: " + name);
        var fullName = namespace + "-" + name;
        if (!prototype) {
            prototype = base;
            base = $.Widget;
        }
        if (Array.isArray(prototype)) prototype = $.extend.apply(null, [
            {}
        ].concat(prototype));
        // Create selector for plugin
        $.expr.pseudos[fullName.toLowerCase()] = function(elem) {
            return !!$.data(elem, fullName);
        };
        $[namespace] = $[namespace] || {};
        existingConstructor = $[namespace][name];
        constructor = $[namespace][name] = function(options, element) {
            // Allow instantiation without "new" keyword
            if (!this || !this._createWidget) return new constructor(options, element);
            // Allow instantiation without initializing for simple inheritance
            // must use "new" keyword (the code above always passes args)
            if (arguments.length) this._createWidget(options, element);
        };
        // Extend with the existing constructor to carry over any static properties
        $.extend(constructor, existingConstructor, {
            version: prototype.version,
            // Copy the object used to create the prototype in case we need to
            // redefine the widget later
            _proto: $.extend({}, prototype),
            // Track widgets that inherit from this widget in case this widget is
            // redefined after a widget inherits from it
            _childConstructors: []
        });
        basePrototype = new base();
        // We need to make the options hash a property directly on the new instance
        // otherwise we'll modify the options hash on the prototype that we're
        // inheriting from
        basePrototype.options = $.widget.extend({}, basePrototype.options);
        $.each(prototype, function(prop, value) {
            if (typeof value !== "function") {
                proxiedPrototype[prop] = value;
                return;
            }
            proxiedPrototype[prop] = function() {
                function _super() {
                    return base.prototype[prop].apply(this, arguments);
                }
                function _superApply(args) {
                    return base.prototype[prop].apply(this, args);
                }
                return function() {
                    var __super = this._super;
                    var __superApply = this._superApply;
                    var returnValue;
                    this._super = _super;
                    this._superApply = _superApply;
                    returnValue = value.apply(this, arguments);
                    this._super = __super;
                    this._superApply = __superApply;
                    return returnValue;
                };
            }();
        });
        constructor.prototype = $.widget.extend(basePrototype, {
            // TODO: remove support for widgetEventPrefix
            // always use the name + a colon as the prefix, e.g., draggable:start
            // don't prefix for widgets that aren't DOM-based
            widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix || name : name
        }, proxiedPrototype, {
            constructor: constructor,
            namespace: namespace,
            widgetName: name,
            widgetFullName: fullName
        });
        // If this widget is being redefined then we need to find all widgets that
        // are inheriting from it and redefine all of them so that they inherit from
        // the new version of this widget. We're essentially trying to replace one
        // level in the prototype chain.
        if (existingConstructor) {
            $.each(existingConstructor._childConstructors, function(i, child) {
                var childPrototype = child.prototype;
                // Redefine the child widget using the same prototype that was
                // originally used, but inherit from the new version of the base
                $.widget(childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto);
            });
            // Remove the list of existing child constructors from the old constructor
            // so the old child constructors can be garbage collected
            delete existingConstructor._childConstructors;
        } else base._childConstructors.push(constructor);
        $.widget.bridge(name, constructor);
        return constructor;
    };
    $.widget.extend = function(target) {
        var input = widgetSlice.call(arguments, 1);
        var inputIndex = 0;
        var inputLength = input.length;
        var key;
        var value;
        for(; inputIndex < inputLength; inputIndex++)for(key in input[inputIndex]){
            value = input[inputIndex][key];
            if (widgetHasOwnProperty.call(input[inputIndex], key) && value !== undefined) {
                // Clone objects
                if ($.isPlainObject(value)) target[key] = $.isPlainObject(target[key]) ? $.widget.extend({}, target[key], value) : // Don't extend strings, arrays, etc. with objects
                $.widget.extend({}, value);
                else target[key] = value;
            }
        }
        return target;
    };
    $.widget.bridge = function(name, object) {
        var fullName = object.prototype.widgetFullName || name;
        $.fn[name] = function(options) {
            var isMethodCall = typeof options === "string";
            var args = widgetSlice.call(arguments, 1);
            var returnValue = this;
            if (isMethodCall) {
                // If this is an empty collection, we need to have the instance method
                // return undefined instead of the jQuery instance
                if (!this.length && options === "instance") returnValue = undefined;
                else this.each(function() {
                    var methodValue;
                    var instance = $.data(this, fullName);
                    if (options === "instance") {
                        returnValue = instance;
                        return false;
                    }
                    if (!instance) return $.error("cannot call methods on " + name + " prior to initialization; " + "attempted to call method '" + options + "'");
                    if (typeof instance[options] !== "function" || options.charAt(0) === "_") return $.error("no such method '" + options + "' for " + name + " widget instance");
                    methodValue = instance[options].apply(instance, args);
                    if (methodValue !== instance && methodValue !== undefined) {
                        returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
                        return false;
                    }
                });
            } else {
                // Allow multiple hashes to be passed on init
                if (args.length) options = $.widget.extend.apply(null, [
                    options
                ].concat(args));
                this.each(function() {
                    var instance = $.data(this, fullName);
                    if (instance) {
                        instance.option(options || {});
                        if (instance._init) instance._init();
                    } else $.data(this, fullName, new object(options, this));
                });
            }
            return returnValue;
        };
    };
    $.Widget = function() {};
    $.Widget._childConstructors = [];
    $.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
            classes: {},
            disabled: false,
            // Callbacks
            create: null
        },
        _createWidget: function(options, element) {
            element = $(element || this.defaultElement || this)[0];
            this.element = $(element);
            this.uuid = widgetUuid++;
            this.eventNamespace = "." + this.widgetName + this.uuid;
            this.bindings = $();
            this.hoverable = $();
            this.focusable = $();
            this.classesElementLookup = {};
            if (element !== this) {
                $.data(element, this.widgetFullName, this);
                this._on(true, this.element, {
                    remove: function(event) {
                        if (event.target === element) this.destroy();
                    }
                });
                this.document = $(element.style ? // Element within the document
                element.ownerDocument : // Element is window or document
                element.document || element);
                this.window = $(this.document[0].defaultView || this.document[0].parentWindow);
            }
            this.options = $.widget.extend({}, this.options, this._getCreateOptions(), options);
            this._create();
            if (this.options.disabled) this._setOptionDisabled(this.options.disabled);
            this._trigger("create", null, this._getCreateEventData());
            this._init();
        },
        _getCreateOptions: function() {
            return {};
        },
        _getCreateEventData: $.noop,
        _create: $.noop,
        _init: $.noop,
        destroy: function() {
            var that = this;
            this._destroy();
            $.each(this.classesElementLookup, function(key, value) {
                that._removeClass(value, key);
            });
            // We can probably remove the unbind calls in 2.0
            // all event bindings should go through this._on()
            this.element.off(this.eventNamespace).removeData(this.widgetFullName);
            this.widget().off(this.eventNamespace).removeAttr("aria-disabled");
            // Clean up events and states
            this.bindings.off(this.eventNamespace);
        },
        _destroy: $.noop,
        widget: function() {
            return this.element;
        },
        option: function(key, value) {
            var options = key;
            var parts;
            var curOption;
            var i;
            if (arguments.length === 0) // Don't return a reference to the internal hash
            return $.widget.extend({}, this.options);
            if (typeof key === "string") {
                // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
                options = {};
                parts = key.split(".");
                key = parts.shift();
                if (parts.length) {
                    curOption = options[key] = $.widget.extend({}, this.options[key]);
                    for(i = 0; i < parts.length - 1; i++){
                        curOption[parts[i]] = curOption[parts[i]] || {};
                        curOption = curOption[parts[i]];
                    }
                    key = parts.pop();
                    if (arguments.length === 1) return curOption[key] === undefined ? null : curOption[key];
                    curOption[key] = value;
                } else {
                    if (arguments.length === 1) return this.options[key] === undefined ? null : this.options[key];
                    options[key] = value;
                }
            }
            this._setOptions(options);
            return this;
        },
        _setOptions: function(options) {
            var key;
            for(key in options)this._setOption(key, options[key]);
            return this;
        },
        _setOption: function(key, value) {
            if (key === "classes") this._setOptionClasses(value);
            this.options[key] = value;
            if (key === "disabled") this._setOptionDisabled(value);
            return this;
        },
        _setOptionClasses: function(value) {
            var classKey, elements, currentElements;
            for(classKey in value){
                currentElements = this.classesElementLookup[classKey];
                if (value[classKey] === this.options.classes[classKey] || !currentElements || !currentElements.length) continue;
                // We are doing this to create a new jQuery object because the _removeClass() call
                // on the next line is going to destroy the reference to the current elements being
                // tracked. We need to save a copy of this collection so that we can add the new classes
                // below.
                elements = $(currentElements.get());
                this._removeClass(currentElements, classKey);
                // We don't use _addClass() here, because that uses this.options.classes
                // for generating the string of classes. We want to use the value passed in from
                // _setOption(), this is the new value of the classes option which was passed to
                // _setOption(). We pass this value directly to _classes().
                elements.addClass(this._classes({
                    element: elements,
                    keys: classKey,
                    classes: value,
                    add: true
                }));
            }
        },
        _setOptionDisabled: function(value) {
            this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!value);
            // If the widget is becoming disabled, then nothing is interactive
            if (value) {
                this._removeClass(this.hoverable, null, "ui-state-hover");
                this._removeClass(this.focusable, null, "ui-state-focus");
            }
        },
        enable: function() {
            return this._setOptions({
                disabled: false
            });
        },
        disable: function() {
            return this._setOptions({
                disabled: true
            });
        },
        _classes: function(options) {
            var full = [];
            var that = this;
            options = $.extend({
                element: this.element,
                classes: this.options.classes || {}
            }, options);
            function bindRemoveEvent() {
                var nodesToBind = [];
                options.element.each(function(_, element) {
                    var isTracked = $.map(that.classesElementLookup, function(elements) {
                        return elements;
                    }).some(function(elements) {
                        return elements.is(element);
                    });
                    if (!isTracked) nodesToBind.push(element);
                });
                that._on($(nodesToBind), {
                    remove: "_untrackClassesElement"
                });
            }
            function processClassString(classes, checkOption) {
                var current, i;
                for(i = 0; i < classes.length; i++){
                    current = that.classesElementLookup[classes[i]] || $();
                    if (options.add) {
                        bindRemoveEvent();
                        current = $($.uniqueSort(current.get().concat(options.element.get())));
                    } else current = $(current.not(options.element).get());
                    that.classesElementLookup[classes[i]] = current;
                    full.push(classes[i]);
                    if (checkOption && options.classes[classes[i]]) full.push(options.classes[classes[i]]);
                }
            }
            if (options.keys) processClassString(options.keys.match(/\S+/g) || [], true);
            if (options.extra) processClassString(options.extra.match(/\S+/g) || []);
            return full.join(" ");
        },
        _untrackClassesElement: function(event) {
            var that = this;
            $.each(that.classesElementLookup, function(key, value) {
                if ($.inArray(event.target, value) !== -1) that.classesElementLookup[key] = $(value.not(event.target).get());
            });
            this._off($(event.target));
        },
        _removeClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, false);
        },
        _addClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, true);
        },
        _toggleClass: function(element, keys, extra, add) {
            add = typeof add === "boolean" ? add : extra;
            var shift = typeof element === "string" || element === null, options = {
                extra: shift ? keys : extra,
                keys: shift ? element : keys,
                element: shift ? this.element : element,
                add: add
            };
            options.element.toggleClass(this._classes(options), add);
            return this;
        },
        _on: function(suppressDisabledCheck, element, handlers) {
            var delegateElement;
            var instance = this;
            // No suppressDisabledCheck flag, shuffle arguments
            if (typeof suppressDisabledCheck !== "boolean") {
                handlers = element;
                element = suppressDisabledCheck;
                suppressDisabledCheck = false;
            }
            // No element argument, shuffle and use this.element
            if (!handlers) {
                handlers = element;
                element = this.element;
                delegateElement = this.widget();
            } else {
                element = delegateElement = $(element);
                this.bindings = this.bindings.add(element);
            }
            $.each(handlers, function(event, handler) {
                function handlerProxy() {
                    // Allow widgets to customize the disabled handling
                    // - disabled as an array instead of boolean
                    // - disabled class as method for disabling individual parts
                    if (!suppressDisabledCheck && (instance.options.disabled === true || $(this).hasClass("ui-state-disabled"))) return;
                    return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
                }
                // Copy the guid so direct unbinding works
                if (typeof handler !== "string") handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $.guid++;
                var match = event.match(/^([\w:-]*)\s*(.*)$/);
                var eventName = match[1] + instance.eventNamespace;
                var selector = match[2];
                if (selector) delegateElement.on(eventName, selector, handlerProxy);
                else element.on(eventName, handlerProxy);
            });
        },
        _off: function(element, eventName) {
            eventName = (eventName || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace;
            element.off(eventName);
            // Clear the stack to avoid memory leaks (#10056)
            this.bindings = $(this.bindings.not(element).get());
            this.focusable = $(this.focusable.not(element).get());
            this.hoverable = $(this.hoverable.not(element).get());
        },
        _delay: function(handler, delay) {
            function handlerProxy() {
                return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
            }
            var instance = this;
            return setTimeout(handlerProxy, delay || 0);
        },
        _hoverable: function(element) {
            this.hoverable = this.hoverable.add(element);
            this._on(element, {
                mouseenter: function(event) {
                    this._addClass($(event.currentTarget), null, "ui-state-hover");
                },
                mouseleave: function(event) {
                    this._removeClass($(event.currentTarget), null, "ui-state-hover");
                }
            });
        },
        _focusable: function(element) {
            this.focusable = this.focusable.add(element);
            this._on(element, {
                focusin: function(event) {
                    this._addClass($(event.currentTarget), null, "ui-state-focus");
                },
                focusout: function(event) {
                    this._removeClass($(event.currentTarget), null, "ui-state-focus");
                }
            });
        },
        _trigger: function(type, event, data) {
            var prop, orig;
            var callback = this.options[type];
            data = data || {};
            event = $.Event(event);
            event.type = (type === this.widgetEventPrefix ? type : this.widgetEventPrefix + type).toLowerCase();
            // The original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[0];
            // Copy original event properties over to the new event
            orig = event.originalEvent;
            if (orig) {
                for(prop in orig)if (!(prop in event)) event[prop] = orig[prop];
            }
            this.element.trigger(event, data);
            return !(typeof callback === "function" && callback.apply(this.element[0], [
                event
            ].concat(data)) === false || event.isDefaultPrevented());
        }
    };
    $.each({
        show: "fadeIn",
        hide: "fadeOut"
    }, function(method, defaultEffect) {
        $.Widget.prototype["_" + method] = function(element, options, callback) {
            if (typeof options === "string") options = {
                effect: options
            };
            var hasOptions;
            var effectName = !options ? method : options === true || typeof options === "number" ? defaultEffect : options.effect || defaultEffect;
            options = options || {};
            if (typeof options === "number") options = {
                duration: options
            };
            else if (options === true) options = {};
            hasOptions = !$.isEmptyObject(options);
            options.complete = callback;
            if (options.delay) element.delay(options.delay);
            if (hasOptions && $.effects && $.effects.effect[effectName]) element[method](options);
            else if (effectName !== method && element[effectName]) element[effectName](options.duration, options.easing, callback);
            else element.queue(function(next) {
                $(this)[method]();
                if (callback) callback.call(element[0]);
                next();
            });
        };
    });
    return $.widget;
});

});

parcelRegister("eZi9U", function(module, exports) {
/* eslint-disable max-len, camelcase */ /*!
 * jQuery UI Datepicker 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Datepicker
//>>group: Widgets
//>>description: Displays a calendar from an input or inline for selecting dates.
//>>docs: https://api.jqueryui.com/datepicker/
//>>demos: https://jqueryui.com/datepicker/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/datepicker.css
//>>css.theme: ../../themes/base/theme.css
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "../version",
        "../keycode"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    $.extend($.ui, {
        datepicker: {
            version: "1.14.1"
        }
    });
    var datepicker_instActive;
    function datepicker_getZindex(elem) {
        var position, value;
        while(elem.length && elem[0] !== document){
            // Ignore z-index if position is set to a value where z-index is ignored by the browser
            // This makes behavior of this function consistent across browsers
            // WebKit always returns auto if the element is positioned
            position = elem.css("position");
            if (position === "absolute" || position === "relative" || position === "fixed") {
                // IE returns 0 when zIndex is not specified
                // other browsers return a string
                // we ignore the case of nested elements with an explicit value of 0
                // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
                value = parseInt(elem.css("zIndex"), 10);
                if (!isNaN(value) && value !== 0) return value;
            }
            elem = elem.parent();
        }
        return 0;
    }
    /* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */ function Datepicker() {
        this._curInst = null; // The current instance in use
        this._keyEvent = false; // If the last event was a key event
        this._disabledInputs = []; // List of date picker inputs that have been disabled
        this._datepickerShowing = false; // True if the popup picker is showing , false if not
        this._inDialog = false; // True if showing within a "dialog", false if not
        this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
        this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
        this._appendClass = "ui-datepicker-append"; // The name of the append marker class
        this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
        this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
        this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
        this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
        this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
        this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
        this.regional = []; // Available regional settings, indexed by language code
        this.regional[""] = {
            closeText: "Done",
            prevText: "Prev",
            nextText: "Next",
            currentText: "Today",
            monthNames: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            monthNamesShort: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            dayNames: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            dayNamesShort: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            dayNamesMin: [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            weekHeader: "Wk",
            dateFormat: "mm/dd/yy",
            firstDay: 0,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: "",
            selectMonthLabel: "Select month",
            selectYearLabel: "Select year" // Invisible label for year selector
        };
        this._defaults = {
            showOn: "focus",
            // "button" for trigger button, or "both" for either
            showAnim: "fadeIn",
            showOptions: {},
            defaultDate: null,
            // +/-number for offset from today, null for today
            appendText: "",
            buttonText: "...",
            buttonImage: "",
            buttonImageOnly: false,
            hideIfNoPrevNext: false,
            // if not applicable, false to just disable them
            navigationAsDateFormat: false,
            gotoCurrent: false,
            changeMonth: false,
            changeYear: false,
            yearRange: "c-10:c+10",
            // either relative to today's year (-nn:+nn), relative to currently displayed year
            // (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
            showOtherMonths: false,
            selectOtherMonths: false,
            showWeek: false,
            calculateWeek: this.iso8601Week,
            // takes a Date and returns the number of the week for it
            shortYearCutoff: "+10",
            // > this are in the previous century,
            // string value starting with "+" for current year + value
            minDate: null,
            maxDate: null,
            duration: "fast",
            beforeShowDay: null,
            // [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
            // [2] = cell title (optional), e.g. $.datepicker.noWeekends
            beforeShow: null,
            // returns a set of custom settings for the date picker
            onSelect: null,
            onChangeMonthYear: null,
            onClose: null,
            onUpdateDatepicker: null,
            numberOfMonths: 1,
            showCurrentAtPos: 0,
            stepMonths: 1,
            stepBigMonths: 12,
            altField: "",
            altFormat: "",
            constrainInput: true,
            showButtonPanel: false,
            autoSize: false,
            disabled: false // The initial disabled state
        };
        $.extend(this._defaults, this.regional[""]);
        this.regional.en = $.extend(true, {}, this.regional[""]);
        this.regional["en-US"] = $.extend(true, {}, this.regional.en);
        this.dpDiv = datepicker_bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
    }
    $.extend(Datepicker.prototype, {
        /* Class name added to elements to indicate already configured with a date picker. */ markerClassName: "hasDatepicker",
        //Keep track of the maximum number of rows displayed (see #7043)
        maxRows: 4,
        // TODO rename to "widget" when switching to widget factory
        _widgetDatepicker: function() {
            return this.dpDiv;
        },
        /* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */ setDefaults: function(settings) {
            datepicker_extendRemove(this._defaults, settings || {});
            return this;
        },
        /* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */ _attachDatepicker: function(target, settings) {
            var nodeName, inline, inst;
            nodeName = target.nodeName.toLowerCase();
            inline = nodeName === "div" || nodeName === "span";
            if (!target.id) {
                this.uuid += 1;
                target.id = "dp" + this.uuid;
            }
            inst = this._newInst($(target), inline);
            inst.settings = $.extend({}, settings || {});
            if (nodeName === "input") this._connectDatepicker(target, inst);
            else if (inline) this._inlineDatepicker(target, inst);
        },
        /* Create a new instance object. */ _newInst: function(target, inline) {
            var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
            return {
                id: id,
                input: target,
                selectedDay: 0,
                selectedMonth: 0,
                selectedYear: 0,
                drawMonth: 0,
                drawYear: 0,
                inline: inline,
                dpDiv: !inline ? this.dpDiv : datepicker_bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))
            };
        },
        /* Attach the date picker to an input field. */ _connectDatepicker: function(target, inst) {
            var input = $(target);
            inst.append = $([]);
            inst.trigger = $([]);
            if (input.hasClass(this.markerClassName)) return;
            this._attachments(input, inst);
            input.addClass(this.markerClassName).on("keydown", this._doKeyDown).on("keypress", this._doKeyPress).on("keyup", this._doKeyUp);
            this._autoSize(inst);
            $.data(target, "datepicker", inst);
            //If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
            if (inst.settings.disabled) this._disableDatepicker(target);
        },
        /* Make attachments based on settings. */ _attachments: function(input, inst) {
            var showOn, buttonText, buttonImage, appendText = this._get(inst, "appendText"), isRTL = this._get(inst, "isRTL");
            if (inst.append) inst.append.remove();
            if (appendText) {
                inst.append = $("<span>").addClass(this._appendClass).text(appendText);
                input[isRTL ? "before" : "after"](inst.append);
            }
            input.off("focus", this._showDatepicker);
            if (inst.trigger) inst.trigger.remove();
            showOn = this._get(inst, "showOn");
            if (showOn === "focus" || showOn === "both") input.on("focus", this._showDatepicker);
            if (showOn === "button" || showOn === "both") {
                buttonText = this._get(inst, "buttonText");
                buttonImage = this._get(inst, "buttonImage");
                if (this._get(inst, "buttonImageOnly")) inst.trigger = $("<img>").addClass(this._triggerClass).attr({
                    src: buttonImage,
                    alt: buttonText,
                    title: buttonText
                });
                else {
                    inst.trigger = $("<button type='button'>").addClass(this._triggerClass);
                    if (buttonImage) inst.trigger.html($("<img>").attr({
                        src: buttonImage,
                        alt: buttonText,
                        title: buttonText
                    }));
                    else inst.trigger.text(buttonText);
                }
                input[isRTL ? "before" : "after"](inst.trigger);
                inst.trigger.on("click", function() {
                    if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) $.datepicker._hideDatepicker();
                    else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
                        $.datepicker._hideDatepicker();
                        $.datepicker._showDatepicker(input[0]);
                    } else $.datepicker._showDatepicker(input[0]);
                    return false;
                });
            }
        },
        /* Apply the maximum length for the date format. */ _autoSize: function(inst) {
            if (this._get(inst, "autoSize") && !inst.inline) {
                var findMax, max, maxI, i, date = new Date(2009, 11, 20), dateFormat = this._get(inst, "dateFormat");
                if (dateFormat.match(/[DM]/)) {
                    findMax = function(names) {
                        max = 0;
                        maxI = 0;
                        for(i = 0; i < names.length; i++)if (names[i].length > max) {
                            max = names[i].length;
                            maxI = i;
                        }
                        return maxI;
                    };
                    date.setMonth(findMax(this._get(inst, dateFormat.match(/MM/) ? "monthNames" : "monthNamesShort")));
                    date.setDate(findMax(this._get(inst, dateFormat.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - date.getDay());
                }
                inst.input.attr("size", this._formatDate(inst, date).length);
            }
        },
        /* Attach an inline date picker to a div. */ _inlineDatepicker: function(target, inst) {
            var divSpan = $(target);
            if (divSpan.hasClass(this.markerClassName)) return;
            divSpan.addClass(this.markerClassName).append(inst.dpDiv);
            $.data(target, "datepicker", inst);
            this._setDate(inst, this._getDefaultDate(inst), true);
            this._updateDatepicker(inst);
            this._updateAlternate(inst);
            //If disabled option is true, disable the datepicker before showing it (see ticket #5665)
            if (inst.settings.disabled) this._disableDatepicker(target);
            // Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
            // https://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
            inst.dpDiv.css("display", "block");
        },
        /* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */ _dialogDatepicker: function(input, date, onSelect, settings, pos) {
            var id, browserWidth, browserHeight, scrollX, scrollY, inst = this._dialogInst; // internal instance
            if (!inst) {
                this.uuid += 1;
                id = "dp" + this.uuid;
                this._dialogInput = $("<input type='text' id='" + id + "' style='position: absolute; top: -100px; width: 0px;'/>");
                this._dialogInput.on("keydown", this._doKeyDown);
                $("body").append(this._dialogInput);
                inst = this._dialogInst = this._newInst(this._dialogInput, false);
                inst.settings = {};
                $.data(this._dialogInput[0], "datepicker", inst);
            }
            datepicker_extendRemove(inst.settings, settings || {});
            date = date && date.constructor === Date ? this._formatDate(inst, date) : date;
            this._dialogInput.val(date);
            this._pos = pos ? pos.length ? pos : [
                pos.pageX,
                pos.pageY
            ] : null;
            if (!this._pos) {
                browserWidth = document.documentElement.clientWidth;
                browserHeight = document.documentElement.clientHeight;
                scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
                scrollY = document.documentElement.scrollTop || document.body.scrollTop;
                this._pos = [
                    browserWidth / 2 - 100 + scrollX,
                    browserHeight / 2 - 150 + scrollY
                ];
            }
            // Move input on screen for focus, but hidden behind dialog
            this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px");
            inst.settings.onSelect = onSelect;
            this._inDialog = true;
            this.dpDiv.addClass(this._dialogClass);
            this._showDatepicker(this._dialogInput[0]);
            if ($.blockUI) $.blockUI(this.dpDiv);
            $.data(this._dialogInput[0], "datepicker", inst);
            return this;
        },
        /* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */ _destroyDatepicker: function(target) {
            var nodeName, $target = $(target), inst = $.data(target, "datepicker");
            if (!$target.hasClass(this.markerClassName)) return;
            nodeName = target.nodeName.toLowerCase();
            $.removeData(target, "datepicker");
            if (nodeName === "input") {
                inst.append.remove();
                inst.trigger.remove();
                $target.removeClass(this.markerClassName).off("focus", this._showDatepicker).off("keydown", this._doKeyDown).off("keypress", this._doKeyPress).off("keyup", this._doKeyUp);
            } else if (nodeName === "div" || nodeName === "span") $target.removeClass(this.markerClassName).empty();
            $.datepicker._hideDatepicker();
            if (datepicker_instActive === inst) {
                datepicker_instActive = null;
                this._curInst = null;
            }
        },
        /* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */ _enableDatepicker: function(target) {
            var nodeName, inline, $target = $(target), inst = $.data(target, "datepicker");
            if (!$target.hasClass(this.markerClassName)) return;
            nodeName = target.nodeName.toLowerCase();
            if (nodeName === "input") {
                target.disabled = false;
                inst.trigger.filter("button").each(function() {
                    this.disabled = false;
                }).end().filter("img").css({
                    opacity: "1.0",
                    cursor: ""
                });
            } else if (nodeName === "div" || nodeName === "span") {
                inline = $target.children("." + this._inlineClass);
                inline.children().removeClass("ui-state-disabled");
                inline.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", false);
            }
            this._disabledInputs = $.map(this._disabledInputs, // Delete entry
            function(value) {
                return value === target ? null : value;
            });
        },
        /* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */ _disableDatepicker: function(target) {
            var nodeName, inline, $target = $(target), inst = $.data(target, "datepicker");
            if (!$target.hasClass(this.markerClassName)) return;
            nodeName = target.nodeName.toLowerCase();
            if (nodeName === "input") {
                target.disabled = true;
                inst.trigger.filter("button").each(function() {
                    this.disabled = true;
                }).end().filter("img").css({
                    opacity: "0.5",
                    cursor: "default"
                });
            } else if (nodeName === "div" || nodeName === "span") {
                inline = $target.children("." + this._inlineClass);
                inline.children().addClass("ui-state-disabled");
                inline.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", true);
            }
            this._disabledInputs = $.map(this._disabledInputs, // Delete entry
            function(value) {
                return value === target ? null : value;
            });
            this._disabledInputs[this._disabledInputs.length] = target;
        },
        /* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */ _isDisabledDatepicker: function(target) {
            if (!target) return false;
            for(var i = 0; i < this._disabledInputs.length; i++){
                if (this._disabledInputs[i] === target) return true;
            }
            return false;
        },
        /* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */ _getInst: function(target) {
            try {
                return $.data(target, "datepicker");
            } catch (err) {
                throw "Missing instance data for this datepicker";
            }
        },
        /* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */ _optionDatepicker: function(target, name, value) {
            var settings, date, minDate, maxDate, inst = this._getInst(target);
            if (arguments.length === 2 && typeof name === "string") return name === "defaults" ? $.extend({}, $.datepicker._defaults) : inst ? name === "all" ? $.extend({}, inst.settings) : this._get(inst, name) : null;
            settings = name || {};
            if (typeof name === "string") {
                settings = {};
                settings[name] = value;
            }
            if (inst) {
                if (this._curInst === inst) this._hideDatepicker();
                date = this._getDateDatepicker(target, true);
                minDate = this._getMinMaxDate(inst, "min");
                maxDate = this._getMinMaxDate(inst, "max");
                datepicker_extendRemove(inst.settings, settings);
                // reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
                if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) inst.settings.minDate = this._formatDate(inst, minDate);
                if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) inst.settings.maxDate = this._formatDate(inst, maxDate);
                if ("disabled" in settings) {
                    if (settings.disabled) this._disableDatepicker(target);
                    else this._enableDatepicker(target);
                }
                this._attachments($(target), inst);
                this._autoSize(inst);
                this._setDate(inst, date);
                this._updateAlternate(inst);
                this._updateDatepicker(inst);
            }
        },
        // Change method deprecated
        _changeDatepicker: function(target, name, value) {
            this._optionDatepicker(target, name, value);
        },
        /* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */ _refreshDatepicker: function(target) {
            var inst = this._getInst(target);
            if (inst) this._updateDatepicker(inst);
        },
        /* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */ _setDateDatepicker: function(target, date) {
            var inst = this._getInst(target);
            if (inst) {
                this._setDate(inst, date);
                this._updateDatepicker(inst);
                this._updateAlternate(inst);
            }
        },
        /* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */ _getDateDatepicker: function(target, noDefault) {
            var inst = this._getInst(target);
            if (inst && !inst.inline) this._setDateFromField(inst, noDefault);
            return inst ? this._getDate(inst) : null;
        },
        /* Handle keystrokes. */ _doKeyDown: function(event) {
            var onSelect, dateStr, sel, inst = $.datepicker._getInst(event.target), handled = true, isRTL = inst.dpDiv.is(".ui-datepicker-rtl");
            inst._keyEvent = true;
            if ($.datepicker._datepickerShowing) switch(event.keyCode){
                case 9:
                    $.datepicker._hideDatepicker();
                    handled = false;
                    break; // hide on tab out
                case 13:
                    sel = $("td." + $.datepicker._dayOverClass + ":not(." + $.datepicker._currentClass + ")", inst.dpDiv);
                    if (sel[0]) $.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
                    onSelect = $.datepicker._get(inst, "onSelect");
                    if (onSelect) {
                        dateStr = $.datepicker._formatDate(inst);
                        // Trigger custom callback
                        onSelect.apply(inst.input ? inst.input[0] : null, [
                            dateStr,
                            inst
                        ]);
                    } else $.datepicker._hideDatepicker();
                    return false; // don't submit the form
                case 27:
                    $.datepicker._hideDatepicker();
                    break; // hide on escape
                case 33:
                    $.datepicker._adjustDate(event.target, event.ctrlKey ? -$.datepicker._get(inst, "stepBigMonths") : -$.datepicker._get(inst, "stepMonths"), "M");
                    break; // previous month/year on page up/+ ctrl
                case 34:
                    $.datepicker._adjustDate(event.target, event.ctrlKey ? +$.datepicker._get(inst, "stepBigMonths") : +$.datepicker._get(inst, "stepMonths"), "M");
                    break; // next month/year on page down/+ ctrl
                case 35:
                    if (event.ctrlKey || event.metaKey) $.datepicker._clearDate(event.target);
                    handled = event.ctrlKey || event.metaKey;
                    break; // clear on ctrl or command +end
                case 36:
                    if (event.ctrlKey || event.metaKey) $.datepicker._gotoToday(event.target);
                    handled = event.ctrlKey || event.metaKey;
                    break; // current on ctrl or command +home
                case 37:
                    if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, isRTL ? 1 : -1, "D");
                    handled = event.ctrlKey || event.metaKey;
                    // -1 day on ctrl or command +left
                    if (event.originalEvent.altKey) $.datepicker._adjustDate(event.target, event.ctrlKey ? -$.datepicker._get(inst, "stepBigMonths") : -$.datepicker._get(inst, "stepMonths"), "M");
                    break;
                case 38:
                    if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, -7, "D");
                    handled = event.ctrlKey || event.metaKey;
                    break; // -1 week on ctrl or command +up
                case 39:
                    if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, isRTL ? -1 : 1, "D");
                    handled = event.ctrlKey || event.metaKey;
                    // +1 day on ctrl or command +right
                    if (event.originalEvent.altKey) $.datepicker._adjustDate(event.target, event.ctrlKey ? +$.datepicker._get(inst, "stepBigMonths") : +$.datepicker._get(inst, "stepMonths"), "M");
                    break;
                case 40:
                    if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, 7, "D");
                    handled = event.ctrlKey || event.metaKey;
                    break; // +1 week on ctrl or command +down
                default:
                    handled = false;
            }
            else if (event.keyCode === 36 && event.ctrlKey) $.datepicker._showDatepicker(this);
            else handled = false;
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
            }
        },
        /* Filter entered characters - based on date format. */ _doKeyPress: function(event) {
            var chars, chr, inst = $.datepicker._getInst(event.target);
            if ($.datepicker._get(inst, "constrainInput")) {
                chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
                chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
                return event.ctrlKey || event.metaKey || chr < " " || !chars || chars.indexOf(chr) > -1;
            }
        },
        /* Synchronise manual entry and field/alternate field. */ _doKeyUp: function(event) {
            var date, inst = $.datepicker._getInst(event.target);
            if (inst.input.val() !== inst.lastVal) try {
                date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"), inst.input ? inst.input.val() : null, $.datepicker._getFormatConfig(inst));
                if (date) {
                    $.datepicker._setDateFromField(inst);
                    $.datepicker._updateAlternate(inst);
                    $.datepicker._updateDatepicker(inst);
                }
            } catch (err) {}
            return true;
        },
        /* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */ _showDatepicker: function(input) {
            input = input.target || input;
            if (input.nodeName.toLowerCase() !== "input") input = $("input", input.parentNode)[0];
            if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) return;
            var inst, beforeShow, beforeShowSettings, isFixed, offset, showAnim, duration;
            inst = $.datepicker._getInst(input);
            if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
                $.datepicker._curInst.dpDiv.stop(true, true);
                if (inst && $.datepicker._datepickerShowing) $.datepicker._hideDatepicker($.datepicker._curInst.input[0]);
            }
            beforeShow = $.datepicker._get(inst, "beforeShow");
            beforeShowSettings = beforeShow ? beforeShow.apply(input, [
                input,
                inst
            ]) : {};
            if (beforeShowSettings === false) return;
            datepicker_extendRemove(inst.settings, beforeShowSettings);
            inst.lastVal = null;
            $.datepicker._lastInput = input;
            $.datepicker._setDateFromField(inst);
            if ($.datepicker._inDialog) input.value = "";
            if (!$.datepicker._pos) {
                $.datepicker._pos = $.datepicker._findPos(input);
                $.datepicker._pos[1] += input.offsetHeight; // add the height
            }
            isFixed = false;
            $(input).parents().each(function() {
                isFixed |= $(this).css("position") === "fixed";
                return !isFixed;
            });
            offset = {
                left: $.datepicker._pos[0],
                top: $.datepicker._pos[1]
            };
            $.datepicker._pos = null;
            //to avoid flashes on Firefox
            inst.dpDiv.empty();
            // determine sizing offscreen
            inst.dpDiv.css({
                position: "absolute",
                display: "block",
                top: "-1000px"
            });
            $.datepicker._updateDatepicker(inst);
            // fix width for dynamic number of date pickers
            // and adjust position before showing
            offset = $.datepicker._checkOffset(inst, offset, isFixed);
            inst.dpDiv.css({
                position: $.datepicker._inDialog && $.blockUI ? "static" : isFixed ? "fixed" : "absolute",
                display: "none",
                left: offset.left + "px",
                top: offset.top + "px"
            });
            if (!inst.inline) {
                showAnim = $.datepicker._get(inst, "showAnim");
                duration = $.datepicker._get(inst, "duration");
                inst.dpDiv.css("z-index", datepicker_getZindex($(input)) + 1);
                $.datepicker._datepickerShowing = true;
                if ($.effects && $.effects.effect[showAnim]) inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
                else inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
                if ($.datepicker._shouldFocusInput(inst)) inst.input.trigger("focus");
                $.datepicker._curInst = inst;
            }
        },
        /* Generate the date picker content. */ _updateDatepicker: function(inst) {
            this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
            datepicker_instActive = inst; // for delegate hover events
            inst.dpDiv.empty().append(this._generateHTML(inst));
            this._attachHandlers(inst);
            var origyearshtml, numMonths = this._getNumberOfMonths(inst), cols = numMonths[1], width = 17, activeCell = inst.dpDiv.find("." + this._dayOverClass + " a"), onUpdateDatepicker = $.datepicker._get(inst, "onUpdateDatepicker");
            if (activeCell.length > 0) datepicker_handleMouseover.apply(activeCell.get(0));
            inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
            if (cols > 1) inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", width * cols + "em");
            inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") + "Class"]("ui-datepicker-multi");
            inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl");
            if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput(inst)) inst.input.trigger("focus");
            // Deffered render of the years select (to avoid flashes on Firefox)
            if (inst.yearshtml) {
                origyearshtml = inst.yearshtml;
                setTimeout(function() {
                    //assure that inst.yearshtml didn't change.
                    if (origyearshtml === inst.yearshtml && inst.yearshtml) inst.dpDiv.find("select.ui-datepicker-year").first().replaceWith(inst.yearshtml);
                    origyearshtml = inst.yearshtml = null;
                }, 0);
            }
            if (onUpdateDatepicker) onUpdateDatepicker.apply(inst.input ? inst.input[0] : null, [
                inst
            ]);
        },
        _shouldFocusInput: function(inst) {
            return inst.input && inst.input.is(":visible") && !inst.input.is(":disabled");
        },
        /* Check positioning to remain on screen. */ _checkOffset: function(inst, offset, isFixed) {
            var dpWidth = inst.dpDiv.outerWidth(), dpHeight = inst.dpDiv.outerHeight(), inputWidth = inst.input ? inst.input.outerWidth() : 0, inputHeight = inst.input ? inst.input.outerHeight() : 0, viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()), viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());
            offset.left -= this._get(inst, "isRTL") ? dpWidth - inputWidth : 0;
            offset.left -= isFixed && offset.left === inst.input.offset().left ? $(document).scrollLeft() : 0;
            offset.top -= isFixed && offset.top === inst.input.offset().top + inputHeight ? $(document).scrollTop() : 0;
            // Now check if datepicker is showing outside window viewport - move to a better place if so.
            offset.left -= Math.min(offset.left, offset.left + dpWidth > viewWidth && viewWidth > dpWidth ? Math.abs(offset.left + dpWidth - viewWidth) : 0);
            offset.top -= Math.min(offset.top, offset.top + dpHeight > viewHeight && viewHeight > dpHeight ? Math.abs(dpHeight + inputHeight) : 0);
            return offset;
        },
        /* Find an object's position on the screen. */ _findPos: function(obj) {
            var position, inst = this._getInst(obj), isRTL = this._get(inst, "isRTL");
            while(obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.pseudos.hidden(obj)))obj = obj[isRTL ? "previousSibling" : "nextSibling"];
            position = $(obj).offset();
            return [
                position.left,
                position.top
            ];
        },
        /* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */ _hideDatepicker: function(input) {
            var showAnim, duration, postProcess, onClose, inst = this._curInst;
            if (!inst || input && inst !== $.data(input, "datepicker")) return;
            if (this._datepickerShowing) {
                showAnim = this._get(inst, "showAnim");
                duration = this._get(inst, "duration");
                postProcess = function() {
                    $.datepicker._tidyDialog(inst);
                };
                if ($.effects && $.effects.effect[showAnim]) inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
                else inst.dpDiv[showAnim === "slideDown" ? "slideUp" : showAnim === "fadeIn" ? "fadeOut" : "hide"](showAnim ? duration : null, postProcess);
                if (!showAnim) postProcess();
                this._datepickerShowing = false;
                onClose = this._get(inst, "onClose");
                if (onClose) onClose.apply(inst.input ? inst.input[0] : null, [
                    inst.input ? inst.input.val() : "",
                    inst
                ]);
                this._lastInput = null;
                if (this._inDialog) {
                    this._dialogInput.css({
                        position: "absolute",
                        left: "0",
                        top: "-100px"
                    });
                    if ($.blockUI) {
                        $.unblockUI();
                        $("body").append(this.dpDiv);
                    }
                }
                this._inDialog = false;
            }
        },
        /* Tidy up after a dialog display. */ _tidyDialog: function(inst) {
            inst.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar");
        },
        /* Close date picker if clicked elsewhere. */ _checkExternalClick: function(event) {
            if (!$.datepicker._curInst) return;
            var $target = $(event.target), inst = $.datepicker._getInst($target[0]);
            if ($target[0].id !== $.datepicker._mainDivId && $target.parents("#" + $.datepicker._mainDivId).length === 0 && !$target.hasClass($.datepicker.markerClassName) && !$target.closest("." + $.datepicker._triggerClass).length && $.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) || $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst) $.datepicker._hideDatepicker();
        },
        /* Adjust one of the date sub-fields. */ _adjustDate: function(id, offset, period) {
            var target = $(id), inst = this._getInst(target[0]);
            if (this._isDisabledDatepicker(target[0])) return;
            this._adjustInstDate(inst, offset, period);
            this._updateDatepicker(inst);
        },
        /* Action for current link. */ _gotoToday: function(id) {
            var date, target = $(id), inst = this._getInst(target[0]);
            if (this._get(inst, "gotoCurrent") && inst.currentDay) {
                inst.selectedDay = inst.currentDay;
                inst.drawMonth = inst.selectedMonth = inst.currentMonth;
                inst.drawYear = inst.selectedYear = inst.currentYear;
            } else {
                date = new Date();
                inst.selectedDay = date.getDate();
                inst.drawMonth = inst.selectedMonth = date.getMonth();
                inst.drawYear = inst.selectedYear = date.getFullYear();
            }
            this._notifyChange(inst);
            this._adjustDate(target);
        },
        /* Action for selecting a new month/year. */ _selectMonthYear: function(id, select, period) {
            var target = $(id), inst = this._getInst(target[0]);
            inst["selected" + (period === "M" ? "Month" : "Year")] = inst["draw" + (period === "M" ? "Month" : "Year")] = parseInt(select.options[select.selectedIndex].value, 10);
            this._notifyChange(inst);
            this._adjustDate(target);
        },
        /* Action for selecting a day. */ _selectDay: function(id, month, year, td) {
            var inst, target = $(id);
            if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) return;
            inst = this._getInst(target[0]);
            inst.selectedDay = inst.currentDay = parseInt($("a", td).attr("data-date"));
            inst.selectedMonth = inst.currentMonth = month;
            inst.selectedYear = inst.currentYear = year;
            this._selectDate(id, this._formatDate(inst, inst.currentDay, inst.currentMonth, inst.currentYear));
        },
        /* Erase the input field and hide the date picker. */ _clearDate: function(id) {
            var target = $(id);
            this._selectDate(target, "");
        },
        /* Update the input field with the selected date. */ _selectDate: function(id, dateStr) {
            var onSelect, target = $(id), inst = this._getInst(target[0]);
            dateStr = dateStr != null ? dateStr : this._formatDate(inst);
            if (inst.input) inst.input.val(dateStr);
            this._updateAlternate(inst);
            onSelect = this._get(inst, "onSelect");
            if (onSelect) onSelect.apply(inst.input ? inst.input[0] : null, [
                dateStr,
                inst
            ]); // trigger custom callback
            else if (inst.input) inst.input.trigger("change"); // fire the change event
            if (inst.inline) this._updateDatepicker(inst);
            else {
                this._hideDatepicker();
                this._lastInput = inst.input[0];
                if (typeof inst.input[0] !== "object") inst.input.trigger("focus"); // restore focus
                this._lastInput = null;
            }
        },
        /* Update any alternate field to synchronise with the main field. */ _updateAlternate: function(inst) {
            var altFormat, date, dateStr, altField = this._get(inst, "altField");
            if (altField) {
                altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
                date = this._getDate(inst);
                dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
                $(document).find(altField).val(dateStr);
            }
        },
        /* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */ noWeekends: function(date) {
            var day = date.getDay();
            return [
                day > 0 && day < 6,
                ""
            ];
        },
        /* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */ iso8601Week: function(date) {
            var time, checkDate = new Date(date.getTime());
            // Find Thursday of this week starting on Monday
            checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
            time = checkDate.getTime();
            checkDate.setMonth(0); // Compare with Jan 1
            checkDate.setDate(1);
            return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
        },
        /* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */ parseDate: function(format, value, settings) {
            if (format == null || value == null) throw "Invalid arguments";
            value = typeof value === "object" ? value.toString() : value + "";
            if (value === "") return null;
            var iFormat, dim, extra, iValue = 0, shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff, shortYearCutoff = typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp : new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10), dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort, dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames, monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort, monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames, year = -1, month = -1, day = -1, doy = -1, literal = false, date, // Check whether a format character is doubled
            lookAhead = function(match) {
                var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
                if (matches) iFormat++;
                return matches;
            }, // Extract a number from the string value
            getNumber = function(match) {
                var isDoubled = lookAhead(match), size = match === "@" ? 14 : match === "!" ? 20 : match === "y" && isDoubled ? 4 : match === "o" ? 3 : 2, minSize = match === "y" ? size : 1, digits = new RegExp("^\\d{" + minSize + "," + size + "}"), num = value.substring(iValue).match(digits);
                if (!num) throw "Missing number at position " + iValue;
                iValue += num[0].length;
                return parseInt(num[0], 10);
            }, // Extract a name from the string value and convert to an index
            getName = function(match, shortNames, longNames) {
                var index = -1, names = $.map(lookAhead(match) ? longNames : shortNames, function(v, k) {
                    return [
                        [
                            k,
                            v
                        ]
                    ];
                }).sort(function(a, b) {
                    return -(a[1].length - b[1].length);
                });
                $.each(names, function(i, pair) {
                    var name = pair[1];
                    if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
                        index = pair[0];
                        iValue += name.length;
                        return false;
                    }
                });
                if (index !== -1) return index + 1;
                else throw "Unknown name at position " + iValue;
            }, // Confirm that a literal character matches the string value
            checkLiteral = function() {
                if (value.charAt(iValue) !== format.charAt(iFormat)) throw "Unexpected literal at position " + iValue;
                iValue++;
            };
            for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                else checkLiteral();
            } else switch(format.charAt(iFormat)){
                case "d":
                    day = getNumber("d");
                    break;
                case "D":
                    getName("D", dayNamesShort, dayNames);
                    break;
                case "o":
                    doy = getNumber("o");
                    break;
                case "m":
                    month = getNumber("m");
                    break;
                case "M":
                    month = getName("M", monthNamesShort, monthNames);
                    break;
                case "y":
                    year = getNumber("y");
                    break;
                case "@":
                    date = new Date(getNumber("@"));
                    year = date.getFullYear();
                    month = date.getMonth() + 1;
                    day = date.getDate();
                    break;
                case "!":
                    date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
                    year = date.getFullYear();
                    month = date.getMonth() + 1;
                    day = date.getDate();
                    break;
                case "'":
                    if (lookAhead("'")) checkLiteral();
                    else literal = true;
                    break;
                default:
                    checkLiteral();
            }
            if (iValue < value.length) {
                extra = value.substr(iValue);
                if (!/^\s+/.test(extra)) throw "Extra/unparsed characters found in date: " + extra;
            }
            if (year === -1) year = new Date().getFullYear();
            else if (year < 100) year += new Date().getFullYear() - new Date().getFullYear() % 100 + (year <= shortYearCutoff ? 0 : -100);
            if (doy > -1) {
                month = 1;
                day = doy;
                do {
                    dim = this._getDaysInMonth(year, month - 1);
                    if (day <= dim) break;
                    month++;
                    day -= dim;
                }while (true);
            }
            date = this._daylightSavingAdjust(new Date(year, month - 1, day));
            if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) throw "Invalid date"; // E.g. 31/02/00
            return date;
        },
        /* Standard date formats. */ ATOM: "yy-mm-dd",
        COOKIE: "D, dd M yy",
        ISO_8601: "yy-mm-dd",
        RFC_822: "D, d M y",
        RFC_850: "DD, dd-M-y",
        RFC_1036: "D, d M y",
        RFC_1123: "D, d M yy",
        RFC_2822: "D, d M yy",
        RSS: "D, d M y",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yy-mm-dd",
        _ticksTo1970: (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)) * 864000000000,
        /* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */ formatDate: function(format, date, settings) {
            if (!date) return "";
            var iFormat, dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort, dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames, monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort, monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames, // Check whether a format character is doubled
            lookAhead = function(match) {
                var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
                if (matches) iFormat++;
                return matches;
            }, // Format a number, with leading zero if necessary
            formatNumber = function(match, value, len) {
                var num = "" + value;
                if (lookAhead(match)) while(num.length < len)num = "0" + num;
                return num;
            }, // Format a name, short or long as requested
            formatName = function(match, value, shortNames, longNames) {
                return lookAhead(match) ? longNames[value] : shortNames[value];
            }, output = "", literal = false;
            if (date) {
                for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                    if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                    else output += format.charAt(iFormat);
                } else switch(format.charAt(iFormat)){
                    case "d":
                        output += formatNumber("d", date.getDate(), 2);
                        break;
                    case "D":
                        output += formatName("D", date.getDay(), dayNamesShort, dayNames);
                        break;
                    case "o":
                        output += formatNumber("o", Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
                        break;
                    case "m":
                        output += formatNumber("m", date.getMonth() + 1, 2);
                        break;
                    case "M":
                        output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
                        break;
                    case "y":
                        output += lookAhead("y") ? date.getFullYear() : (date.getFullYear() % 100 < 10 ? "0" : "") + date.getFullYear() % 100;
                        break;
                    case "@":
                        output += date.getTime();
                        break;
                    case "!":
                        output += date.getTime() * 10000 + this._ticksTo1970;
                        break;
                    case "'":
                        if (lookAhead("'")) output += "'";
                        else literal = true;
                        break;
                    default:
                        output += format.charAt(iFormat);
                }
            }
            return output;
        },
        /* Extract all possible characters from the date format. */ _possibleChars: function(format) {
            var iFormat, chars = "", literal = false, // Check whether a format character is doubled
            lookAhead = function(match) {
                var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
                if (matches) iFormat++;
                return matches;
            };
            for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                else chars += format.charAt(iFormat);
            } else switch(format.charAt(iFormat)){
                case "d":
                case "m":
                case "y":
                case "@":
                    chars += "0123456789";
                    break;
                case "D":
                case "M":
                    return null; // Accept anything
                case "'":
                    if (lookAhead("'")) chars += "'";
                    else literal = true;
                    break;
                default:
                    chars += format.charAt(iFormat);
            }
            return chars;
        },
        /* Get a setting value, defaulting if necessary. */ _get: function(inst, name) {
            return inst.settings[name] !== undefined ? inst.settings[name] : this._defaults[name];
        },
        /* Parse existing date and initialise date picker. */ _setDateFromField: function(inst, noDefault) {
            if (inst.input.val() === inst.lastVal) return;
            var dateFormat = this._get(inst, "dateFormat"), dates = inst.lastVal = inst.input ? inst.input.val() : null, defaultDate = this._getDefaultDate(inst), date = defaultDate, settings = this._getFormatConfig(inst);
            try {
                date = this.parseDate(dateFormat, dates, settings) || defaultDate;
            } catch (event) {
                dates = noDefault ? "" : dates;
            }
            inst.selectedDay = date.getDate();
            inst.drawMonth = inst.selectedMonth = date.getMonth();
            inst.drawYear = inst.selectedYear = date.getFullYear();
            inst.currentDay = dates ? date.getDate() : 0;
            inst.currentMonth = dates ? date.getMonth() : 0;
            inst.currentYear = dates ? date.getFullYear() : 0;
            this._adjustInstDate(inst);
        },
        /* Retrieve the default date shown on opening. */ _getDefaultDate: function(inst) {
            return this._restrictMinMax(inst, this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
        },
        /* A date may be specified as an exact value or a relative one. */ _determineDate: function(inst, date, defaultDate) {
            var offsetNumeric = function(offset) {
                var date = new Date();
                date.setDate(date.getDate() + offset);
                return date;
            }, offsetString = function(offset) {
                try {
                    return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"), offset, $.datepicker._getFormatConfig(inst));
                } catch (e) {
                // Ignore
                }
                var date = (offset.toLowerCase().match(/^c/) ? $.datepicker._getDate(inst) : null) || new Date(), year = date.getFullYear(), month = date.getMonth(), day = date.getDate(), pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, matches = pattern.exec(offset);
                while(matches){
                    switch(matches[2] || "d"){
                        case "d":
                        case "D":
                            day += parseInt(matches[1], 10);
                            break;
                        case "w":
                        case "W":
                            day += parseInt(matches[1], 10) * 7;
                            break;
                        case "m":
                        case "M":
                            month += parseInt(matches[1], 10);
                            day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
                            break;
                        case "y":
                        case "Y":
                            year += parseInt(matches[1], 10);
                            day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
                            break;
                    }
                    matches = pattern.exec(offset);
                }
                return new Date(year, month, day);
            }, newDate = date == null || date === "" ? defaultDate : typeof date === "string" ? offsetString(date) : typeof date === "number" ? isNaN(date) ? defaultDate : offsetNumeric(date) : new Date(date.getTime());
            newDate = newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate;
            if (newDate) {
                newDate.setHours(0);
                newDate.setMinutes(0);
                newDate.setSeconds(0);
                newDate.setMilliseconds(0);
            }
            return this._daylightSavingAdjust(newDate);
        },
        /* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */ _daylightSavingAdjust: function(date) {
            if (!date) return null;
            date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
            return date;
        },
        /* Set the date(s) directly. */ _setDate: function(inst, date, noChange) {
            var clear = !date, origMonth = inst.selectedMonth, origYear = inst.selectedYear, newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));
            inst.selectedDay = inst.currentDay = newDate.getDate();
            inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
            inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
            if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) this._notifyChange(inst);
            this._adjustInstDate(inst);
            if (inst.input) inst.input.val(clear ? "" : this._formatDate(inst));
        },
        /* Retrieve the date(s) directly. */ _getDate: function(inst) {
            var startDate = !inst.currentYear || inst.input && inst.input.val() === "" ? null : this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
            return startDate;
        },
        /* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */ _attachHandlers: function(inst) {
            var stepMonths = this._get(inst, "stepMonths"), id = "#" + inst.id.replace(/\\\\/g, "\\");
            inst.dpDiv.find("[data-handler]").map(function() {
                var handler = {
                    prev: function() {
                        $.datepicker._adjustDate(id, -stepMonths, "M");
                    },
                    next: function() {
                        $.datepicker._adjustDate(id, +stepMonths, "M");
                    },
                    hide: function() {
                        $.datepicker._hideDatepicker();
                    },
                    today: function() {
                        $.datepicker._gotoToday(id);
                    },
                    selectDay: function() {
                        $.datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
                        return false;
                    },
                    selectMonth: function() {
                        $.datepicker._selectMonthYear(id, this, "M");
                        return false;
                    },
                    selectYear: function() {
                        $.datepicker._selectMonthYear(id, this, "Y");
                        return false;
                    }
                };
                $(this).on(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
            });
        },
        /* Generate the HTML for the current state of the date picker. */ _generateHTML: function(inst) {
            var maxDraw, prevText, prev, nextText, next, currentText, gotoDate, controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin, monthNames, monthNamesShort, beforeShowDay, showOtherMonths, selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate, cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows, printDate, dRow, tbody, daySettings, otherMonth, unselectable, tempDate = new Date(), today = this._daylightSavingAdjust(new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())), isRTL = this._get(inst, "isRTL"), showButtonPanel = this._get(inst, "showButtonPanel"), hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"), navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"), numMonths = this._getNumberOfMonths(inst), showCurrentAtPos = this._get(inst, "showCurrentAtPos"), stepMonths = this._get(inst, "stepMonths"), isMultiMonth = numMonths[0] !== 1 || numMonths[1] !== 1, currentDate = this._daylightSavingAdjust(!inst.currentDay ? new Date(9999, 9, 9) : new Date(inst.currentYear, inst.currentMonth, inst.currentDay)), minDate = this._getMinMaxDate(inst, "min"), maxDate = this._getMinMaxDate(inst, "max"), drawMonth = inst.drawMonth - showCurrentAtPos, drawYear = inst.drawYear;
            if (drawMonth < 0) {
                drawMonth += 12;
                drawYear--;
            }
            if (maxDate) {
                maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(), maxDate.getMonth() - numMonths[0] * numMonths[1] + 1, maxDate.getDate()));
                maxDraw = minDate && maxDraw < minDate ? minDate : maxDraw;
                while(this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw){
                    drawMonth--;
                    if (drawMonth < 0) {
                        drawMonth = 11;
                        drawYear--;
                    }
                }
            }
            inst.drawMonth = drawMonth;
            inst.drawYear = drawYear;
            prevText = this._get(inst, "prevText");
            prevText = !navigationAsDateFormat ? prevText : this.formatDate(prevText, this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)), this._getFormatConfig(inst));
            if (this._canAdjustMonth(inst, -1, drawYear, drawMonth)) prev = $("<a>").attr({
                "class": "ui-datepicker-prev ui-corner-all",
                "data-handler": "prev",
                "data-event": "click",
                title: prevText
            }).append($("<span>").addClass("ui-icon ui-icon-circle-triangle-" + (isRTL ? "e" : "w")).text(prevText))[0].outerHTML;
            else if (hideIfNoPrevNext) prev = "";
            else prev = $("<a>").attr({
                "class": "ui-datepicker-prev ui-corner-all ui-state-disabled",
                title: prevText
            }).append($("<span>").addClass("ui-icon ui-icon-circle-triangle-" + (isRTL ? "e" : "w")).text(prevText))[0].outerHTML;
            nextText = this._get(inst, "nextText");
            nextText = !navigationAsDateFormat ? nextText : this.formatDate(nextText, this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)), this._getFormatConfig(inst));
            if (this._canAdjustMonth(inst, 1, drawYear, drawMonth)) next = $("<a>").attr({
                "class": "ui-datepicker-next ui-corner-all",
                "data-handler": "next",
                "data-event": "click",
                title: nextText
            }).append($("<span>").addClass("ui-icon ui-icon-circle-triangle-" + (isRTL ? "w" : "e")).text(nextText))[0].outerHTML;
            else if (hideIfNoPrevNext) next = "";
            else next = $("<a>").attr({
                "class": "ui-datepicker-next ui-corner-all ui-state-disabled",
                title: nextText
            }).append($("<span>").attr("class", "ui-icon ui-icon-circle-triangle-" + (isRTL ? "w" : "e")).text(nextText))[0].outerHTML;
            currentText = this._get(inst, "currentText");
            gotoDate = this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today;
            currentText = !navigationAsDateFormat ? currentText : this.formatDate(currentText, gotoDate, this._getFormatConfig(inst));
            controls = "";
            if (!inst.inline) controls = $("<button>").attr({
                type: "button",
                "class": "ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all",
                "data-handler": "hide",
                "data-event": "click"
            }).text(this._get(inst, "closeText"))[0].outerHTML;
            buttonPanel = "";
            if (showButtonPanel) buttonPanel = $("<div class='ui-datepicker-buttonpane ui-widget-content'>").append(isRTL ? controls : "").append(this._isInRange(inst, gotoDate) ? $("<button>").attr({
                type: "button",
                "class": "ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all",
                "data-handler": "today",
                "data-event": "click"
            }).text(currentText) : "").append(isRTL ? "" : controls)[0].outerHTML;
            firstDay = parseInt(this._get(inst, "firstDay"), 10);
            firstDay = isNaN(firstDay) ? 0 : firstDay;
            showWeek = this._get(inst, "showWeek");
            dayNames = this._get(inst, "dayNames");
            dayNamesMin = this._get(inst, "dayNamesMin");
            monthNames = this._get(inst, "monthNames");
            monthNamesShort = this._get(inst, "monthNamesShort");
            beforeShowDay = this._get(inst, "beforeShowDay");
            showOtherMonths = this._get(inst, "showOtherMonths");
            selectOtherMonths = this._get(inst, "selectOtherMonths");
            defaultDate = this._getDefaultDate(inst);
            html = "";
            for(row = 0; row < numMonths[0]; row++){
                group = "";
                this.maxRows = 4;
                for(col = 0; col < numMonths[1]; col++){
                    selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
                    cornerClass = " ui-corner-all";
                    calender = "";
                    if (isMultiMonth) {
                        calender += "<div class='ui-datepicker-group";
                        if (numMonths[1] > 1) switch(col){
                            case 0:
                                calender += " ui-datepicker-group-first";
                                cornerClass = " ui-corner-" + (isRTL ? "right" : "left");
                                break;
                            case numMonths[1] - 1:
                                calender += " ui-datepicker-group-last";
                                cornerClass = " ui-corner-" + (isRTL ? "left" : "right");
                                break;
                            default:
                                calender += " ui-datepicker-group-middle";
                                cornerClass = "";
                                break;
                        }
                        calender += "'>";
                    }
                    calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" + (/all|left/.test(cornerClass) && row === 0 ? isRTL ? next : prev : "") + (/all|right/.test(cornerClass) && row === 0 ? isRTL ? prev : next : "") + this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate, row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
                    "</div><table class='ui-datepicker-calendar'><thead>" + "<tr>";
                    thead = showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "";
                    for(dow = 0; dow < 7; dow++){
                        day = (dow + firstDay) % 7;
                        thead += "<th scope='col'" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" + "<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
                    }
                    calender += thead + "</tr></thead><tbody>";
                    daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
                    if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
                    leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
                    curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
                    numRows = isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows; //If multiple months, use the higher number of rows (see #7043)
                    this.maxRows = numRows;
                    printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
                    for(dRow = 0; dRow < numRows; dRow++){
                        calender += "<tr>";
                        tbody = !showWeek ? "" : "<td class='ui-datepicker-week-col'>" + this._get(inst, "calculateWeek")(printDate) + "</td>";
                        for(dow = 0; dow < 7; dow++){
                            daySettings = beforeShowDay ? beforeShowDay.apply(inst.input ? inst.input[0] : null, [
                                printDate
                            ]) : [
                                true,
                                ""
                            ];
                            otherMonth = printDate.getMonth() !== drawMonth;
                            unselectable = otherMonth && !selectOtherMonths || !daySettings[0] || minDate && printDate < minDate || maxDate && printDate > maxDate;
                            tbody += "<td class='" + ((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + // highlight weekends
                            (otherMonth ? " ui-datepicker-other-month" : "") + // highlight days from other months
                            (printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent || // user pressed key
                            defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ? // or defaultDate is current printedDate and defaultDate is selectedDate
                            " " + this._dayOverClass : "") + // highlight selected day
                            (unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "") + // highlight unselectable days
                            (otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + // highlight custom dates
                            (printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + // highlight selected day
                            (printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + // highlight today (if different)
                            ((!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + // cell title
                            (unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + // actions
                            (otherMonth && !showOtherMonths ? "&#xa0;" : unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" + (printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") + (printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + // highlight selected day
                            (otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
                            "' href='#' aria-current='" + (printDate.getTime() === currentDate.getTime() ? "true" : "false") + // mark date as selected for screen reader
                            "' data-date='" + printDate.getDate() + // store date as data
                            "'>" + printDate.getDate() + "</a>") + "</td>"; // display selectable date
                            printDate.setDate(printDate.getDate() + 1);
                            printDate = this._daylightSavingAdjust(printDate);
                        }
                        calender += tbody + "</tr>";
                    }
                    drawMonth++;
                    if (drawMonth > 11) {
                        drawMonth = 0;
                        drawYear++;
                    }
                    calender += "</tbody></table>" + (isMultiMonth ? "</div>" + (numMonths[0] > 0 && col === numMonths[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
                    group += calender;
                }
                html += group;
            }
            html += buttonPanel;
            inst._keyEvent = false;
            return html;
        },
        /* Generate the month and year header. */ _generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate, secondary, monthNames, monthNamesShort) {
            var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear, changeMonth = this._get(inst, "changeMonth"), changeYear = this._get(inst, "changeYear"), showMonthAfterYear = this._get(inst, "showMonthAfterYear"), selectMonthLabel = this._get(inst, "selectMonthLabel"), selectYearLabel = this._get(inst, "selectYearLabel"), html = "<div class='ui-datepicker-title'>", monthHtml = "";
            // Month selection
            if (secondary || !changeMonth) monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
            else {
                inMinYear = minDate && minDate.getFullYear() === drawYear;
                inMaxYear = maxDate && maxDate.getFullYear() === drawYear;
                monthHtml += "<select class='ui-datepicker-month' aria-label='" + selectMonthLabel + "' data-handler='selectMonth' data-event='change'>";
                for(month = 0; month < 12; month++)if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) monthHtml += "<option value='" + month + "'" + (month === drawMonth ? " selected='selected'" : "") + ">" + monthNamesShort[month] + "</option>";
                monthHtml += "</select>";
            }
            if (!showMonthAfterYear) html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
            // Year selection
            if (!inst.yearshtml) {
                inst.yearshtml = "";
                if (secondary || !changeYear) html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
                else {
                    // determine range of years to display
                    years = this._get(inst, "yearRange").split(":");
                    thisYear = new Date().getFullYear();
                    determineYear = function(value) {
                        var year = value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) : value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) : parseInt(value, 10);
                        return isNaN(year) ? thisYear : year;
                    };
                    year = determineYear(years[0]);
                    endYear = Math.max(year, determineYear(years[1] || ""));
                    year = minDate ? Math.max(year, minDate.getFullYear()) : year;
                    endYear = maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear;
                    inst.yearshtml += "<select class='ui-datepicker-year' aria-label='" + selectYearLabel + "' data-handler='selectYear' data-event='change'>";
                    for(; year <= endYear; year++)inst.yearshtml += "<option value='" + year + "'" + (year === drawYear ? " selected='selected'" : "") + ">" + year + "</option>";
                    inst.yearshtml += "</select>";
                    html += inst.yearshtml;
                    inst.yearshtml = null;
                }
            }
            html += this._get(inst, "yearSuffix");
            if (showMonthAfterYear) html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
            html += "</div>"; // Close datepicker_header
            return html;
        },
        /* Adjust one of the date sub-fields. */ _adjustInstDate: function(inst, offset, period) {
            var year = inst.selectedYear + (period === "Y" ? offset : 0), month = inst.selectedMonth + (period === "M" ? offset : 0), day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0), date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));
            inst.selectedDay = date.getDate();
            inst.drawMonth = inst.selectedMonth = date.getMonth();
            inst.drawYear = inst.selectedYear = date.getFullYear();
            if (period === "M" || period === "Y") this._notifyChange(inst);
        },
        /* Ensure a date is within any min/max bounds. */ _restrictMinMax: function(inst, date) {
            var minDate = this._getMinMaxDate(inst, "min"), maxDate = this._getMinMaxDate(inst, "max"), newDate = minDate && date < minDate ? minDate : date;
            return maxDate && newDate > maxDate ? maxDate : newDate;
        },
        /* Notify change of month/year. */ _notifyChange: function(inst) {
            var onChange = this._get(inst, "onChangeMonthYear");
            if (onChange) onChange.apply(inst.input ? inst.input[0] : null, [
                inst.selectedYear,
                inst.selectedMonth + 1,
                inst
            ]);
        },
        /* Determine the number of months to show. */ _getNumberOfMonths: function(inst) {
            var numMonths = this._get(inst, "numberOfMonths");
            return numMonths == null ? [
                1,
                1
            ] : typeof numMonths === "number" ? [
                1,
                numMonths
            ] : numMonths;
        },
        /* Determine the current maximum date - ensure no time components are set. */ _getMinMaxDate: function(inst, minMax) {
            return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
        },
        /* Find the number of days in a given month. */ _getDaysInMonth: function(year, month) {
            return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
        },
        /* Find the day of the week of the first of a month. */ _getFirstDayOfMonth: function(year, month) {
            return new Date(year, month, 1).getDay();
        },
        /* Determines if we should allow a "next/prev" month display change. */ _canAdjustMonth: function(inst, offset, curYear, curMonth) {
            var numMonths = this._getNumberOfMonths(inst), date = this._daylightSavingAdjust(new Date(curYear, curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));
            if (offset < 0) date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
            return this._isInRange(inst, date);
        },
        /* Is the given date in the accepted range? */ _isInRange: function(inst, date) {
            var yearSplit, currentYear, minDate = this._getMinMaxDate(inst, "min"), maxDate = this._getMinMaxDate(inst, "max"), minYear = null, maxYear = null, years = this._get(inst, "yearRange");
            if (years) {
                yearSplit = years.split(":");
                currentYear = new Date().getFullYear();
                minYear = parseInt(yearSplit[0], 10);
                maxYear = parseInt(yearSplit[1], 10);
                if (yearSplit[0].match(/[+\-].*/)) minYear += currentYear;
                if (yearSplit[1].match(/[+\-].*/)) maxYear += currentYear;
            }
            return (!minDate || date.getTime() >= minDate.getTime()) && (!maxDate || date.getTime() <= maxDate.getTime()) && (!minYear || date.getFullYear() >= minYear) && (!maxYear || date.getFullYear() <= maxYear);
        },
        /* Provide the configuration settings for formatting/parsing. */ _getFormatConfig: function(inst) {
            var shortYearCutoff = this._get(inst, "shortYearCutoff");
            shortYearCutoff = typeof shortYearCutoff !== "string" ? shortYearCutoff : new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10);
            return {
                shortYearCutoff: shortYearCutoff,
                dayNamesShort: this._get(inst, "dayNamesShort"),
                dayNames: this._get(inst, "dayNames"),
                monthNamesShort: this._get(inst, "monthNamesShort"),
                monthNames: this._get(inst, "monthNames")
            };
        },
        /* Format the given date for display. */ _formatDate: function(inst, day, month, year) {
            if (!day) {
                inst.currentDay = inst.selectedDay;
                inst.currentMonth = inst.selectedMonth;
                inst.currentYear = inst.selectedYear;
            }
            var date = day ? typeof day === "object" ? day : this._daylightSavingAdjust(new Date(year, month, day)) : this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
            return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
        }
    });
    /*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */ function datepicker_bindHover(dpDiv) {
        var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
        return dpDiv.on("mouseout", selector, function() {
            $(this).removeClass("ui-state-hover");
            if (this.className.indexOf("ui-datepicker-prev") !== -1) $(this).removeClass("ui-datepicker-prev-hover");
            if (this.className.indexOf("ui-datepicker-next") !== -1) $(this).removeClass("ui-datepicker-next-hover");
        }).on("mouseover", selector, datepicker_handleMouseover);
    }
    function datepicker_handleMouseover() {
        if (!$.datepicker._isDisabledDatepicker(datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[0] : datepicker_instActive.input[0])) {
            $(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
            $(this).addClass("ui-state-hover");
            if (this.className.indexOf("ui-datepicker-prev") !== -1) $(this).addClass("ui-datepicker-prev-hover");
            if (this.className.indexOf("ui-datepicker-next") !== -1) $(this).addClass("ui-datepicker-next-hover");
        }
    }
    /* jQuery extend now ignores nulls! */ function datepicker_extendRemove(target, props) {
        $.extend(target, props);
        for(var name in props)if (props[name] == null) target[name] = props[name];
        return target;
    }
    /* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */ $.fn.datepicker = function(options) {
        /* Verify an empty collection wasn't passed - Fixes #6976 */ if (!this.length) return this;
        /* Initialise the date picker. */ if (!$.datepicker.initialized) {
            $(document).on("mousedown", $.datepicker._checkExternalClick);
            $.datepicker.initialized = true;
        }
        /* Append datepicker main container to body if not exist. */ if ($("#" + $.datepicker._mainDivId).length === 0) $("body").append($.datepicker.dpDiv);
        var otherArgs = Array.prototype.slice.call(arguments, 1);
        if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) return $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [
            this[0]
        ].concat(otherArgs));
        if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") return $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [
            this[0]
        ].concat(otherArgs));
        return this.each(function() {
            if (typeof options === "string") $.datepicker["_" + options + "Datepicker"].apply($.datepicker, [
                this
            ].concat(otherArgs));
            else $.datepicker._attachDatepicker(this, options);
        });
    };
    $.datepicker = new Datepicker(); // singleton instance
    $.datepicker.initialized = false;
    $.datepicker.uuid = new Date().getTime();
    $.datepicker.version = "1.14.1";
    return $.datepicker;
});

});

parcelRegister("l6jOP", function(module, exports) {
/*!
 * jQuery UI Mouse 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: https://api.jqueryui.com/mouse/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    var mouseHandled = false;
    $(document).on("mouseup", function() {
        mouseHandled = false;
    });
    return $.widget("ui.mouse", {
        version: "1.14.1",
        options: {
            cancel: "input, textarea, button, select, option",
            distance: 1,
            delay: 0
        },
        _mouseInit: function() {
            var that = this;
            this.element.on("mousedown." + this.widgetName, function(event) {
                return that._mouseDown(event);
            }).on("click." + this.widgetName, function(event) {
                if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
                    $.removeData(event.target, that.widgetName + ".preventClickEvent");
                    event.stopImmediatePropagation();
                    return false;
                }
            });
            this.started = false;
        },
        // TODO: make sure destroying one instance of mouse doesn't mess with
        // other instances of mouse
        _mouseDestroy: function() {
            this.element.off("." + this.widgetName);
            if (this._mouseMoveDelegate) this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate);
        },
        _mouseDown: function(event) {
            // don't let more than one widget handle mouseStart
            if (mouseHandled) return;
            this._mouseMoved = false;
            // We may have missed mouseup (out of window)
            if (this._mouseStarted) this._mouseUp(event);
            this._mouseDownEvent = event;
            var that = this, btnIsLeft = event.which === 1, elIsCancel = typeof this.options.cancel === "string" ? $(event.target).closest(this.options.cancel).length : false;
            if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) return true;
            this.mouseDelayMet = !this.options.delay;
            if (!this.mouseDelayMet) this._mouseDelayTimer = setTimeout(function() {
                that.mouseDelayMet = true;
            }, this.options.delay);
            if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
                this._mouseStarted = this._mouseStart(event) !== false;
                if (!this._mouseStarted) {
                    event.preventDefault();
                    return true;
                }
            }
            // Click event may never have fired (Gecko & Opera)
            if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) $.removeData(event.target, this.widgetName + ".preventClickEvent");
            // These delegates are required to keep context
            this._mouseMoveDelegate = function(event) {
                return that._mouseMove(event);
            };
            this._mouseUpDelegate = function(event) {
                return that._mouseUp(event);
            };
            this.document.on("mousemove." + this.widgetName, this._mouseMoveDelegate).on("mouseup." + this.widgetName, this._mouseUpDelegate);
            event.preventDefault();
            mouseHandled = true;
            return true;
        },
        _mouseMove: function(event) {
            // Only check for mouseups outside the document if you've moved inside the document
            // at least once.
            if (this._mouseMoved && !event.which) {
                // Support: Safari <=8 - 9
                // Safari sets which to 0 if you press any of the following keys
                // during a drag (#14461)
                if (event.originalEvent.altKey || event.originalEvent.ctrlKey || event.originalEvent.metaKey || event.originalEvent.shiftKey) this.ignoreMissingWhich = true;
                else if (!this.ignoreMissingWhich) return this._mouseUp(event);
            }
            if (event.which || event.button) this._mouseMoved = true;
            if (this._mouseStarted) {
                this._mouseDrag(event);
                return event.preventDefault();
            }
            if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
                this._mouseStarted = this._mouseStart(this._mouseDownEvent, event) !== false;
                if (this._mouseStarted) this._mouseDrag(event);
                else this._mouseUp(event);
            }
            return !this._mouseStarted;
        },
        _mouseUp: function(event) {
            this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate);
            if (this._mouseStarted) {
                this._mouseStarted = false;
                if (event.target === this._mouseDownEvent.target) $.data(event.target, this.widgetName + ".preventClickEvent", true);
                this._mouseStop(event);
            }
            if (this._mouseDelayTimer) {
                clearTimeout(this._mouseDelayTimer);
                delete this._mouseDelayTimer;
            }
            this.ignoreMissingWhich = false;
            mouseHandled = false;
            event.preventDefault();
        },
        _mouseDistanceMet: function(event) {
            return Math.max(Math.abs(this._mouseDownEvent.pageX - event.pageX), Math.abs(this._mouseDownEvent.pageY - event.pageY)) >= this.options.distance;
        },
        _mouseDelayMet: function() {
            return this.mouseDelayMet;
        },
        // These are placeholder methods, to be overriden by extending plugin
        _mouseStart: function() {},
        _mouseDrag: function() {},
        _mouseStop: function() {},
        _mouseCapture: function() {
            return true;
        }
    });
});

});

parcelRegister("fiGBW", function(module, exports) {
/*!
 * jQuery UI Autocomplete 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: https://api.jqueryui.com/autocomplete/
//>>demos: https://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./menu",
        "../keycode",
        "../position",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    $.widget("ui.autocomplete", {
        version: "1.14.1",
        defaultElement: "<input>",
        options: {
            appendTo: null,
            autoFocus: false,
            delay: 300,
            minLength: 1,
            position: {
                my: "left top",
                at: "left bottom",
                collision: "none"
            },
            source: null,
            // Callbacks
            change: null,
            close: null,
            focus: null,
            open: null,
            response: null,
            search: null,
            select: null
        },
        requestIndex: 0,
        pending: 0,
        liveRegionTimer: null,
        _create: function() {
            // Some browsers only repeat keydown events, not keypress events,
            // so we use the suppressKeyPress flag to determine if we've already
            // handled the keydown event. #7269
            // Unfortunately the code for & in keypress is the same as the up arrow,
            // so we use the suppressKeyPressRepeat flag to avoid handling keypress
            // events when we know the keydown event was used to modify the
            // search term. #7799
            var suppressKeyPress, suppressKeyPressRepeat, suppressInput, nodeName = this.element[0].nodeName.toLowerCase(), isTextarea = nodeName === "textarea", isInput = nodeName === "input";
            // Textareas are always multi-line
            // Inputs are always single-line, even if inside a contentEditable element
            // All other element types are determined by whether they're contentEditable
            this.isMultiLine = isTextarea || !isInput && this.element.prop("contentEditable") === "true";
            this.valueMethod = this.element[isTextarea || isInput ? "val" : "text"];
            this.isNewMenu = true;
            this._addClass("ui-autocomplete-input");
            this.element.attr("autocomplete", "off");
            this._on(this.element, {
                keydown: function(event) {
                    if (this.element.prop("readOnly")) {
                        suppressKeyPress = true;
                        suppressInput = true;
                        suppressKeyPressRepeat = true;
                        return;
                    }
                    suppressKeyPress = false;
                    suppressInput = false;
                    suppressKeyPressRepeat = false;
                    var keyCode = $.ui.keyCode;
                    switch(event.keyCode){
                        case keyCode.PAGE_UP:
                            suppressKeyPress = true;
                            this._move("previousPage", event);
                            break;
                        case keyCode.PAGE_DOWN:
                            suppressKeyPress = true;
                            this._move("nextPage", event);
                            break;
                        case keyCode.UP:
                            suppressKeyPress = true;
                            this._keyEvent("previous", event);
                            break;
                        case keyCode.DOWN:
                            suppressKeyPress = true;
                            this._keyEvent("next", event);
                            break;
                        case keyCode.ENTER:
                            // when menu is open and has focus
                            if (this.menu.active) {
                                // #6055 - Opera still allows the keypress to occur
                                // which causes forms to submit
                                suppressKeyPress = true;
                                event.preventDefault();
                                this.menu.select(event);
                            }
                            break;
                        case keyCode.TAB:
                            if (this.menu.active) this.menu.select(event);
                            break;
                        case keyCode.ESCAPE:
                            if (this.menu.element.is(":visible")) {
                                if (!this.isMultiLine) this._value(this.term);
                                this.close(event);
                                // Different browsers have different default behavior for escape
                                // Single press can mean undo or clear
                                event.preventDefault();
                            }
                            break;
                        default:
                            suppressKeyPressRepeat = true;
                            // search timeout should be triggered before the input value is changed
                            this._searchTimeout(event);
                            break;
                    }
                },
                keypress: function(event) {
                    if (suppressKeyPress) {
                        suppressKeyPress = false;
                        if (!this.isMultiLine || this.menu.element.is(":visible")) event.preventDefault();
                        return;
                    }
                    if (suppressKeyPressRepeat) return;
                    // Replicate some key handlers to allow them to repeat in Firefox and Opera
                    var keyCode = $.ui.keyCode;
                    switch(event.keyCode){
                        case keyCode.PAGE_UP:
                            this._move("previousPage", event);
                            break;
                        case keyCode.PAGE_DOWN:
                            this._move("nextPage", event);
                            break;
                        case keyCode.UP:
                            this._keyEvent("previous", event);
                            break;
                        case keyCode.DOWN:
                            this._keyEvent("next", event);
                            break;
                    }
                },
                input: function(event) {
                    if (suppressInput) {
                        suppressInput = false;
                        event.preventDefault();
                        return;
                    }
                    this._searchTimeout(event);
                },
                focus: function() {
                    this.selectedItem = null;
                    this.previous = this._value();
                },
                blur: function(event) {
                    clearTimeout(this.searching);
                    this.close(event);
                    this._change(event);
                }
            });
            this._initSource();
            this.menu = $("<ul>").appendTo(this._appendTo()).menu({
                // disable ARIA support, the live region takes care of that
                role: null
            }).hide().menu("instance");
            this._addClass(this.menu.element, "ui-autocomplete", "ui-front");
            this._on(this.menu.element, {
                mousedown: function(event) {
                    // Prevent moving focus out of the text field
                    event.preventDefault();
                },
                menufocus: function(event, ui) {
                    var label, item;
                    // Support: Firefox
                    // Prevent accidental activation of menu items in Firefox (#7024 #9118)
                    if (this.isNewMenu) {
                        this.isNewMenu = false;
                        if (event.originalEvent && /^mouse/.test(event.originalEvent.type)) {
                            this.menu.blur();
                            this.document.one("mousemove", function() {
                                $(event.target).trigger(event.originalEvent);
                            });
                            return;
                        }
                    }
                    item = ui.item.data("ui-autocomplete-item");
                    if (false !== this._trigger("focus", event, {
                        item: item
                    })) // use value to match what will end up in the input, if it was a key event
                    {
                        if (event.originalEvent && /^key/.test(event.originalEvent.type)) this._value(item.value);
                    }
                    // Announce the value in the liveRegion
                    label = ui.item.attr("aria-label") || item.value;
                    if (label && String.prototype.trim.call(label).length) {
                        clearTimeout(this.liveRegionTimer);
                        this.liveRegionTimer = this._delay(function() {
                            this.liveRegion.html($("<div>").text(label));
                        }, 100);
                    }
                },
                menuselect: function(event, ui) {
                    var item = ui.item.data("ui-autocomplete-item"), previous = this.previous;
                    // Only trigger when focus was lost (click on menu)
                    if (this.element[0] !== this.document[0].activeElement) {
                        this.element.trigger("focus");
                        this.previous = previous;
                    }
                    if (false !== this._trigger("select", event, {
                        item: item
                    })) this._value(item.value);
                    // reset the term after the select event
                    // this allows custom select handling to work properly
                    this.term = this._value();
                    this.close(event);
                    this.selectedItem = item;
                }
            });
            this.liveRegion = $("<div>", {
                role: "status",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            }).appendTo(this.document[0].body);
            this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible");
            // Turning off autocomplete prevents the browser from remembering the
            // value when navigating through history, so we re-enable autocomplete
            // if the page is unloaded before the widget is destroyed. #7790
            this._on(this.window, {
                beforeunload: function() {
                    this.element.removeAttr("autocomplete");
                }
            });
        },
        _destroy: function() {
            clearTimeout(this.searching);
            this.element.removeAttr("autocomplete");
            this.menu.element.remove();
            this.liveRegion.remove();
        },
        _setOption: function(key, value) {
            this._super(key, value);
            if (key === "source") this._initSource();
            if (key === "appendTo") this.menu.element.appendTo(this._appendTo());
            if (key === "disabled" && value && this.xhr) this.xhr.abort();
        },
        _isEventTargetInWidget: function(event) {
            var menuElement = this.menu.element[0];
            return event.target === this.element[0] || event.target === menuElement || $.contains(menuElement, event.target);
        },
        _closeOnClickOutside: function(event) {
            if (!this._isEventTargetInWidget(event)) this.close();
        },
        _appendTo: function() {
            var element = this.options.appendTo;
            if (element) element = element.jquery || element.nodeType ? $(element) : this.document.find(element).eq(0);
            if (!element || !element[0]) element = this.element.closest(".ui-front, dialog");
            if (!element.length) element = this.document[0].body;
            return element;
        },
        _initSource: function() {
            var array, url, that = this;
            if (Array.isArray(this.options.source)) {
                array = this.options.source;
                this.source = function(request, response) {
                    response($.ui.autocomplete.filter(array, request.term));
                };
            } else if (typeof this.options.source === "string") {
                url = this.options.source;
                this.source = function(request, response) {
                    if (that.xhr) that.xhr.abort();
                    that.xhr = $.ajax({
                        url: url,
                        data: request,
                        dataType: "json",
                        success: function(data) {
                            response(data);
                        },
                        error: function() {
                            response([]);
                        }
                    });
                };
            } else this.source = this.options.source;
        },
        _searchTimeout: function(event) {
            clearTimeout(this.searching);
            this.searching = this._delay(function() {
                // Search if the value has changed, or if the user retypes the same value (see #7434)
                var equalValues = this.term === this._value(), menuVisible = this.menu.element.is(":visible"), modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
                if (!equalValues || equalValues && !menuVisible && !modifierKey) {
                    this.selectedItem = null;
                    this.search(null, event);
                }
            }, this.options.delay);
        },
        search: function(value, event) {
            value = value != null ? value : this._value();
            // Always save the actual value, not the one passed as an argument
            this.term = this._value();
            if (value.length < this.options.minLength) return this.close(event);
            if (this._trigger("search", event) === false) return;
            return this._search(value);
        },
        _search: function(value) {
            this.pending++;
            this._addClass("ui-autocomplete-loading");
            this.cancelSearch = false;
            this.source({
                term: value
            }, this._response());
        },
        _response: function() {
            var index = ++this.requestIndex;
            return (function(content) {
                if (index === this.requestIndex) this.__response(content);
                this.pending--;
                if (!this.pending) this._removeClass("ui-autocomplete-loading");
            }).bind(this);
        },
        __response: function(content) {
            if (content) content = this._normalize(content);
            this._trigger("response", null, {
                content: content
            });
            if (!this.options.disabled && content && content.length && !this.cancelSearch) {
                this._suggest(content);
                this._trigger("open");
            } else // use ._close() instead of .close() so we don't cancel future searches
            this._close();
        },
        close: function(event) {
            this.cancelSearch = true;
            this._close(event);
        },
        _close: function(event) {
            // Remove the handler that closes the menu on outside clicks
            this._off(this.document, "mousedown");
            if (this.menu.element.is(":visible")) {
                this.menu.element.hide();
                this.menu.blur();
                this.isNewMenu = true;
                this._trigger("close", event);
            }
        },
        _change: function(event) {
            if (this.previous !== this._value()) this._trigger("change", event, {
                item: this.selectedItem
            });
        },
        _normalize: function(items) {
            // assume all items have the right format when the first item is complete
            if (items.length && items[0].label && items[0].value) return items;
            return $.map(items, function(item) {
                if (typeof item === "string") return {
                    label: item,
                    value: item
                };
                return $.extend({}, item, {
                    label: item.label || item.value,
                    value: item.value || item.label
                });
            });
        },
        _suggest: function(items) {
            var ul = this.menu.element.empty();
            this._renderMenu(ul, items);
            this.isNewMenu = true;
            this.menu.refresh();
            // Size and position menu
            ul.show();
            this._resizeMenu();
            ul.position($.extend({
                of: this.element
            }, this.options.position));
            if (this.options.autoFocus) this.menu.next();
            // Listen for interactions outside of the widget (#6642)
            this._on(this.document, {
                mousedown: "_closeOnClickOutside"
            });
        },
        _resizeMenu: function() {
            var ul = this.menu.element;
            ul.outerWidth(Math.max(// Firefox wraps long text (possibly a rounding bug)
            // so we add 1px to avoid the wrapping (#7513)
            ul.width("").outerWidth() + 1, this.element.outerWidth()));
        },
        _renderMenu: function(ul, items) {
            var that = this;
            $.each(items, function(index, item) {
                that._renderItemData(ul, item);
            });
        },
        _renderItemData: function(ul, item) {
            return this._renderItem(ul, item).data("ui-autocomplete-item", item);
        },
        _renderItem: function(ul, item) {
            return $("<li>").append($("<div>").text(item.label)).appendTo(ul);
        },
        _move: function(direction, event) {
            if (!this.menu.element.is(":visible")) {
                this.search(null, event);
                return;
            }
            if (this.menu.isFirstItem() && /^previous/.test(direction) || this.menu.isLastItem() && /^next/.test(direction)) {
                if (!this.isMultiLine) this._value(this.term);
                this.menu.blur();
                return;
            }
            this.menu[direction](event);
        },
        widget: function() {
            return this.menu.element;
        },
        _value: function() {
            return this.valueMethod.apply(this.element, arguments);
        },
        _keyEvent: function(keyEvent, event) {
            if (!this.isMultiLine || this.menu.element.is(":visible")) {
                this._move(keyEvent, event);
                // Prevents moving cursor to beginning/end of the text field in some browsers
                event.preventDefault();
            }
        }
    });
    $.extend($.ui.autocomplete, {
        escapeRegex: function(value) {
            return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
        },
        filter: function(array, term) {
            var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");
            return $.grep(array, function(value) {
                return matcher.test(value.label || value.value || value);
            });
        }
    });
    // Live region extension, adding a `messages` option
    // NOTE: This is an experimental API. We are still investigating
    // a full solution for string manipulation and internationalization.
    $.widget("ui.autocomplete", $.ui.autocomplete, {
        options: {
            messages: {
                noResults: "No search results.",
                results: function(amount) {
                    return amount + (amount > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate.";
                }
            }
        },
        __response: function(content) {
            var message;
            this._superApply(arguments);
            if (this.options.disabled || this.cancelSearch) return;
            if (content && content.length) message = this.options.messages.results(content.length);
            else message = this.options.messages.noResults;
            clearTimeout(this.liveRegionTimer);
            this.liveRegionTimer = this._delay(function() {
                this.liveRegion.html($("<div>").text(message));
            }, 100);
        }
    });
    return $.ui.autocomplete;
});

});

parcelRegister("gxm1M", function(module, exports) {
/*!
 * jQuery UI Menu 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: https://api.jqueryui.com/menu/
//>>demos: https://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "../keycode",
        "../position",
        "../unique-id",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.widget("ui.menu", {
        version: "1.14.1",
        defaultElement: "<ul>",
        delay: 300,
        options: {
            icons: {
                submenu: "ui-icon-caret-1-e"
            },
            items: "> *",
            menus: "ul",
            position: {
                my: "left top",
                at: "right top"
            },
            role: "menu",
            // Callbacks
            blur: null,
            focus: null,
            select: null
        },
        _create: function() {
            this.activeMenu = this.element;
            // Flag used to prevent firing of the click handler
            // as the event bubbles up through nested menus
            this.mouseHandled = false;
            this.lastMousePosition = {
                x: null,
                y: null
            };
            this.element.uniqueId().attr({
                role: this.options.role,
                tabIndex: 0
            });
            this._addClass("ui-menu", "ui-widget ui-widget-content");
            this._on({
                // Prevent focus from sticking to links inside menu after clicking
                // them (focus should always stay on UL during navigation).
                "mousedown .ui-menu-item": function(event) {
                    event.preventDefault();
                    this._activateItem(event);
                },
                "click .ui-menu-item": function(event) {
                    var target = $(event.target);
                    var active = $(this.document[0].activeElement);
                    if (!this.mouseHandled && target.not(".ui-state-disabled").length) {
                        this.select(event);
                        // Only set the mouseHandled flag if the event will bubble, see #9469.
                        if (!event.isPropagationStopped()) this.mouseHandled = true;
                        // Open submenu on click
                        if (target.has(".ui-menu").length) this.expand(event);
                        else if (!this.element.is(":focus") && active.closest(".ui-menu").length) {
                            // Redirect focus to the menu
                            this.element.trigger("focus", [
                                true
                            ]);
                            // If the active item is on the top level, let it stay active.
                            // Otherwise, blur the active item since it is no longer visible.
                            if (this.active && this.active.parents(".ui-menu").length === 1) clearTimeout(this.timer);
                        }
                    }
                },
                "mouseenter .ui-menu-item": "_activateItem",
                "mousemove .ui-menu-item": "_activateItem",
                mouseleave: "collapseAll",
                "mouseleave .ui-menu": "collapseAll",
                focus: function(event, keepActiveItem) {
                    // If there's already an active item, keep it active
                    // If not, activate the first item
                    var item = this.active || this._menuItems().first();
                    if (!keepActiveItem) this.focus(event, item);
                },
                blur: function(event) {
                    this._delay(function() {
                        var notContained = !$.contains(this.element[0], this.document[0].activeElement);
                        if (notContained) this.collapseAll(event);
                    });
                },
                keydown: "_keydown"
            });
            this.refresh();
            // Clicks outside of a menu collapse any open menus
            this._on(this.document, {
                click: function(event) {
                    if (this._closeOnDocumentClick(event)) this.collapseAll(event, true);
                    // Reset the mouseHandled flag
                    this.mouseHandled = false;
                }
            });
        },
        _activateItem: function(event) {
            // Ignore mouse events while typeahead is active, see #10458.
            // Prevents focusing the wrong item when typeahead causes a scroll while the mouse
            // is over an item in the menu
            if (this.previousFilter) return;
            // If the mouse didn't actually move, but the page was scrolled, ignore the event (#9356)
            if (event.clientX === this.lastMousePosition.x && event.clientY === this.lastMousePosition.y) return;
            this.lastMousePosition = {
                x: event.clientX,
                y: event.clientY
            };
            var actualTarget = $(event.target).closest(".ui-menu-item"), target = $(event.currentTarget);
            // Ignore bubbled events on parent items, see #11641
            if (actualTarget[0] !== target[0]) return;
            // If the item is already active, there's nothing to do
            if (target.is(".ui-state-active")) return;
            // Remove ui-state-active class from siblings of the newly focused menu item
            // to avoid a jump caused by adjacent elements both having a class with a border
            this._removeClass(target.siblings().children(".ui-state-active"), null, "ui-state-active");
            this.focus(event, target);
        },
        _destroy: function() {
            var items = this.element.find(".ui-menu-item").removeAttr("role aria-disabled"), submenus = items.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");
            // Destroy (sub)menus
            this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show();
            submenus.children().each(function() {
                var elem = $(this);
                if (elem.data("ui-menu-submenu-caret")) elem.remove();
            });
        },
        _keydown: function(event) {
            var match, prev, character, skip, preventDefault = true;
            switch(event.keyCode){
                case $.ui.keyCode.PAGE_UP:
                    this.previousPage(event);
                    break;
                case $.ui.keyCode.PAGE_DOWN:
                    this.nextPage(event);
                    break;
                case $.ui.keyCode.HOME:
                    this._move("first", "first", event);
                    break;
                case $.ui.keyCode.END:
                    this._move("last", "last", event);
                    break;
                case $.ui.keyCode.UP:
                    this.previous(event);
                    break;
                case $.ui.keyCode.DOWN:
                    this.next(event);
                    break;
                case $.ui.keyCode.LEFT:
                    this.collapse(event);
                    break;
                case $.ui.keyCode.RIGHT:
                    if (this.active && !this.active.is(".ui-state-disabled")) this.expand(event);
                    break;
                case $.ui.keyCode.ENTER:
                case $.ui.keyCode.SPACE:
                    this._activate(event);
                    break;
                case $.ui.keyCode.ESCAPE:
                    this.collapse(event);
                    break;
                default:
                    preventDefault = false;
                    prev = this.previousFilter || "";
                    skip = false;
                    // Support number pad values
                    character = event.keyCode >= 96 && event.keyCode <= 105 ? (event.keyCode - 96).toString() : String.fromCharCode(event.keyCode);
                    clearTimeout(this.filterTimer);
                    if (character === prev) skip = true;
                    else character = prev + character;
                    match = this._filterMenuItems(character);
                    match = skip && match.index(this.active.next()) !== -1 ? this.active.nextAll(".ui-menu-item") : match;
                    // If no matches on the current filter, reset to the last character pressed
                    // to move down the menu to the first item that starts with that character
                    if (!match.length) {
                        character = String.fromCharCode(event.keyCode);
                        match = this._filterMenuItems(character);
                    }
                    if (match.length) {
                        this.focus(event, match);
                        this.previousFilter = character;
                        this.filterTimer = this._delay(function() {
                            delete this.previousFilter;
                        }, 1000);
                    } else delete this.previousFilter;
            }
            if (preventDefault) event.preventDefault();
        },
        _activate: function(event) {
            if (this.active && !this.active.is(".ui-state-disabled")) {
                if (this.active.children("[aria-haspopup='true']").length) this.expand(event);
                else this.select(event);
            }
        },
        refresh: function() {
            var menus, items, newSubmenus, newItems, newWrappers, that = this, icon = this.options.icons.submenu, submenus = this.element.find(this.options.menus);
            this._toggleClass("ui-menu-icons", null, !!this.element.find(".ui-icon").length);
            // Initialize nested menus
            newSubmenus = submenus.filter(":not(.ui-menu)").hide().attr({
                role: this.options.role,
                "aria-hidden": "true",
                "aria-expanded": "false"
            }).each(function() {
                var menu = $(this), item = menu.prev(), submenuCaret = $("<span>").data("ui-menu-submenu-caret", true);
                that._addClass(submenuCaret, "ui-menu-icon", "ui-icon " + icon);
                item.attr("aria-haspopup", "true").prepend(submenuCaret);
                menu.attr("aria-labelledby", item.attr("id"));
            });
            this._addClass(newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front");
            menus = submenus.add(this.element);
            items = menus.find(this.options.items);
            // Initialize menu-items containing spaces and/or dashes only as dividers
            items.not(".ui-menu-item").each(function() {
                var item = $(this);
                if (that._isDivider(item)) that._addClass(item, "ui-menu-divider", "ui-widget-content");
            });
            // Don't refresh list items that are already adapted
            newItems = items.not(".ui-menu-item, .ui-menu-divider");
            newWrappers = newItems.children().not(".ui-menu").uniqueId().attr({
                tabIndex: -1,
                role: this._itemRole()
            });
            this._addClass(newItems, "ui-menu-item")._addClass(newWrappers, "ui-menu-item-wrapper");
            // Add aria-disabled attribute to any disabled menu item
            items.filter(".ui-state-disabled").attr("aria-disabled", "true");
            // If the active item has been removed, blur the menu
            if (this.active && !$.contains(this.element[0], this.active[0])) this.blur();
        },
        _itemRole: function() {
            return ({
                menu: "menuitem",
                listbox: "option"
            })[this.options.role];
        },
        _setOption: function(key, value) {
            if (key === "icons") {
                var icons = this.element.find(".ui-menu-icon");
                this._removeClass(icons, null, this.options.icons.submenu)._addClass(icons, null, value.submenu);
            }
            this._super(key, value);
        },
        _setOptionDisabled: function(value) {
            this._super(value);
            this.element.attr("aria-disabled", String(value));
            this._toggleClass(null, "ui-state-disabled", !!value);
        },
        focus: function(event, item) {
            var nested, focused, activeParent;
            this.blur(event, event && event.type === "focus");
            this._scrollIntoView(item);
            this.active = item.first();
            focused = this.active.children(".ui-menu-item-wrapper");
            this._addClass(focused, null, "ui-state-active");
            // Only update aria-activedescendant if there's a role
            // otherwise we assume focus is managed elsewhere
            if (this.options.role) this.element.attr("aria-activedescendant", focused.attr("id"));
            // Highlight active parent menu item, if any
            activeParent = this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper");
            this._addClass(activeParent, null, "ui-state-active");
            if (event && event.type === "keydown") this._close();
            else this.timer = this._delay(function() {
                this._close();
            }, this.delay);
            nested = item.children(".ui-menu");
            if (nested.length && event && /^mouse/.test(event.type)) this._startOpening(nested);
            this.activeMenu = item.parent();
            this._trigger("focus", event, {
                item: item
            });
        },
        _scrollIntoView: function(item) {
            var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
            if (this._hasScroll()) {
                borderTop = parseFloat($.css(this.activeMenu[0], "borderTopWidth")) || 0;
                paddingTop = parseFloat($.css(this.activeMenu[0], "paddingTop")) || 0;
                offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
                scroll = this.activeMenu.scrollTop();
                elementHeight = this.activeMenu.height();
                itemHeight = item.outerHeight();
                if (offset < 0) this.activeMenu.scrollTop(scroll + offset);
                else if (offset + itemHeight > elementHeight) this.activeMenu.scrollTop(scroll + offset - elementHeight + itemHeight);
            }
        },
        blur: function(event, fromFocus) {
            if (!fromFocus) clearTimeout(this.timer);
            if (!this.active) return;
            this._removeClass(this.active.children(".ui-menu-item-wrapper"), null, "ui-state-active");
            this._trigger("blur", event, {
                item: this.active
            });
            this.active = null;
        },
        _startOpening: function(submenu) {
            clearTimeout(this.timer);
            // Don't open if already open fixes a Firefox bug that caused a .5 pixel
            // shift in the submenu position when mousing over the caret icon
            if (submenu.attr("aria-hidden") !== "true") return;
            this.timer = this._delay(function() {
                this._close();
                this._open(submenu);
            }, this.delay);
        },
        _open: function(submenu) {
            var position = $.extend({
                of: this.active
            }, this.options.position);
            clearTimeout(this.timer);
            this.element.find(".ui-menu").not(submenu.parents(".ui-menu")).hide().attr("aria-hidden", "true");
            submenu.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(position);
        },
        collapseAll: function(event, all) {
            clearTimeout(this.timer);
            this.timer = this._delay(function() {
                // If we were passed an event, look for the submenu that contains the event
                var currentMenu = all ? this.element : $(event && event.target).closest(this.element.find(".ui-menu"));
                // If we found no valid submenu ancestor, use the main menu to close all
                // sub menus anyway
                if (!currentMenu.length) currentMenu = this.element;
                this._close(currentMenu);
                this.blur(event);
                // Work around active item staying active after menu is blurred
                this._removeClass(currentMenu.find(".ui-state-active"), null, "ui-state-active");
                this.activeMenu = currentMenu;
            }, all ? 0 : this.delay);
        },
        // With no arguments, closes the currently active menu - if nothing is active
        // it closes all menus.  If passed an argument, it will search for menus BELOW
        _close: function(startMenu) {
            if (!startMenu) startMenu = this.active ? this.active.parent() : this.element;
            startMenu.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false");
        },
        _closeOnDocumentClick: function(event) {
            return !$(event.target).closest(".ui-menu").length;
        },
        _isDivider: function(item) {
            // Match hyphen, em dash, en dash
            return !/[^\-\u2014\u2013\s]/.test(item.text());
        },
        collapse: function(event) {
            var newItem = this.active && this.active.parent().closest(".ui-menu-item", this.element);
            if (newItem && newItem.length) {
                this._close();
                this.focus(event, newItem);
            }
        },
        expand: function(event) {
            var newItem = this.active && this._menuItems(this.active.children(".ui-menu")).first();
            if (newItem && newItem.length) {
                this._open(newItem.parent());
                // Delay so Firefox will not hide activedescendant change in expanding submenu from AT
                this._delay(function() {
                    this.focus(event, newItem);
                });
            }
        },
        next: function(event) {
            this._move("next", "first", event);
        },
        previous: function(event) {
            this._move("prev", "last", event);
        },
        isFirstItem: function() {
            return this.active && !this.active.prevAll(".ui-menu-item").length;
        },
        isLastItem: function() {
            return this.active && !this.active.nextAll(".ui-menu-item").length;
        },
        _menuItems: function(menu) {
            return (menu || this.element).find(this.options.items).filter(".ui-menu-item");
        },
        _move: function(direction, filter, event) {
            var next;
            if (this.active) {
                if (direction === "first" || direction === "last") next = this.active[direction === "first" ? "prevAll" : "nextAll"](".ui-menu-item").last();
                else next = this.active[direction + "All"](".ui-menu-item").first();
            }
            if (!next || !next.length || !this.active) next = this._menuItems(this.activeMenu)[filter]();
            this.focus(event, next);
        },
        nextPage: function(event) {
            var item, base, height;
            if (!this.active) {
                this.next(event);
                return;
            }
            if (this.isLastItem()) return;
            if (this._hasScroll()) {
                base = this.active.offset().top;
                height = this.element.innerHeight();
                // jQuery 3.2 doesn't include scrollbars in innerHeight, add it back.
                if ($.fn.jquery.indexOf("3.2.") === 0) height += this.element[0].offsetHeight - this.element.outerHeight();
                this.active.nextAll(".ui-menu-item").each(function() {
                    item = $(this);
                    return item.offset().top - base - height < 0;
                });
                this.focus(event, item);
            } else this.focus(event, this._menuItems(this.activeMenu)[!this.active ? "first" : "last"]());
        },
        previousPage: function(event) {
            var item, base, height;
            if (!this.active) {
                this.next(event);
                return;
            }
            if (this.isFirstItem()) return;
            if (this._hasScroll()) {
                base = this.active.offset().top;
                height = this.element.innerHeight();
                // jQuery 3.2 doesn't include scrollbars in innerHeight, add it back.
                if ($.fn.jquery.indexOf("3.2.") === 0) height += this.element[0].offsetHeight - this.element.outerHeight();
                this.active.prevAll(".ui-menu-item").each(function() {
                    item = $(this);
                    return item.offset().top - base + height > 0;
                });
                this.focus(event, item);
            } else this.focus(event, this._menuItems(this.activeMenu).first());
        },
        _hasScroll: function() {
            return this.element.outerHeight() < this.element.prop("scrollHeight");
        },
        select: function(event) {
            // TODO: It should never be possible to not have an active item at this
            // point, but the tests don't trigger mouseenter before click.
            this.active = this.active || $(event.target).closest(".ui-menu-item");
            var ui = {
                item: this.active
            };
            if (!this.active.has(".ui-menu").length) this.collapseAll(event, true);
            this._trigger("select", event, ui);
        },
        _filterMenuItems: function(character) {
            var escapedCharacter = character.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"), regex = new RegExp("^" + escapedCharacter, "i");
            return this.activeMenu.find(this.options.items)// Only match on items, not dividers or other content (#10571)
            .filter(".ui-menu-item").filter(function() {
                return regex.test(String.prototype.trim.call($(this).children(".ui-menu-item-wrapper").text()));
            });
        }
    });
});

});

parcelRegister("8DRDR", function(module, exports) {
/*!
 * jQuery UI Unique ID 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: https://api.jqueryui.com/uniqueId/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.fn.extend({
        uniqueId: function() {
            var uuid = 0;
            return function() {
                return this.each(function() {
                    if (!this.id) this.id = "ui-id-" + ++uuid;
                });
            };
        }(),
        removeUniqueId: function() {
            return this.each(function() {
                if (/^ui-id-\d+$/.test(this.id)) $(this).removeAttr("id");
            });
        }
    });
});

});

parcelRegister("51KzB", function(module, exports) {
/*!
 * jQuery UI Keycode 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: https://api.jqueryui.com/jQuery.ui.keyCode/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.ui.keyCode = {
        BACKSPACE: 8,
        COMMA: 188,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        LEFT: 37,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        PERIOD: 190,
        RIGHT: 39,
        SPACE: 32,
        TAB: 9,
        UP: 38
    };
});

});

parcelRegister("43ggz", function(module, exports) {
/*!
 * jQuery UI Position 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 * https://api.jqueryui.com/position/
 */ //>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: https://api.jqueryui.com/position/
//>>demos: https://jqueryui.com/position/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    (function() {
        var cachedScrollbarWidth, max = Math.max, abs = Math.abs, rhorizontal = /left|center|right/, rvertical = /top|center|bottom/, roffset = /[\+\-]\d+(\.[\d]+)?%?/, rposition = /^\w+/, rpercent = /%$/, _position = $.fn.position;
        function getOffsets(offsets, width, height) {
            return [
                parseFloat(offsets[0]) * (rpercent.test(offsets[0]) ? width / 100 : 1),
                parseFloat(offsets[1]) * (rpercent.test(offsets[1]) ? height / 100 : 1)
            ];
        }
        function parseCss(element, property) {
            return parseInt($.css(element, property), 10) || 0;
        }
        function isWindow(obj) {
            return obj != null && obj === obj.window;
        }
        function getDimensions(elem) {
            var raw = elem[0];
            if (raw.nodeType === 9) return {
                width: elem.width(),
                height: elem.height(),
                offset: {
                    top: 0,
                    left: 0
                }
            };
            if (isWindow(raw)) return {
                width: elem.width(),
                height: elem.height(),
                offset: {
                    top: elem.scrollTop(),
                    left: elem.scrollLeft()
                }
            };
            if (raw.preventDefault) return {
                width: 0,
                height: 0,
                offset: {
                    top: raw.pageY,
                    left: raw.pageX
                }
            };
            return {
                width: elem.outerWidth(),
                height: elem.outerHeight(),
                offset: elem.offset()
            };
        }
        $.position = {
            scrollbarWidth: function() {
                if (cachedScrollbarWidth !== undefined) return cachedScrollbarWidth;
                var w1, w2, div = $("<div style='display:block;position:absolute;width:200px;height:200px;overflow:hidden;'><div style='height:300px;width:auto;'></div></div>"), innerDiv = div.children()[0];
                $("body").append(div);
                w1 = innerDiv.offsetWidth;
                div.css("overflow", "scroll");
                w2 = innerDiv.offsetWidth;
                if (w1 === w2) w2 = div[0].clientWidth;
                div.remove();
                return cachedScrollbarWidth = w1 - w2;
            },
            getScrollInfo: function(within) {
                var overflowX = within.isWindow || within.isDocument ? "" : within.element.css("overflow-x"), overflowY = within.isWindow || within.isDocument ? "" : within.element.css("overflow-y"), hasOverflowX = overflowX === "scroll" || overflowX === "auto" && within.width < within.element[0].scrollWidth, hasOverflowY = overflowY === "scroll" || overflowY === "auto" && within.height < within.element[0].scrollHeight;
                return {
                    width: hasOverflowY ? $.position.scrollbarWidth() : 0,
                    height: hasOverflowX ? $.position.scrollbarWidth() : 0
                };
            },
            getWithinInfo: function(element) {
                var withinElement = $(element || window), isElemWindow = isWindow(withinElement[0]), isDocument = !!withinElement[0] && withinElement[0].nodeType === 9, hasOffset = !isElemWindow && !isDocument;
                return {
                    element: withinElement,
                    isWindow: isElemWindow,
                    isDocument: isDocument,
                    offset: hasOffset ? $(element).offset() : {
                        left: 0,
                        top: 0
                    },
                    scrollLeft: withinElement.scrollLeft(),
                    scrollTop: withinElement.scrollTop(),
                    width: withinElement.outerWidth(),
                    height: withinElement.outerHeight()
                };
            }
        };
        $.fn.position = function(options) {
            if (!options || !options.of) return _position.apply(this, arguments);
            // Make a copy, we don't want to modify arguments
            options = $.extend({}, options);
            var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions, // Make sure string options are treated as CSS selectors
            target = typeof options.of === "string" ? $(document).find(options.of) : $(options.of), within = $.position.getWithinInfo(options.within), scrollInfo = $.position.getScrollInfo(within), collision = (options.collision || "flip").split(" "), offsets = {};
            dimensions = getDimensions(target);
            if (target[0].preventDefault) // Force left top to allow flipping
            options.at = "left top";
            targetWidth = dimensions.width;
            targetHeight = dimensions.height;
            targetOffset = dimensions.offset;
            // Clone to reuse original targetOffset later
            basePosition = $.extend({}, targetOffset);
            // Force my and at to have valid horizontal and vertical positions
            // if a value is missing or invalid, it will be converted to center
            $.each([
                "my",
                "at"
            ], function() {
                var pos = (options[this] || "").split(" "), horizontalOffset, verticalOffset;
                if (pos.length === 1) pos = rhorizontal.test(pos[0]) ? pos.concat([
                    "center"
                ]) : rvertical.test(pos[0]) ? [
                    "center"
                ].concat(pos) : [
                    "center",
                    "center"
                ];
                pos[0] = rhorizontal.test(pos[0]) ? pos[0] : "center";
                pos[1] = rvertical.test(pos[1]) ? pos[1] : "center";
                // Calculate offsets
                horizontalOffset = roffset.exec(pos[0]);
                verticalOffset = roffset.exec(pos[1]);
                offsets[this] = [
                    horizontalOffset ? horizontalOffset[0] : 0,
                    verticalOffset ? verticalOffset[0] : 0
                ];
                // Reduce to just the positions without the offsets
                options[this] = [
                    rposition.exec(pos[0])[0],
                    rposition.exec(pos[1])[0]
                ];
            });
            // Normalize collision option
            if (collision.length === 1) collision[1] = collision[0];
            if (options.at[0] === "right") basePosition.left += targetWidth;
            else if (options.at[0] === "center") basePosition.left += targetWidth / 2;
            if (options.at[1] === "bottom") basePosition.top += targetHeight;
            else if (options.at[1] === "center") basePosition.top += targetHeight / 2;
            atOffset = getOffsets(offsets.at, targetWidth, targetHeight);
            basePosition.left += atOffset[0];
            basePosition.top += atOffset[1];
            return this.each(function() {
                var collisionPosition, using, elem = $(this), elemWidth = elem.outerWidth(), elemHeight = elem.outerHeight(), marginLeft = parseCss(this, "marginLeft"), marginTop = parseCss(this, "marginTop"), collisionWidth = elemWidth + marginLeft + parseCss(this, "marginRight") + scrollInfo.width, collisionHeight = elemHeight + marginTop + parseCss(this, "marginBottom") + scrollInfo.height, position = $.extend({}, basePosition), myOffset = getOffsets(offsets.my, elem.outerWidth(), elem.outerHeight());
                if (options.my[0] === "right") position.left -= elemWidth;
                else if (options.my[0] === "center") position.left -= elemWidth / 2;
                if (options.my[1] === "bottom") position.top -= elemHeight;
                else if (options.my[1] === "center") position.top -= elemHeight / 2;
                position.left += myOffset[0];
                position.top += myOffset[1];
                collisionPosition = {
                    marginLeft: marginLeft,
                    marginTop: marginTop
                };
                $.each([
                    "left",
                    "top"
                ], function(i, dir) {
                    if ($.ui.position[collision[i]]) $.ui.position[collision[i]][dir](position, {
                        targetWidth: targetWidth,
                        targetHeight: targetHeight,
                        elemWidth: elemWidth,
                        elemHeight: elemHeight,
                        collisionPosition: collisionPosition,
                        collisionWidth: collisionWidth,
                        collisionHeight: collisionHeight,
                        offset: [
                            atOffset[0] + myOffset[0],
                            atOffset[1] + myOffset[1]
                        ],
                        my: options.my,
                        at: options.at,
                        within: within,
                        elem: elem
                    });
                });
                if (options.using) // Adds feedback as second argument to using callback, if present
                using = function(props) {
                    var left = targetOffset.left - position.left, right = left + targetWidth - elemWidth, top = targetOffset.top - position.top, bottom = top + targetHeight - elemHeight, feedback = {
                        target: {
                            element: target,
                            left: targetOffset.left,
                            top: targetOffset.top,
                            width: targetWidth,
                            height: targetHeight
                        },
                        element: {
                            element: elem,
                            left: position.left,
                            top: position.top,
                            width: elemWidth,
                            height: elemHeight
                        },
                        horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                        vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
                    };
                    if (targetWidth < elemWidth && abs(left + right) < targetWidth) feedback.horizontal = "center";
                    if (targetHeight < elemHeight && abs(top + bottom) < targetHeight) feedback.vertical = "middle";
                    if (max(abs(left), abs(right)) > max(abs(top), abs(bottom))) feedback.important = "horizontal";
                    else feedback.important = "vertical";
                    options.using.call(this, props, feedback);
                };
                elem.offset($.extend(position, {
                    using: using
                }));
            });
        };
        $.ui.position = {
            fit: {
                left: function(position, data) {
                    var within = data.within, withinOffset = within.isWindow ? within.scrollLeft : within.offset.left, outerWidth = within.width, collisionPosLeft = position.left - data.collisionPosition.marginLeft, overLeft = withinOffset - collisionPosLeft, overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset, newOverRight;
                    // Element is wider than within
                    if (data.collisionWidth > outerWidth) {
                        // Element is initially over the left side of within
                        if (overLeft > 0 && overRight <= 0) {
                            newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
                            position.left += overLeft - newOverRight;
                        // Element is initially over right side of within
                        } else if (overRight > 0 && overLeft <= 0) position.left = withinOffset;
                        else if (overLeft > overRight) position.left = withinOffset + outerWidth - data.collisionWidth;
                        else position.left = withinOffset;
                    // Too far left -> align with left edge
                    } else if (overLeft > 0) position.left += overLeft;
                    else if (overRight > 0) position.left -= overRight;
                    else position.left = max(position.left - collisionPosLeft, position.left);
                },
                top: function(position, data) {
                    var within = data.within, withinOffset = within.isWindow ? within.scrollTop : within.offset.top, outerHeight = data.within.height, collisionPosTop = position.top - data.collisionPosition.marginTop, overTop = withinOffset - collisionPosTop, overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset, newOverBottom;
                    // Element is taller than within
                    if (data.collisionHeight > outerHeight) {
                        // Element is initially over the top of within
                        if (overTop > 0 && overBottom <= 0) {
                            newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
                            position.top += overTop - newOverBottom;
                        // Element is initially over bottom of within
                        } else if (overBottom > 0 && overTop <= 0) position.top = withinOffset;
                        else if (overTop > overBottom) position.top = withinOffset + outerHeight - data.collisionHeight;
                        else position.top = withinOffset;
                    // Too far up -> align with top
                    } else if (overTop > 0) position.top += overTop;
                    else if (overBottom > 0) position.top -= overBottom;
                    else position.top = max(position.top - collisionPosTop, position.top);
                }
            },
            flip: {
                left: function(position, data) {
                    var within = data.within, withinOffset = within.offset.left + within.scrollLeft, outerWidth = within.width, offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left, collisionPosLeft = position.left - data.collisionPosition.marginLeft, overLeft = collisionPosLeft - offsetLeft, overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft, myOffset = data.my[0] === "left" ? -data.elemWidth : data.my[0] === "right" ? data.elemWidth : 0, atOffset = data.at[0] === "left" ? data.targetWidth : data.at[0] === "right" ? -data.targetWidth : 0, offset = -2 * data.offset[0], newOverRight, newOverLeft;
                    if (overLeft < 0) {
                        newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
                        if (newOverRight < 0 || newOverRight < abs(overLeft)) position.left += myOffset + atOffset + offset;
                    } else if (overRight > 0) {
                        newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
                        if (newOverLeft > 0 || abs(newOverLeft) < overRight) position.left += myOffset + atOffset + offset;
                    }
                },
                top: function(position, data) {
                    var within = data.within, withinOffset = within.offset.top + within.scrollTop, outerHeight = within.height, offsetTop = within.isWindow ? within.scrollTop : within.offset.top, collisionPosTop = position.top - data.collisionPosition.marginTop, overTop = collisionPosTop - offsetTop, overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop, top = data.my[1] === "top", myOffset = top ? -data.elemHeight : data.my[1] === "bottom" ? data.elemHeight : 0, atOffset = data.at[1] === "top" ? data.targetHeight : data.at[1] === "bottom" ? -data.targetHeight : 0, offset = -2 * data.offset[1], newOverTop, newOverBottom;
                    if (overTop < 0) {
                        newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
                        if (newOverBottom < 0 || newOverBottom < abs(overTop)) position.top += myOffset + atOffset + offset;
                    } else if (overBottom > 0) {
                        newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
                        if (newOverTop > 0 || abs(newOverTop) < overBottom) position.top += myOffset + atOffset + offset;
                    }
                }
            },
            flipfit: {
                left: function() {
                    $.ui.position.flip.left.apply(this, arguments);
                    $.ui.position.fit.left.apply(this, arguments);
                },
                top: function() {
                    $.ui.position.flip.top.apply(this, arguments);
                    $.ui.position.fit.top.apply(this, arguments);
                }
            }
        };
    })();
    return $.ui.position;
});

});


parcelRegister("dV0v3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a220fc7dc1820378$export$2e2bcd8739ae039);
/**
 * Common datepicker initialization
 * Centralizes all datepicker default settings to ensure consistency
 * across the application. Ensures calendar starts on Monday.
 */ 
var $6gih2 = parcelRequire("6gih2");
function $a220fc7dc1820378$export$e22f8f81acfff186(options = {}) {
    // Check if jQuery UI datepicker is available
    if (typeof (0, $6gih2.default) === "undefined" || !(0, $6gih2.default).datepicker || !(0, $6gih2.default).datepicker.setDefaults) {
        // jQuery UI not loaded yet, try again later
        if (typeof window !== "undefined") setTimeout(()=>$a220fc7dc1820378$export$e22f8f81acfff186(options), 100);
        return;
    }
    let lang = options.lang;
    if (!lang) // Try to detect language from multiple sources
    {
        if (typeof window !== "undefined") {
            // Try settings module
            if (window.settings && window.settings.LANG) lang = window.settings.LANG;
            // Try trans module
            if (!lang && window._ && window._.languageCode) lang = window._.languageCode;
            // Try HTML lang attribute
            if (!lang && window.$) {
                const htmlLang = window.$("html").attr("lang");
                if (htmlLang) lang = htmlLang;
            }
            // Try meta tag
            if (!lang && window.$) {
                const metaLang = window.$("meta[http-equiv=content-language]").attr("content");
                if (metaLang) lang = metaLang;
            }
        }
    }
    // Normalize language code (e.g., "es-ES" -> "es", "es_MX" -> "es", "ES" -> "es")
    if (lang) lang = String(lang).split(/[-_]/)[0].toLowerCase();
    const yearRange = options.yearRange || "1900:2050";
    // Debug: log detected language (can be removed in production)
    if (typeof console !== "undefined" && console.log) console.log("[datepicker-init] Detected language:", lang || "default (en)");
    // Build the complete defaults object with all settings at once
    // This ensures all settings are applied together and prevents partial application
    const defaults = {
        changeMonth: true,
        changeYear: true,
        dateFormat: "yy-mm-dd",
        firstDay: 1,
        yearRange: yearRange,
        showButtonPanel: true
    };
    // Language-specific settings
    // IMPORTANT: dayNamesMin must always start with Sunday (index 0)
    // jQuery UI uses firstDay to determine which day to display first
    // With firstDay: 1 (Monday), it will show dayNamesMin[1] in the first column
    if (lang === "es") Object.assign(defaults, {
        monthNamesShort: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        // Day names: [Sunday, Monday, Tuesday, ...] - jQuery UI will use firstDay to show Monday first
        dayNamesMin: [
            "Do",
            "Lu",
            "Ma",
            "Mi",
            "Ju",
            "Vi",
            "S\xe1"
        ],
        closeText: "Hecho",
        currentText: "Hoy",
        nextText: "Siguiente",
        prevText: "Anterior"
    });
    else if (lang === "fr") Object.assign(defaults, {
        monthNamesShort: [
            "Jan",
            "F\xe9v",
            "Mar",
            "Avr",
            "Mai",
            "Jun",
            "Jul",
            "Ao\xfb",
            "Sep",
            "Oct",
            "Nov",
            "D\xe9c"
        ],
        // Day names: [Sunday, Monday, Tuesday, ...] - jQuery UI will use firstDay to show Monday first
        dayNamesMin: [
            "Di",
            "Lu",
            "Ma",
            "Me",
            "Je",
            "Ve",
            "Sa"
        ],
        closeText: "Finir",
        currentText: "Aujourd'hui",
        nextText: "Prochain",
        prevText: "Pr\xe9c\xe9dent"
    });
    else // Default English - day names starting with Sunday
    Object.assign(defaults, {
        dayNamesMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        closeText: "Done",
        currentText: "Today",
        nextText: "Next",
        prevText: "Previous"
    });
    // Apply all defaults in a single call
    (0, $6gih2.default).datepicker.setDefaults(defaults);
    // Verify settings were applied (debug only)
    if (typeof console !== "undefined" && console.log) {
        const currentDefaults = (0, $6gih2.default).datepicker._defaults;
        console.log("[datepicker-init] Applied settings:", {
            lang: lang || "default (en)",
            dayNamesMin: currentDefaults.dayNamesMin,
            closeText: currentDefaults.closeText,
            currentText: currentDefaults.currentText,
            nextText: currentDefaults.nextText,
            prevText: currentDefaults.prevText
        });
    }
}
var $a220fc7dc1820378$export$2e2bcd8739ae039 = $a220fc7dc1820378$export$e22f8f81acfff186;
// Make it globally available for inline scripts in templates
if (typeof window !== "undefined") window.initDatepickerDefaults = $a220fc7dc1820378$export$e22f8f81acfff186;

});


parcelRegister("44K3k", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("bmrA4")),
    (parcelRequire("lErZQ"))($parcel$resolve("6K6wt"))
]).then(()=>parcelRequire('aVveV'));

});

parcelRegister("8wRys", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("ib2Dl")).then(()=>parcelRequire('lvCS2'));

});

parcelRegister("bJzoA", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("9BIyr")).then(()=>parcelRequire('kzyPS'));

});

parcelRegister("aZgYx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ffcc4d5a09f63bd$export$2e2bcd8739ae039);

var $iUSsr = parcelRequire("iUSsr");

var $aXzbO = parcelRequire("aXzbO");
function $7ffcc4d5a09f63bd$export$2e2bcd8739ae039() {}
const $7ffcc4d5a09f63bd$var$is_mobile = /iPhone/i.test(navigator.userAgent) || /iPad/i.test(navigator.userAgent) || /android/i.test(navigator.userAgent);
const $7ffcc4d5a09f63bd$var$has_video = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("video").length > 0;
if ($7ffcc4d5a09f63bd$var$has_video) {
    if ($7ffcc4d5a09f63bd$var$is_mobile) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").prepend('<div class="video-background"></div>');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".video-background").addClass("mobile_bg");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("video").hide();
    } else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("video").show();
}
(0, $aXzbO.default).register("js-scroll-to", function($el, to) {
    $el.click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body,html").animate({
            scrollTop: (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(to).offset().top
        }, 1000);
    });
});

});

parcelRegister("b8FLW", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("ehieA"))
]).then(()=>parcelRequire('8xyG6'));

});

parcelRegister("bFKtv", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("fdpFS"))($parcel$resolve("6IfXN")),
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("hyuPl"))
]).then(()=>parcelRequire('6iDu3'));

});
parcelRegister("fdpFS", function(module, exports) {
"use strict";

var $2f5wq = parcelRequire("2f5wq");
module.exports = $2f5wq(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


parcelRegister("8FTRs", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("a67mA")).then(()=>parcelRequire('lpXQz'));

});

parcelRegister("g6BFq", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("9TeKT"))
]).then(()=>parcelRequire('7retx'));

});

parcelRegister("31VAC", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("iPwUs"))
]).then(()=>parcelRequire('4S7e2'));

});

parcelRegister("31xAa", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("ho15Y")).then(()=>parcelRequire('dYNWX'));

});

parcelRegister("irKeD", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("di1qI")).then(()=>parcelRequire('6rTkW'));

});

parcelRegister("2BpmZ", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("bSuIr"))
]).then(()=>parcelRequire('jNJEb'));

});

parcelRegister("bjjWr", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("jOKmh")),
    (parcelRequire("lErZQ"))($parcel$resolve("7muRG"))
]).then(()=>parcelRequire('gblvQ'));

});

parcelRegister("cvFmR", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("ehieA")),
    (parcelRequire("lErZQ"))($parcel$resolve("hwnFn"))
]).then(()=>parcelRequire('9JRe2'));

});

parcelRegister("8Mgw5", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("ffS5u")),
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("aGb3c"))
]).then(()=>parcelRequire('r6oIY'));

});

parcelRegister("eGPLs", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("atcRo")).then(()=>parcelRequire('9m662'));

});

parcelRegister("7S7xn", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("7JmD4")).then(()=>parcelRequire('hFv6f'));

});

parcelRegister("auIWN", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("bZ2sI")).then(()=>parcelRequire('77nV8'));

});

parcelRegister("arqRO", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("iPwUs")),
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("8Llv4"))
]).then(()=>parcelRequire('e4w3T'));

});

parcelRegister("bVENP", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("7GYCQ")).then(()=>parcelRequire('bSyu3'));

});

parcelRegister("fsMsp", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("bkxOo")).then(()=>parcelRequire('VTYTF'));

});

parcelRegister("kq28k", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("7hrr3")).then(()=>parcelRequire('5WhRG'));

});

parcelRegister("5jzUE", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("bmrA4")),
    (parcelRequire("lErZQ"))($parcel$resolve("403my"))
]).then(()=>parcelRequire('g35QR'));

});

parcelRegister("fTbrq", function(module, exports) {

var $iUSsr = parcelRequire("iUSsr");

var $aXzbO = parcelRequire("aXzbO");
(0, $aXzbO.default).register("js-scroll-to", function($el, to) {
    $el.click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body,html").animate({
            scrollTop: (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(to).offset().top
        }, 1000);
    });
});
class $b914de0f6b14a170$var$Slider {
    constructor(el){
        this.el = el;
        this.count = el.find("li").length;
        this.width = window.innerWidth;
        this.current = 0;
        this.parent = el.find("ul")[0];
    }
    setSlide(slide) {
        if (slide < 0) slide = this.count - 1;
        if (slide >= this.count) slide = 0;
        this.current = slide;
        this.parent.scrollTo({
            left: slide * this.width,
            behavior: "smooth"
        });
    }
}
(0, $aXzbO.default).register("js-slider", function($el, config) {
    const wait_t = 3000;
    const slide = new $b914de0f6b14a170$var$Slider($el);
    config = config || "interval";
    $el.data("slide", slide);
    if (config === "interval") setInterval(()=>{
        // console.log({ slide });
        let slide_new = slide.current + 1;
        if (slide_new >= slide.count) slide_new = 0;
        slide.setSlide(slide_new);
    }, wait_t);
    window.addEventListener("resize", ()=>{
        slide.width = window.innerWidth;
        slide.setSlide(0);
    });
});
// Slide is defined as "element_selector,slide_number"
(0, $aXzbO.default).register("js-goto-slide", function($el, slide) {
    $el.click(function() {
        const slide_split = slide.split(",");
        const target_slide_number = slide_split[1];
        const target_slide_obj = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(slide_split[0]);
        const slide_obj = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(target_slide_obj).data("slide");
        if (!slide_obj) {
            console.error("Slider not found");
            return;
        }
        if (target_slide_number === "prev") target_slide_number = slide_obj.current - 1;
        else if (target_slide_number === "next") target_slide_number = slide_obj.current + 1;
        else target_slide_number = parseInt(target_slide_number);
        slide_obj.setSlide(target_slide_number);
    });
});

});

parcelRegister("j8WGH", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("bmrA4")).then(()=>parcelRequire('aw8GQ'));

});

parcelRegister("8g9Fd", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("ehieA")),
    (parcelRequire("lErZQ"))($parcel$resolve("c5z83"))
]).then(()=>parcelRequire('h5yLn'));

});

parcelRegister("fMymV", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("6aWxk")).then(()=>parcelRequire('5pISd'));

});

parcelRegister("1AcZv", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("ffS5u")),
    (parcelRequire("lErZQ"))($parcel$resolve("iBLTg"))
]).then(()=>parcelRequire('k5cbL'));

});

parcelRegister("2UmYW", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("a68Wo")).then(()=>parcelRequire('8U23v'));

});

parcelRegister("ckrmH", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("lErZQ"))($parcel$resolve("9TeKT")),
    (parcelRequire("lErZQ"))($parcel$resolve("di1qI")),
    (parcelRequire("lErZQ"))($parcel$resolve("lOo8r"))
]).then(()=>parcelRequire('bgs3R'));

});

parcelRegister("8lzGS", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("e9NiB")).then(()=>parcelRequire('dhEwi'));

});

parcelRegister("gHB2G", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("9Eqrp")).then(()=>parcelRequire('ewPSq'));

});

parcelRegister("gGcX4", function(module, exports) {

module.exports = (parcelRequire("lErZQ"))($parcel$resolve("86gtL")).then(()=>parcelRequire('5WAWU'));

});



var $033d9d9673f853ad$exports = {};
$parcel$extendImportMap({
    "iS3ev": "ajax_tables.7953d308.js",
    "jOKmh": "jquery.tablesorter.b7d73a6f.js",
    "dFBut": "editable_tables.3a391d4c.js",
    "6K6wt": "form.dfb5539b.js",
    "bmrA4": "jquery.validate.dbd7fa2d.js",
    "ib2Dl": "formsjson.802ac829.js",
    "9BIyr": "tabs.ac4553cb.js",
    "ehieA": "3panels.ec47df0d.js",
    "di1qI": "gui.aef5abc2.js",
    "hyuPl": "cms.22205955.js",
    "6IfXN": "cms.5407c1e8.css",
    "a67mA": "cmsp.79e352eb.js",
    "9TeKT": "upload.aa59df61.js",
    "iPwUs": "users.f7994ce9.js",
    "ho15Y": "filtered_file_list.6485833d.js",
    "bSuIr": "add_message.66ca9bdf.js",
    "7muRG": "collaborator_filter_list.8a86382f.js",
    "hwnFn": "file_messages.18b753b0.js",
    "aGb3c": "metrics.b63716dc.js",
    "ffS5u": "metrics.ab641b43.js",
    "atcRo": "pain.78ddb6c7.js",
    "kwpXw": "slider.a1ac0f90.js",
    "7JmD4": "cinput.ce69013c.js",
    "bZ2sI": "userform_edit.c9db5297.js",
    "8Llv4": "userforms_reports.3c6fac66.js",
    "7GYCQ": "userforms.5efd1682.js",
    "bkxOo": "group_permissions.af7e5cd3.js",
    "7hrr3": "enduser_register.0b49cf68.js",
    "403my": "fastuser.a5fe5425.js",
    "c5z83": "messages.02fea80f.js",
    "6aWxk": "contracts.42ffe1af.js",
    "iBLTg": "graphs.6b791aa5.js",
    "lOo8r": "cmd.aaace6a8.js",
    "9Eqrp": "colabjoin.aa62c746.js",
    "86gtL": "useraddress.d7bc3ca1.js",
    "a68Wo": "log_report.f3e22ea1.js",
    "e9NiB": "pathology.452a3c75.js"
});

// Generated by scripts/write-build-revision.sh — do not commit.
const $a603656288d95de8$export$5ef54c535fe7aaeb = "a3e7d4e896914c4f4ff0f67e74fad1e6f6174701";



var $iUSsr = parcelRequire("iUSsr");

var $aXzbO = parcelRequire("aXzbO");

var $liSU2 = parcelRequire("liSU2");
parcelRequire("etgDw");

var $aXzbO = parcelRequire("aXzbO");

var $iUSsr = parcelRequire("iUSsr");
// Read a cookie
function $a3d5f1b0a98c4eb0$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
}
// Set a cookie
function $a3d5f1b0a98c4eb0$var$setCookie(name, value, days = 7) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 86400000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}
// Delete a cookie
function $a3d5f1b0a98c4eb0$var$deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}
function $a3d5f1b0a98c4eb0$var$is_public_area() {
    const path = window.location.pathname;
    if (path.startsWith("/en/")) return true;
    if (path.startsWith("/es/")) return true;
    if (path.startsWith("/fr/")) return true;
    if (path.startsWith("/pl/")) return true;
    if (path.startsWith("/cz/")) return true;
    // better just know which are public areas
    return false;
// if (path.startsWith("/file/")) {
//   return false;
// }
// if (path.startsWith("/form/")) {
//   return false;
// }
// if (path.startsWith("/users/")) {
//   return false;
// }
// if (path.startsWith("/report/")) {
//   return false;
// }
// if (path.startsWith("/join/")) {
//   return false;
// }
// if ($(".home").length > 0) {
//   return false;
// }
// return true;
}
function $a3d5f1b0a98c4eb0$var$cookielaw() {
    if (!$a3d5f1b0a98c4eb0$var$is_public_area()) return;
    const $cookielawBanner = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#CookielawBanner");
    const gdpr_cookies = $a3d5f1b0a98c4eb0$var$getCookie("gdpr_cookies");
    if (gdpr_cookies) $cookielawBanner.hide();
    else $cookielawBanner.show();
    if (gdpr_cookies === "all") $a3d5f1b0a98c4eb0$var$enable_analytics();
    (0, $aXzbO.default).register("js-click-accept-cookie", function($el, sel) {
        $el.click(function() {
            $a3d5f1b0a98c4eb0$var$setCookie("gdpr_cookies", sel, 365);
            $cookielawBanner.slideUp();
            if (sel === "all") $a3d5f1b0a98c4eb0$var$enable_analytics();
        });
    });
}
function $a3d5f1b0a98c4eb0$var$addScript(url) {
    const script = document.createElement("script");
    script.src = url;
    document.head.appendChild(script);
}
function $a3d5f1b0a98c4eb0$var$enable_analytics() {
    $a3d5f1b0a98c4eb0$var$addScript("https://www.googletagmanager.com/gtag/js?id=G-BTKBYQQ3XF");
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-BTKBYQQ3XF");
}
$a3d5f1b0a98c4eb0$var$cookielaw();
var $a3d5f1b0a98c4eb0$export$2e2bcd8739ae039 = $a3d5f1b0a98c4eb0$var$cookielaw;


parcelRequire("jSeXR");

var $1pryj = parcelRequire("1pryj");
parcelRequire("aZgYx");
parcelRequire("fTbrq");
parcelRequire("gkdRb");
parcelRequire("aPbgY");

var $dV0v3 = parcelRequire("dV0v3");

var $evyJi = parcelRequire("evyJi");
window.__CORONIS__VERSION = (0, $a603656288d95de8$export$5ef54c535fe7aaeb);
window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
window.onerror = function(desc, file, line, col, err) {
    var error = {
        description: desc,
        error: err && err.stack.split("\n"),
        navigator: navigator.appVersion,
        screen: {
            width: window.screen.width,
            height: window.screen.height,
            orientation: window.screen.orientation
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).post("/error/clientlog", {
        data: JSON.stringify(error)
    });
};
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("ajax require").each(function() {
    required = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).text().replace(/,/g, " ").split(/ +/).forEach(function(r) {
        // console.log("Require <%o>", r);
        (0, $liSU2.import_by_name)(r).then(function(a) {
            a && a.load && a.load();
        });
    });
});
(0, $aXzbO.default).register("js-hamburger", function($el, menu_sel) {
    $el.click(function() {
        $el.find(".open").toggle();
        $el.find(".close").toggle();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(menu_sel).toggle();
    });
});
(0, $aXzbO.default).register("js-toggle-slide", function($el, menu_sel) {
    $el.addClass("closed").removeClass("open"); // Start in closed state.
    $el.click(function() {
        $el.toggleClass("selected");
        $el.toggleClass("closed");
        $el.toggleClass("open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(menu_sel).slideToggle("slow");
    });
});
(0, $aXzbO.default).register("js-toggle", function($el, menu_sel) {
    $el.click(function() {
        $el.toggleClass("selected");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(menu_sel).toggle();
    });
});
(0, $aXzbO.default).register("js-click-on-click", function($el, sel) {
    $el.click(function() {
        // console.log("Click", $(sel));
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(sel).click();
    });
});
(0, $aXzbO.default).register("js-hide-on-click", function($el, sel) {
    $el.click(function() {
        // console.log("Click", $(sel));
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(sel).hide();
    });
});
(0, $aXzbO.default).register("js-show-on-click", function($el, sel) {
    $el.click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(sel).show();
    });
});
(0, $aXzbO.default).register("js-toggle-open", function($el, sel) {
    $el.click(function() {
        $el.toggleClass("selected");
        $el.toggleClass("closed");
        $el.toggleClass("open");
    });
});
(0, $aXzbO.default).register("js-font-size", function($el, sel) {
    $el.find("input").change(function() {
        var val = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).val();
        var $sel = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(sel);
        $sel.removeClass("s m l");
        $sel.addClass(val);
    });
});

(0, $aXzbO.default).register("js-css", function($el, sel) {
    Promise.resolve((parcelRequire("jSeXR"))).then(function(utils) {
        utils.requireCSS(sel);
    });
});
// Initialize datepicker defaults early so they're available for any datepicker() calls
// This ensures all datepickers start on Monday, even those created in inline scripts
// Try multiple sources for language detection
const $cbc8db462981157d$var$detectedLang = (0, $1pryj.default).LANG || typeof (0, $evyJi.default) !== "undefined" && (0, $evyJi.default).languageCode || null;
(0, $dV0v3.default)({
    lang: $cbc8db462981157d$var$detectedLang
});
(0, $aXzbO.default).register("js-datepicker", function($el, sel) {
    // $("body").append(
    //   $('<link href="' + STATIC_URL + '/css/jquery-ui.css" rel="stylesheet">')
    // );
    // Re-initialize to ensure defaults are set (in case jquery-ui loads after this)
    const detectedLang = (0, $1pryj.default).LANG || typeof (0, $evyJi.default) !== "undefined" && (0, $evyJi.default).languageCode || null;
    (0, $dV0v3.default)({
        lang: detectedLang
    });
    if (sel) $el.datepicker({
        defaultDate: sel
    });
    else $el.datepicker();
});
(0, $aXzbO.default).register("js-flash", ($el)=>{
    $el.find(".close").click(function() {
        $el.remove();
    });
    $el.delay(10000).fadeOut(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).remove();
    });
});
(0, $aXzbO.default).register("js-print", function($el) {
    $el.click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").addClass("print");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[href="#show_1000"]').click();
        setTimeout(window.print, 1000);
    });
});
(0, $aXzbO.default).register("js-print-now", function($el) {
    setTimeout(window.print, 1000);
});
(0, $aXzbO.default).register("js-reload", function($el, val) {
    if (val.endsWith("m")) val = Number(val.slice(0, val.length - 1)) * 60000;
    else val = Number(val) * 1000;
    console.log("Reload in %d ms", val);
    setTimeout(function() {
        window.location.pathname = window.location.pathname;
    }, val);
});
var $cbc8db462981157d$var$url = window.location.pathname; // Only relative
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("a").each(function() {
    var a = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
    if (a.attr("href") == $cbc8db462981157d$var$url) a.addClass("selected");
});
var $cbc8db462981157d$var$windowsize = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width();
function $cbc8db462981157d$var$checkHeader() {
    if ($cbc8db462981157d$var$windowsize >= 974) {
        //change header only in desktop version
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).scrollTop() > 150) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".header_ontop").hide();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".header_onscroll, .onscroll").show();
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".header_ontop").show();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".header_onscroll, .onscroll").hide();
        }
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".header_ontop").show();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".header_onscroll").hide();
    }
}
function $cbc8db462981157d$var$loadCss(css) {
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = css;
    document.head.appendChild(link);
}
$cbc8db462981157d$var$loadCss("/static/js/main.css");
$cbc8db462981157d$var$checkHeader();
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).scroll(function() {
    $cbc8db462981157d$var$checkHeader();
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).resize(function() {
    $cbc8db462981157d$var$windowsize = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width();
    $cbc8db462981157d$var$checkHeader();
});

})();
//# sourceMappingURL=main.js.map
